var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var toStr$9 = Object.prototype.toString;

var isArguments$3 = function isArguments(value) {
	var str = toStr$9.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr$9.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var implementation$b;
var hasRequiredImplementation;

function requireImplementation () {
	if (hasRequiredImplementation) return implementation$b;
	hasRequiredImplementation = 1;

	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = isArguments$3; // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};

		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];

			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}

			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}

			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}

			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	implementation$b = keysShim;
	return implementation$b;
}

var slice = Array.prototype.slice;
var isArgs = isArguments$3;

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : requireImplementation();

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

var objectKeys$2 = keysShim;

/** @type {import('.')} */
var esErrors = Error;

/** @type {import('./eval')} */
var _eval = EvalError;

/** @type {import('./range')} */
var range = RangeError;

/** @type {import('./ref')} */
var ref = ReferenceError;

/** @type {import('./syntax')} */
var syntax = SyntaxError;

/** @type {import('./type')} */
var type = TypeError;

/** @type {import('./uri')} */
var uri = URIError;

var shams$1;
var hasRequiredShams;

function requireShams () {
	if (hasRequiredShams) return shams$1;
	hasRequiredShams = 1;

	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	shams$1 = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }

		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }

		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }

		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }

		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}

		return true;
	};
	return shams$1;
}

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = requireShams();

var hasSymbols$5 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

var test = {
	__proto__: null,
	foo: {}
};

var $Object$1 = Object;

/** @type {import('.')} */
var hasProto$1 = function hasProto() {
	// @ts-expect-error: TS errors on an inherited property for some reason
	return { __proto__: test }.foo === test.foo
		&& !(test instanceof $Object$1);
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr$8 = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

var implementation$a = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$8.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var implementation$9 = implementation$a;

var functionBind = Function.prototype.bind || implementation$9;

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind$1 = functionBind;

/** @type {import('.')} */
var hasown = bind$1.call(call, $hasOwn);

var undefined$1;

var $Error = esErrors;
var $EvalError = _eval;
var $RangeError = range;
var $ReferenceError = ref;
var $SyntaxError$2 = syntax;
var $TypeError$6 = type;
var $URIError = uri;

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD$2 = Object.getOwnPropertyDescriptor;
if ($gOPD$2) {
	try {
		$gOPD$2({}, '');
	} catch (e) {
		$gOPD$2 = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$6();
};
var ThrowTypeError = $gOPD$2
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD$2(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$4 = hasSymbols$5();
var hasProto = hasProto$1();

var getProto$1 = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto$1 ? undefined$1 : getProto$1(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$4 && getProto$1 ? getProto$1([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined$1 : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined$1 : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$4 && getProto$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$4 || !getProto$1 ? undefined$1 : getProto$1(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$4 || !getProto$1 ? undefined$1 : getProto$1(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$4 && getProto$1 ? getProto$1(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols$4 ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError$2,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$6,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

if (getProto$1) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto$1(getProto$1(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto$1) {
			value = getProto$1(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = functionBind;
var hasOwn$2 = hasown;
var $concat$1 = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec$1 = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError$2('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError$2('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace$1(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$1(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn$2(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn$2(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$6('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError$2('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$6('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$6('"allowMissing" argument must be a boolean');
	}

	if ($exec$1(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError$2('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError$2('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn$2(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$6('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD$2 && (i + 1) >= parts.length) {
				var desc = $gOPD$2(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn$2(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var esDefineProperty;
var hasRequiredEsDefineProperty;

function requireEsDefineProperty () {
	if (hasRequiredEsDefineProperty) return esDefineProperty;
	hasRequiredEsDefineProperty = 1;

	var GetIntrinsic = getIntrinsic;

	/** @type {import('.')} */
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}

	esDefineProperty = $defineProperty;
	return esDefineProperty;
}

var GetIntrinsic$7 = getIntrinsic;

var $gOPD$1 = GetIntrinsic$7('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD$1) {
	try {
		$gOPD$1([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD$1 = null;
	}
}

var gopd$1 = $gOPD$1;

var $defineProperty$1 = requireEsDefineProperty();

var $SyntaxError$1 = syntax;
var $TypeError$5 = type;

var gopd = gopd$1;

/** @type {import('.')} */
var defineDataProperty$1 = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError$5('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError$5('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError$5('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError$5('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError$5('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError$5('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty$1) {
		$defineProperty$1(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError$1('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};

var $defineProperty = requireEsDefineProperty();

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

var hasPropertyDescriptors_1 = hasPropertyDescriptors;

var keys = objectKeys$2;
var hasSymbols$3 = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$7 = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = defineDataProperty$1;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr$7.call(fn) === '[object Function]';
};

var supportsDescriptors$2 = hasPropertyDescriptors_1();

var defineProperty$1 = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors$2) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties$1 = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols$3) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty$1(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties$1.supportsDescriptors = !!supportsDescriptors$2;

var defineProperties_1 = defineProperties$1;

var callBind$6 = {exports: {}};

var GetIntrinsic$6 = getIntrinsic;
var define$5 = defineDataProperty$1;
var hasDescriptors$1 = hasPropertyDescriptors_1();
var gOPD$4 = gopd$1;

var $TypeError$4 = type;
var $floor$1 = GetIntrinsic$6('%Math.floor%');

/** @type {import('.')} */
var setFunctionLength = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError$4('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor$1(length) !== length) {
		throw new $TypeError$4('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD$4) {
		var desc = gOPD$4(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors$1) {
			define$5(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define$5(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};

(function (module) {

	var bind = functionBind;
	var GetIntrinsic = getIntrinsic;
	var setFunctionLength$1 = setFunctionLength;

	var $TypeError = type;
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

	var $defineProperty = requireEsDefineProperty();
	var $max = GetIntrinsic('%Math.max%');

	module.exports = function callBind(originalFunction) {
		if (typeof originalFunction !== 'function') {
			throw new $TypeError('a function is required');
		}
		var func = $reflectApply(bind, $call, arguments);
		return setFunctionLength$1(
			func,
			1 + $max(0, originalFunction.length - (arguments.length - 1)),
			true
		);
	};

	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};

	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	} 
} (callBind$6));

var callBindExports = callBind$6.exports;

var GetIntrinsic$5 = getIntrinsic;

var callBind$5 = callBindExports;

var $indexOf$1 = callBind$5(GetIntrinsic$5('String.prototype.indexOf'));

var callBound$c = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic$5(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf$1(name, '.prototype.') > -1) {
		return callBind$5(intrinsic);
	}
	return intrinsic;
};

// modified from https://github.com/es-shims/es6-shim
var objectKeys$1 = objectKeys$2;
var hasSymbols$2 = requireShams()();
var callBound$b = callBound$c;
var toObject = Object;
var $push = callBound$b('Array.prototype.push');
var $propIsEnumerable = callBound$b('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols$2 ? Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
var implementation$8 = function assign(target, source1) {
	if (target == null) { throw new TypeError('target must be an object'); }
	var to = toObject(target); // step 1
	if (arguments.length === 1) {
		return to; // step 2
	}
	for (var s = 1; s < arguments.length; ++s) {
		var from = toObject(arguments[s]); // step 3.a.i

		// step 3.a.ii:
		var keys = objectKeys$1(from);
		var getSymbols = hasSymbols$2 && (Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			var syms = getSymbols(from);
			for (var j = 0; j < syms.length; ++j) {
				var key = syms[j];
				if ($propIsEnumerable(from, key)) {
					$push(keys, key);
				}
			}
		}

		// step 3.a.iii:
		for (var i = 0; i < keys.length; ++i) {
			var nextKey = keys[i];
			if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
				var propValue = from[nextKey]; // step 3.a.iii.2.a
				to[nextKey] = propValue; // step 3.a.iii.2.b
			}
		}
	}

	return to; // step 4
};

var implementation$7 = implementation$8;

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

var polyfill$4 = function getPolyfill() {
	if (!Object.assign) {
		return implementation$7;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation$7;
	}
	if (assignHasPendingExceptions()) {
		return implementation$7;
	}
	return Object.assign;
};

var define$4 = defineProperties_1;
var getPolyfill$5 = polyfill$4;

var shim$5 = function shimAssign() {
	var polyfill = getPolyfill$5();
	define$4(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};

var defineProperties = defineProperties_1;
var callBind$4 = callBindExports;

var implementation$6 = implementation$8;
var getPolyfill$4 = polyfill$4;
var shim$4 = shim$5;

var polyfill$3 = callBind$4.apply(getPolyfill$4());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
	return polyfill$3(Object, arguments);
};

defineProperties(bound, {
	getPolyfill: getPolyfill$4,
	implementation: implementation$6,
	shim: shim$4
});

var object_assign = bound;

var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD$3 = Object.getOwnPropertyDescriptor;
if (gOPD$3) {
	try {
		gOPD$3([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD$3 = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD$3) {
		return false;
	}
	var desc = gOPD$3(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

var functionsHaveNames_1 = functionsHaveNames;

var define$3 = defineDataProperty$1;
var hasDescriptors = hasPropertyDescriptors_1();
var functionsHaveConfigurableNames = functionsHaveNames_1.functionsHaveConfigurableNames();

var $TypeError$3 = type;

/** @type {import('.')} */
var setFunctionName$1 = function setFunctionName(fn, name) {
	if (typeof fn !== 'function') {
		throw new $TypeError$3('`fn` is not a function');
	}
	var loose = arguments.length > 2 && !!arguments[2];
	if (!loose || functionsHaveConfigurableNames) {
		if (hasDescriptors) {
			define$3(/** @type {Parameters<define>[0]} */ (fn), 'name', name, true, true);
		} else {
			define$3(/** @type {Parameters<define>[0]} */ (fn), 'name', name);
		}
	}
	return fn;
};

var setFunctionName = setFunctionName$1;
var $TypeError$2 = type;

var $Object = Object;

var implementation$5 = setFunctionName(function flags() {
	if (this == null || this !== $Object(this)) {
		throw new $TypeError$2('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.unicodeSets) {
		result += 'v';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
}, 'get flags', true);

var implementation$4 = implementation$5;

var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;

var polyfill$2 = function getPolyfill() {
	if (supportsDescriptors$1 && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation$4;
};

var supportsDescriptors = defineProperties_1.supportsDescriptors;
var getPolyfill$3 = polyfill$2;
var gOPD$2 = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

var shim$3 = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill$3();
	var proto = getProto(regex);
	var descriptor = gOPD$2(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};

var define$2 = defineProperties_1;
var callBind$3 = callBindExports;

var implementation$3 = implementation$5;
var getPolyfill$2 = polyfill$2;
var shim$2 = shim$3;

var flagsBound = callBind$3(getPolyfill$2());

define$2(flagsBound, {
	getPolyfill: getPolyfill$2,
	implementation: implementation$3,
	shim: shim$2
});

var regexp_prototype_flags = flagsBound;

var esGetIterator = {exports: {}};

var hasSymbols$1 = requireShams();

/** @type {import('.')} */
var shams = function hasToStringTagShams() {
	return hasSymbols$1() && !!Symbol.toStringTag;
};

var hasToStringTag$7 = shams();
var callBound$a = callBound$c;

var $toString$4 = callBound$a('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag$7 && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString$4(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString$4(value) !== '[object Array]' &&
		$toString$4(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

var isArguments$2 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	default: _nodeResolve_empty
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice$1 = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf$1 = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO$1 = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice$1.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require$$0;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol$2(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$1(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$1(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$1(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$1(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$1(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$2(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$1(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol$2(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray$2(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap$3(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet$3(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap$1(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet$1(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber$1(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt$1(obj)) {
        return markBoxed(inspect(bigIntValueOf$1.call(obj)));
    }
    if (isBoolean$1(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString$3(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (obj === commonjsGlobal) {
        return '{ [object globalThis] }';
    }
    if (!isDate$1(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO$1 ? gPO$1(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice$1.call(toStr$6(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray$2(obj) { return toStr$6(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate$1(obj) { return toStr$6(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr$6(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr$6(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString$3(obj) { return toStr$6(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber$1(obj) { return toStr$6(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean$1(obj) { return toStr$6(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol$2(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt$1(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf$1) {
        return false;
    }
    try {
        bigIntValueOf$1.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn$1 = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$1(obj, key) {
    return hasOwn$1.call(obj, key);
}

function toStr$6(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap$3(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap$1(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet$3(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet$1(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice$1.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$2(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$1(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$1(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

var GetIntrinsic$4 = getIntrinsic;
var callBound$9 = callBound$c;
var inspect = objectInspect;

var $TypeError$1 = type;
var $WeakMap$1 = GetIntrinsic$4('%WeakMap%', true);
var $Map$3 = GetIntrinsic$4('%Map%', true);

var $weakMapGet = callBound$9('WeakMap.prototype.get', true);
var $weakMapSet = callBound$9('WeakMap.prototype.set', true);
var $weakMapHas = callBound$9('WeakMap.prototype.has', true);
var $mapGet$1 = callBound$9('Map.prototype.get', true);
var $mapSet = callBound$9('Map.prototype.set', true);
var $mapHas$5 = callBound$9('Map.prototype.has', true);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('.').listGetNode} */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	for (; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			// eslint-disable-next-line no-extra-parens
			curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

/** @type {import('.').listGet} */
var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('.').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('.').ListNode<typeof value>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('.').listHas} */
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

/** @type {import('.')} */
var sideChannel = function getSideChannel() {
	/** @type {WeakMap<object, unknown>} */ var $wm;
	/** @type {Map<object, unknown>} */ var $m;
	/** @type {import('.').RootNode<unknown>} */ var $o;

	/** @type {import('.').Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError$1('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap$1 && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map$3) {
				if ($m) {
					return $mapGet$1($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap$1 && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map$3) {
				if ($m) {
					return $mapHas$5($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap$1 && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap$1();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map$3) {
				if (!$m) {
					$m = new $Map$3();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

var hasOwn = hasown;
var channel = sideChannel();

var $TypeError = type;

var SLOT$1 = {
	assert: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		channel.assert(O);
		if (!SLOT$1.has(O, slot)) {
			throw new $TypeError('`' + slot + '` is not present on `O`');
		}
	},
	get: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		return slots && slots['$' + slot];
	},
	has: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		return !!slots && hasOwn(slots, '$' + slot);
	},
	set: function (O, slot, V) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		if (!slots) {
			slots = {};
			channel.set(O, slots);
		}
		slots['$' + slot] = V;
	}
};

if (Object.freeze) {
	Object.freeze(SLOT$1);
}

var internalSlot = SLOT$1;

var SLOT = internalSlot;

var $SyntaxError = SyntaxError;
var $StopIteration = typeof StopIteration === 'object' ? StopIteration : null;

var stopIterationIterator = function getStopIterationIterator(origIterator) {
	if (!$StopIteration) {
		throw new $SyntaxError('this environment lacks StopIteration');
	}

	SLOT.set(origIterator, '[[Done]]', false);

	var siIterator = {
		next: function next() {
			var iterator = SLOT.get(this, '[[Iterator]]');
			var done = SLOT.get(iterator, '[[Done]]');
			try {
				return {
					done: done,
					value: done ? void undefined : iterator.next()
				};
			} catch (e) {
				SLOT.set(iterator, '[[Done]]', true);
				if (e !== $StopIteration) {
					throw e;
				}
				return {
					done: true,
					value: void undefined
				};
			}
		}
	};

	SLOT.set(siIterator, '[[Iterator]]', origIterator);

	return siIterator;
};

var toString = {}.toString;

var isarray = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$5 = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag$6 = shams();

var isString$2 = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag$6 ? tryStringObject(value) : toStr$5.call(value) === strClass;
};

/** @const */
var $Map$2 = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set$3 = typeof Set === 'function' && Set.prototype ? Set : null;

var exported$2;

if (!$Map$2) {
	/** @type {import('.')} */
	// eslint-disable-next-line no-unused-vars
	exported$2 = function isMap(x) {
		// `Map` is not present in this environment.
		return false;
	};
}

var $mapHas$4 = $Map$2 ? Map.prototype.has : null;
var $setHas$4 = $Set$3 ? Set.prototype.has : null;
if (!exported$2 && !$mapHas$4) {
	/** @type {import('.')} */
	// eslint-disable-next-line no-unused-vars
	exported$2 = function isMap(x) {
		// `Map` does not have a `has` method
		return false;
	};
}

/** @type {import('.')} */
var isMap$2 = exported$2 || function isMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas$4.call(x);
		if ($setHas$4) {
			try {
				$setHas$4.call(x);
			} catch (e) {
				return true;
			}
		}
		// @ts-expect-error TS can't figure out that $Map is always truthy here
		return x instanceof $Map$2; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};

var $Map$1 = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set$2 = typeof Set === 'function' && Set.prototype ? Set : null;

var exported$1;

if (!$Set$2) {
	/** @type {import('.')} */
	// eslint-disable-next-line no-unused-vars
	exported$1 = function isSet(x) {
		// `Set` is not present in this environment.
		return false;
	};
}

var $mapHas$3 = $Map$1 ? Map.prototype.has : null;
var $setHas$3 = $Set$2 ? Set.prototype.has : null;
if (!exported$1 && !$setHas$3) {
	/** @type {import('.')} */
	// eslint-disable-next-line no-unused-vars
	exported$1 = function isSet(x) {
		// `Set` does not have a `has` method
		return false;
	};
}

/** @type {import('.')} */
var isSet$2 = exported$1 || function isSet(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$setHas$3.call(x);
		if ($mapHas$3) {
			try {
				$mapHas$3.call(x);
			} catch (e) {
				return true;
			}
		}
		// @ts-expect-error TS can't figure out that $Set is always truthy here
		return x instanceof $Set$2; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};

/* eslint global-require: 0 */
// the code is structured this way so that bundlers can
// alias out `has-symbols` to `() => true` or `() => false` if your target
// environments' Symbol capabilities are known, and then use
// dead code elimination on the rest of this module.
//
// Similarly, `isarray` can be aliased to `Array.isArray` if
// available in all target environments.

var isArguments$1 = isArguments$2;
var getStopIterationIterator = stopIterationIterator;

if (hasSymbols$5() || requireShams()()) {
	var $iterator = Symbol.iterator;
	// Symbol is available natively or shammed
	// natively:
	//  - Chrome >= 38
	//  - Edge 12-14?, Edge >= 15 for sure
	//  - FF >= 36
	//  - Safari >= 9
	//  - node >= 0.12
	esGetIterator.exports = function getIterator(iterable) {
		// alternatively, `iterable[$iterator]?.()`
		if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
			return iterable[$iterator]();
		}
		if (isArguments$1(iterable)) {
			// arguments objects lack Symbol.iterator
			// - node 0.12
			return Array.prototype[$iterator].call(iterable);
		}
	};
} else {
	// Symbol is not available, native or shammed
	var isArray$1 = isarray;
	var isString$1 = isString$2;
	var GetIntrinsic$3 = getIntrinsic;
	var $Map = GetIntrinsic$3('%Map%', true);
	var $Set$1 = GetIntrinsic$3('%Set%', true);
	var callBound$8 = callBound$c;
	var $arrayPush = callBound$8('Array.prototype.push');
	var $charCodeAt = callBound$8('String.prototype.charCodeAt');
	var $stringSlice = callBound$8('String.prototype.slice');

	var advanceStringIndex = function advanceStringIndex(S, index) {
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}

		var first = $charCodeAt(S, index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}

		var second = $charCodeAt(S, index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}

		return index + 2;
	};

	var getArrayIterator = function getArrayIterator(arraylike) {
		var i = 0;
		return {
			next: function next() {
				var done = i >= arraylike.length;
				var value;
				if (!done) {
					value = arraylike[i];
					i += 1;
				}
				return {
					done: done,
					value: value
				};
			}
		};
	};

	var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
		if (isArray$1(iterable) || isArguments$1(iterable)) {
			return getArrayIterator(iterable);
		}
		if (isString$1(iterable)) {
			var i = 0;
			return {
				next: function next() {
					var nextIndex = advanceStringIndex(iterable, i);
					var value = $stringSlice(iterable, i, nextIndex);
					i = nextIndex;
					return {
						done: nextIndex > iterable.length,
						value: value
					};
				}
			};
		}

		// es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
		if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') {
			return iterable['_es6-shim iterator_']();
		}
	};

	if (!$Map && !$Set$1) {
		// the only language iterables are Array, String, arguments
		// - Safari <= 6.0
		// - Chrome < 38
		// - node < 0.12
		// - FF < 13
		// - IE < 11
		// - Edge < 11

		esGetIterator.exports = function getIterator(iterable) {
			if (iterable != null) {
				return getNonCollectionIterator(iterable, true);
			}
		};
	} else {
		// either Map or Set are available, but Symbol is not
		// - es6-shim on an ES5 browser
		// - Safari 6.2 (maybe 6.1?)
		// - FF v[13, 36)
		// - IE 11
		// - Edge 11
		// - Safari v[6, 9)

		var isMap$1 = isMap$2;
		var isSet$1 = isSet$2;

		// Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
		var $mapForEach = callBound$8('Map.prototype.forEach', true);
		var $setForEach = callBound$8('Set.prototype.forEach', true);
		if (typeof process === 'undefined' || !process.versions || !process.versions.node) { // "if is not node"

			// Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
			// returns a value, or throws a StopIteration object. These browsers
			// do not have any other mechanism for iteration.
			var $mapIterator = callBound$8('Map.prototype.iterator', true);
			var $setIterator = callBound$8('Set.prototype.iterator', true);
		}
		// Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
		// this returns a proper iterator object, so we should use it instead of forEach.
		// newer es6-shim versions use a string "_es6-shim iterator_" property.
		var $mapAtAtIterator = callBound$8('Map.prototype.@@iterator', true) || callBound$8('Map.prototype._es6-shim iterator_', true);
		var $setAtAtIterator = callBound$8('Set.prototype.@@iterator', true) || callBound$8('Set.prototype._es6-shim iterator_', true);

		var getCollectionIterator = function getCollectionIterator(iterable) {
			if (isMap$1(iterable)) {
				if ($mapIterator) {
					return getStopIterationIterator($mapIterator(iterable));
				}
				if ($mapAtAtIterator) {
					return $mapAtAtIterator(iterable);
				}
				if ($mapForEach) {
					var entries = [];
					$mapForEach(iterable, function (v, k) {
						$arrayPush(entries, [k, v]);
					});
					return getArrayIterator(entries);
				}
			}
			if (isSet$1(iterable)) {
				if ($setIterator) {
					return getStopIterationIterator($setIterator(iterable));
				}
				if ($setAtAtIterator) {
					return $setAtAtIterator(iterable);
				}
				if ($setForEach) {
					var values = [];
					$setForEach(iterable, function (v) {
						$arrayPush(values, v);
					});
					return getArrayIterator(values);
				}
			}
		};

		esGetIterator.exports = function getIterator(iterable) {
			return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
		};
	}
}

var esGetIteratorExports = esGetIterator.exports;

var numberIsNaN = function (value) {
	return value !== value;
};

var implementation$2 = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};

var implementation$1 = implementation$2;

var polyfill$1 = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation$1;
};

var getPolyfill$1 = polyfill$1;
var define$1 = defineProperties_1;

var shim$1 = function shimObjectIs() {
	var polyfill = getPolyfill$1();
	define$1(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};

var define = defineProperties_1;
var callBind$2 = callBindExports;

var implementation = implementation$2;
var getPolyfill = polyfill$1;
var shim = shim$1;

var polyfill = callBind$2(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

var objectIs = polyfill;

var callBind$1 = callBindExports;
var callBound$7 = callBound$c;
var GetIntrinsic$2 = getIntrinsic;

var $ArrayBuffer = GetIntrinsic$2('%ArrayBuffer%', true);
/** @type {undefined | ((receiver: ArrayBuffer) => number) | ((receiver: unknown) => never)} */
var $byteLength$2 = callBound$7('ArrayBuffer.prototype.byteLength', true);
var $toString$3 = callBound$7('Object.prototype.toString');

// in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
var abSlice = !!$ArrayBuffer && !$byteLength$2 && new $ArrayBuffer(0).slice;
var $abSlice = !!abSlice && callBind$1(abSlice);

/** @type {import('.')} */
var isArrayBuffer$2 = $byteLength$2 || $abSlice
	? function isArrayBuffer(obj) {
		if (!obj || typeof obj !== 'object') {
			return false;
		}
		try {
			if ($byteLength$2) {
				// @ts-expect-error no idea why TS can't handle the overload
				$byteLength$2(obj);
			} else {
				// @ts-expect-error TS chooses not to type-narrow inside a closure
				$abSlice(obj, 0);
			}
			return true;
		} catch (e) {
			return false;
		}
	}
	: $ArrayBuffer
		// in node 0.8, ArrayBuffers have no prototype or own methods, but also no Symbol.toStringTag
		? function isArrayBuffer(obj) {
			return $toString$3(obj) === '[object ArrayBuffer]';
		}
		: function isArrayBuffer(obj) { // eslint-disable-line no-unused-vars
			return false;
		};

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr$4 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$5 = shams();

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag$5 ? tryDateObject(value) : toStr$4.call(value) === dateClass;
};

var callBound$6 = callBound$c;
var hasToStringTag$4 = shams();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$4) {
	has = callBound$6('Object.prototype.hasOwnProperty');
	$exec = callBound$6('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString$2 = callBound$6('Object.prototype.toString');
var gOPD$1 = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

var isRegex$1 = hasToStringTag$4
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD$1(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString$2(value) === regexClass;
	};

var callBound$5 = callBound$c;

var $byteLength$1 = callBound$5('SharedArrayBuffer.prototype.byteLength', true);

/** @type {import('.')} */
var isSharedArrayBuffer$1 = $byteLength$1
	? function isSharedArrayBuffer(obj) {
		if (!obj || typeof obj !== 'object') {
			return false;
		}
		try {
			$byteLength$1(obj);
			return true;
		} catch (e) {
			return false;
		}
	}
	: function isSharedArrayBuffer(obj) { // eslint-disable-line no-unused-vars
		return false;
	};

var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject(value) {
	try {
		numToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$3 = Object.prototype.toString;
var numClass = '[object Number]';
var hasToStringTag$3 = shams();

var isNumberObject = function isNumberObject(value) {
	if (typeof value === 'number') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag$3 ? tryNumberObject(value) : toStr$3.call(value) === numClass;
};

var callBound$4 = callBound$c;
var $boolToStr = callBound$4('Boolean.prototype.toString');
var $toString$1 = callBound$4('Object.prototype.toString');

var tryBooleanObject = function booleanBrandCheck(value) {
	try {
		$boolToStr(value);
		return true;
	} catch (e) {
		return false;
	}
};
var boolClass = '[object Boolean]';
var hasToStringTag$2 = shams();

var isBooleanObject = function isBoolean(value) {
	if (typeof value === 'boolean') {
		return true;
	}
	if (value === null || typeof value !== 'object') {
		return false;
	}
	return hasToStringTag$2 && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString$1(value) === boolClass;
};

var isSymbol$1 = {exports: {}};

var toStr$2 = Object.prototype.toString;
var hasSymbols = hasSymbols$5();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	isSymbol$1.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr$2.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	isSymbol$1.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false;
	};
}

var isSymbolExports = isSymbol$1.exports;

var isBigint = {exports: {}};

var $BigInt = typeof BigInt !== 'undefined' && BigInt;

var hasBigints = function hasNativeBigInts() {
	return typeof $BigInt === 'function'
		&& typeof BigInt === 'function'
		&& typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
		&& typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};

var hasBigInts = hasBigints();

if (hasBigInts) {
	var bigIntValueOf = BigInt.prototype.valueOf;
	var tryBigInt = function tryBigIntObject(value) {
		try {
			bigIntValueOf.call(value);
			return true;
		} catch (e) {
		}
		return false;
	};

	isBigint.exports = function isBigInt(value) {
		if (
			value === null
			|| typeof value === 'undefined'
			|| typeof value === 'boolean'
			|| typeof value === 'string'
			|| typeof value === 'number'
			|| typeof value === 'symbol'
			|| typeof value === 'function'
		) {
			return false;
		}
		if (typeof value === 'bigint') {
			return true;
		}

		return tryBigInt(value);
	};
} else {
	isBigint.exports = function isBigInt(value) {
		return false;
	};
}

var isBigintExports = isBigint.exports;

var isString = isString$2;
var isNumber = isNumberObject;
var isBoolean = isBooleanObject;
var isSymbol = isSymbolExports;
var isBigInt = isBigintExports;

// eslint-disable-next-line consistent-return
var whichBoxedPrimitive$1 = function whichBoxedPrimitive(value) {
	// eslint-disable-next-line eqeqeq
	if (value == null || (typeof value !== 'object' && typeof value !== 'function')) {
		return null;
	}
	if (isString(value)) {
		return 'String';
	}
	if (isNumber(value)) {
		return 'Number';
	}
	if (isBoolean(value)) {
		return 'Boolean';
	}
	if (isSymbol(value)) {
		return 'Symbol';
	}
	if (isBigInt(value)) {
		return 'BigInt';
	}
};

var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
var $WeakSet$1 = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;

var exported;

if (!$WeakMap) {
	/** @type {import('.')} */
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakMap(x) {
		// `WeakMap` is not present in this environment.
		return false;
	};
}

var $mapHas$2 = $WeakMap ? $WeakMap.prototype.has : null;
var $setHas$2 = $WeakSet$1 ? $WeakSet$1.prototype.has : null;
if (!exported && !$mapHas$2) {
	/** @type {import('.')} */
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakMap(x) {
		// `WeakMap` does not have a `has` method
		return false;
	};
}

/** @type {import('.')} */
var isWeakmap = exported || function isWeakMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas$2.call(x, $mapHas$2);
		if ($setHas$2) {
			try {
				$setHas$2.call(x, $setHas$2);
			} catch (e) {
				return true;
			}
		}
		// @ts-expect-error TS can't figure out that $WeakMap is always truthy here
		return x instanceof $WeakMap; // core-js workaround, pre-v3
	} catch (e) {}
	return false;
};

var isWeakset = {exports: {}};

var GetIntrinsic$1 = getIntrinsic;
var callBound$3 = callBound$c;

var $WeakSet = GetIntrinsic$1('%WeakSet%', true);

var $setHas$1 = callBound$3('WeakSet.prototype.has', true);

if ($setHas$1) {
	var $mapHas$1 = callBound$3('WeakMap.prototype.has', true);

	/** @type {import('.')} */
	isWeakset.exports = function isWeakSet(x) {
		if (!x || typeof x !== 'object') {
			return false;
		}
		try {
			$setHas$1(x, $setHas$1);
			if ($mapHas$1) {
				try {
					$mapHas$1(x, $mapHas$1);
				} catch (e) {
					return true;
				}
			}
			// @ts-expect-error TS can't figure out that $WeakSet is always truthy here
			return x instanceof $WeakSet; // core-js workaround, pre-v3
		} catch (e) {}
		return false;
	};
} else {
	/** @type {import('.')} */
	// eslint-disable-next-line no-unused-vars
	isWeakset.exports = function isWeakSet(x) {
		// `WeakSet` does not exist, or does not have a `has` method
		return false;
	};
}

var isWeaksetExports = isWeakset.exports;

var isMap = isMap$2;
var isSet = isSet$2;
var isWeakMap = isWeakmap;
var isWeakSet = isWeaksetExports;

/** @type {import('.')} */
var whichCollection$1 = function whichCollection(/** @type {unknown} */ value) {
	if (value && typeof value === 'object') {
		if (isMap(value)) {
			return 'Map';
		}
		if (isSet(value)) {
			return 'Set';
		}
		if (isWeakMap(value)) {
			return 'WeakMap';
		}
		if (isWeakSet(value)) {
			return 'WeakSet';
		}
	}
	return false;
};

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$1 = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag$1 = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr$1.call(all) === toStr$1.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr$1.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

var isCallable$1 = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag$1) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr$1.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};

var isCallable = isCallable$1;

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach$1 = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

var forEach_1 = forEach$1;

/** @type {import('.')} */
var possibleTypedArrayNames = [
	'Float32Array',
	'Float64Array',
	'Int8Array',
	'Int16Array',
	'Int32Array',
	'Uint8Array',
	'Uint8ClampedArray',
	'Uint16Array',
	'Uint32Array',
	'BigInt64Array',
	'BigUint64Array'
];

var possibleNames = possibleTypedArrayNames;

var g$1 = typeof globalThis === 'undefined' ? commonjsGlobal : globalThis;

/** @type {import('.')} */
var availableTypedArrays$1 = function availableTypedArrays() {
	var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g$1[possibleNames[i]] === 'function') {
			// @ts-expect-error
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};

var forEach = forEach_1;
var availableTypedArrays = availableTypedArrays$1;
var callBind = callBindExports;
var callBound$2 = callBound$c;
var gOPD = gopd$1;

/** @type {(O: object) => string} */
var $toString = callBound$2('Object.prototype.toString');
var hasToStringTag = shams();

var g = typeof globalThis === 'undefined' ? commonjsGlobal : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound$2('String.prototype.slice');
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');

/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */
var $indexOf = callBound$2('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};

/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */
/** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */
var cache = { __proto__: null };
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			// @ts-expect-error TS won't narrow inside a closure
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				// @ts-expect-error TS won't narrow inside a closure
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			// @ts-expect-error TODO: fix
			cache['$' + typedArray] = callBind(descriptor.get);
		}
	});
} else {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		var fn = arr.slice || arr.set;
		if (fn) {
			// @ts-expect-error TODO: fix
			cache['$' + typedArray] = callBind(fn);
		}
	});
}

/** @type {(value: object) => false | import('.').TypedArrayName} */
var tryTypedArrays = function tryAllTypedArrays(value) {
	/** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
	forEach(
		// eslint-disable-next-line no-extra-parens
		/** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ (cache),
		/** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
		function (getter, typedArray) {
			if (!found) {
				try {
				// @ts-expect-error TODO: fix
					if ('$' + getter(value) === typedArray) {
						found = $slice(typedArray, 1);
					}
				} catch (e) { /**/ }
			}
		}
	);
	return found;
};

/** @type {(value: object) => false | import('.').TypedArrayName} */
var trySlices = function tryAllSlices(value) {
	/** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
	forEach(
		// eslint-disable-next-line no-extra-parens
		/** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ (cache),
		/** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function (getter, name) {
			if (!found) {
				try {
					// @ts-expect-error TODO: fix
					getter(value);
					found = $slice(name, 1);
				} catch (e) { /**/ }
			}
		}
	);
	return found;
};

/** @type {import('.')} */
var whichTypedArray$1 = function whichTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag) {
		/** @type {string} */
		var tag = $slice($toString(value), 8, -1);
		if ($indexOf(typedArrays, tag) > -1) {
			return tag;
		}
		if (tag !== 'Object') {
			return false;
		}
		// node < 0.6 hits here on real Typed Arrays
		return trySlices(value);
	}
	if (!gOPD) { return null; } // unknown engine
	return tryTypedArrays(value);
};

var callBound$1 = callBound$c;
var $byteLength = callBound$1('ArrayBuffer.prototype.byteLength', true);

var isArrayBuffer$1 = isArrayBuffer$2;

/** @type {import('.')} */
var arrayBufferByteLength = function byteLength(ab) {
	if (!isArrayBuffer$1(ab)) {
		return NaN;
	}
	return $byteLength ? $byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property

var assign = object_assign;
var callBound = callBound$c;
var flags = regexp_prototype_flags;
var GetIntrinsic = getIntrinsic;
var getIterator = esGetIteratorExports;
var getSideChannel = sideChannel;
var is = objectIs;
var isArguments = isArguments$2;
var isArray = isarray;
var isArrayBuffer = isArrayBuffer$2;
var isDate = isDateObject;
var isRegex = isRegex$1;
var isSharedArrayBuffer = isSharedArrayBuffer$1;
var objectKeys = objectKeys$2;
var whichBoxedPrimitive = whichBoxedPrimitive$1;
var whichCollection = whichCollection$1;
var whichTypedArray = whichTypedArray$1;
var byteLength = arrayBufferByteLength;

var sabByteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);

var $getTime = callBound('Date.prototype.getTime');
var gPO = Object.getPrototypeOf;
var $objToString = callBound('Object.prototype.toString');

var $Set = GetIntrinsic('%Set%', true);
var $mapHas = callBound('Map.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSize = callBound('Map.prototype.size', true);
var $setAdd = callBound('Set.prototype.add', true);
var $setDelete = callBound('Set.prototype.delete', true);
var $setHas = callBound('Set.prototype.has', true);
var $setSize = callBound('Set.prototype.size', true);

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function setHasEqualElement(set, val1, opts, channel) {
  var i = getIterator(set);
  var result;
  while ((result = i.next()) && !result.done) {
    if (internalDeepEqual(val1, result.value, opts, channel)) { // eslint-disable-line no-use-before-define
      // Remove the matching element to make sure we do not check that again.
      $setDelete(set, result.value);
      return true;
    }
  }

  return false;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function findLooseMatchingPrimitives(prim) {
  if (typeof prim === 'undefined') {
    return null;
  }
  if (typeof prim === 'object') { // Only pass in null as object!
    return void 0;
  }
  if (typeof prim === 'symbol') {
    return false;
  }
  if (typeof prim === 'string' || typeof prim === 'number') {
    // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
  }
  return true;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  var curB = $mapGet(b, altValue);
  var looseOpts = assign({}, opts, { strict: false });
  if (
    (typeof curB === 'undefined' && !$mapHas(b, altValue))
    // eslint-disable-next-line no-use-before-define
    || !internalDeepEqual(item, curB, looseOpts, channel)
  ) {
    return false;
  }
  // eslint-disable-next-line no-use-before-define
  return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function setMightHaveLoosePrim(a, b, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }

  return $setHas(b, altValue) && !$setHas(a, altValue);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
  var i = getIterator(set);
  var result;
  var key2;
  while ((result = i.next()) && !result.done) {
    key2 = result.value;
    if (
      // eslint-disable-next-line no-use-before-define
      internalDeepEqual(key1, key2, opts, channel)
      // eslint-disable-next-line no-use-before-define
      && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)
    ) {
      $setDelete(set, key2);
      return true;
    }
  }

  return false;
}

function internalDeepEqual(actual, expected, options, channel) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  var actualBoxed = whichBoxedPrimitive(actual);
  var expectedBoxed = whichBoxedPrimitive(expected);
  if (actualBoxed !== expectedBoxed) {
    return false;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration

  var hasActual = channel.has(actual);
  var hasExpected = channel.has(expected);
  var sentinel;
  if (hasActual && hasExpected) {
    if (channel.get(actual) === channel.get(expected)) {
      return true;
    }
  } else {
    sentinel = {};
  }
  if (!hasActual) { channel.set(actual, sentinel); }
  if (!hasExpected) { channel.set(expected, sentinel); }

  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts, channel);
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }

  return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}

function setEquiv(a, b, opts, channel) {
  if ($setSize(a) !== $setSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  while ((resultA = iA.next()) && !resultA.done) {
    if (resultA.value && typeof resultA.value === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    } else if (!$setHas(b, resultA.value)) {
      if (opts.strict) { return false; }
      if (!setMightHaveLoosePrim(a, b, resultA.value)) {
        return false;
      }
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    }
  }
  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
      if (resultB.value && typeof resultB.value === 'object') {
        if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && !$setHas(a, resultB.value)
        && !setHasEqualElement(set, resultB.value, opts.strict, channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function mapEquiv(a, b, opts, channel) {
  if ($mapSize(a) !== $mapSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  var key;
  var item1;
  var item2;
  while ((resultA = iA.next()) && !resultA.done) {
    key = resultA.value[0];
    item1 = resultA.value[1];
    if (key && typeof key === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, key);
    } else {
      item2 = $mapGet(b, key);
      if ((typeof item2 === 'undefined' && !$mapHas(b, key)) || !internalDeepEqual(item1, item2, opts, channel)) {
        if (opts.strict) {
          return false;
        }
        if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) {
          return false;
        }
        if (!set) { set = new $Set(); }
        $setAdd(set, key);
      }
    }
  }

  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      key = resultB.value[0];
      item2 = resultB.value[1];
      if (key && typeof key === 'object') {
        if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel))
        && !mapHasEqualEntry(set, a, key, item2, assign({}, opts, { strict: false }), channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function objEquiv(a, b, opts, channel) {
  /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5], max-lines: [2, 400] */
  var i, key;

  if (typeof a !== typeof b) { return false; }
  if (a == null || b == null) { return false; }

  if ($objToString(a) !== $objToString(b)) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsArray = isArray(a);
  var bIsArray = isArray(b);
  if (aIsArray !== bIsArray) { return false; }

  // TODO: replace when a cross-realm brand check is available
  var aIsError = a instanceof Error;
  var bIsError = b instanceof Error;
  if (aIsError !== bIsError) { return false; }
  if (aIsError || bIsError) {
    if (a.name !== b.name || a.message !== b.message) { return false; }
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) {
    return false;
  }

  var aIsDate = isDate(a);
  var bIsDate = isDate(b);
  if (aIsDate !== bIsDate) { return false; }
  if (aIsDate || bIsDate) { // && would work too, because both are true or both false here
    if ($getTime(a) !== $getTime(b)) { return false; }
  }
  if (opts.strict && gPO && gPO(a) !== gPO(b)) { return false; }

  var aWhich = whichTypedArray(a);
  var bWhich = whichTypedArray(b);
  if (aWhich !== bWhich) {
    return false;
  }
  if (aWhich || bWhich) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  var aIsArrayBuffer = isArrayBuffer(a);
  var bIsArrayBuffer = isArrayBuffer(b);
  if (aIsArrayBuffer !== bIsArrayBuffer) { return false; }
  if (aIsArrayBuffer || bIsArrayBuffer) { // && would work too, because both are true or both false here
    if (byteLength(a) !== byteLength(b)) { return false; }
    return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
  }

  var aIsSAB = isSharedArrayBuffer(a);
  var bIsSAB = isSharedArrayBuffer(b);
  if (aIsSAB !== bIsSAB) { return false; }
  if (aIsSAB || bIsSAB) { // && would work too, because both are true or both false here
    if (sabByteLength(a) !== sabByteLength(b)) { return false; }
    return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
  }

  if (typeof a !== typeof b) { return false; }

  var ka = objectKeys(a);
  var kb = objectKeys(b);
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; } // eslint-disable-line eqeqeq
  }

  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!internalDeepEqual(a[key], b[key], opts, channel)) { return false; }
  }

  var aCollection = whichCollection(a);
  var bCollection = whichCollection(b);
  if (aCollection !== bCollection) {
    return false;
  }
  if (aCollection === 'Set' || bCollection === 'Set') { // aCollection === bCollection
    return setEquiv(a, b, opts, channel);
  }
  if (aCollection === 'Map') { // aCollection === bCollection
    return mapEquiv(a, b, opts, channel);
  }

  return true;
}

var deepEqual = function deepEqual(a, b, opts) {
  return internalDeepEqual(a, b, opts, getSideChannel());
};

var deepEqual$1 = /*@__PURE__*/getDefaultExportFromCjs(deepEqual);

let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let nanoid = (size = 21) => {
  let id = '';
  let i = size;
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0];
  }
  return id
};

const isValidNonEmptyObject = (obj) => {
    return typeof obj === "object" && !Array.isArray(obj) && Object.keys(obj).length !== 0;
};
const AsyncListener = (actualUnsub) => {
    return {
        unsubscribe() {
            if (!actualUnsub) {
                console.error("Failed to unsubscribe!");
                return;
            }
            if (typeof actualUnsub === "function") {
                actualUnsub();
            }
            else {
                actualUnsub.then((unsubFunc) => unsubFunc()).catch(console.error);
            }
        }
    };
};
const promisePlus = (promise, timeoutMilliseconds, timeoutMessage) => {
    return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
            const message = timeoutMessage || `Promise timeout hit: ${timeoutMilliseconds}`;
            reject(message);
        }, timeoutMilliseconds);
        promise()
            .then((result) => {
            clearTimeout(timeout);
            resolve(result);
        })
            .catch((error) => {
            clearTimeout(timeout);
            reject(error);
        });
    });
};
const generateCommandId = () => {
    return nanoid();
};

const connectBrowserAppProps = ["name", "title", "version", "customProperties", "icon", "caption", "type"];
const fdc3v2AppProps = ["appId", "name", "type", "details", "version", "title", "tooltip", "lang", "description", "categories", "icons", "screenshots", "contactEmail", "moreInfo", "publisher", "customConfig", "hostManifests", "interop", "localizedVersions"];

/**
 * Wraps values in an `Ok` type.
 *
 * Example: `ok(5) // => {ok: true, result: 5}`
 */
var ok$1 = function (result) { return ({ ok: true, result: result }); };
/**
 * Wraps errors in an `Err` type.
 *
 * Example: `err('on fire') // => {ok: false, error: 'on fire'}`
 */
var err$1 = function (error) { return ({ ok: false, error: error }); };
/**
 * Create a `Promise` that either resolves with the result of `Ok` or rejects
 * with the error of `Err`.
 */
var asPromise$1 = function (r) {
    return r.ok === true ? Promise.resolve(r.result) : Promise.reject(r.error);
};
/**
 * Unwraps a `Result` and returns either the result of an `Ok`, or
 * `defaultValue`.
 *
 * Example:
 * ```
 * Result.withDefault(5, number().run(json))
 * ```
 *
 * It would be nice if `Decoder` had an instance method that mirrored this
 * function. Such a method would look something like this:
 * ```
 * class Decoder<A> {
 *   runWithDefault = (defaultValue: A, json: any): A =>
 *     Result.withDefault(defaultValue, this.run(json));
 * }
 *
 * number().runWithDefault(5, json)
 * ```
 * Unfortunately, the type of `defaultValue: A` on the method causes issues
 * with type inference on  the `object` decoder in some situations. While these
 * inference issues can be solved by providing the optional type argument for
 * `object`s, the extra trouble and confusion doesn't seem worth it.
 */
var withDefault$1 = function (defaultValue, r) {
    return r.ok === true ? r.result : defaultValue;
};
/**
 * Return the successful result, or throw an error.
 */
var withException$1 = function (r) {
    if (r.ok === true) {
        return r.result;
    }
    else {
        throw r.error;
    }
};
/**
 * Apply `f` to the result of an `Ok`, or pass the error through.
 */
var map$1 = function (f, r) {
    return r.ok === true ? ok$1(f(r.result)) : r;
};
/**
 * Apply `f` to the result of two `Ok`s, or pass an error through. If both
 * `Result`s are errors then the first one is returned.
 */
var map2$1 = function (f, ar, br) {
    return ar.ok === false ? ar :
        br.ok === false ? br :
            ok$1(f(ar.result, br.result));
};
/**
 * Apply `f` to the error of an `Err`, or pass the success through.
 */
var mapError$1 = function (f, r) {
    return r.ok === true ? r : err$1(f(r.error));
};
/**
 * Chain together a sequence of computations that may fail, similar to a
 * `Promise`. If the first computation fails then the error will propagate
 * through. If it succeeds, then `f` will be applied to the value, returning a
 * new `Result`.
 */
var andThen$1 = function (f, r) {
    return r.ok === true ? f(r.result) : r;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */



var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function isEqual$1(a, b) {
    if (a === b) {
        return true;
    }
    if (a === null && b === null) {
        return true;
    }
    if (typeof (a) !== typeof (b)) {
        return false;
    }
    if (typeof (a) === 'object') {
        // Array
        if (Array.isArray(a)) {
            if (!Array.isArray(b)) {
                return false;
            }
            if (a.length !== b.length) {
                return false;
            }
            for (var i = 0; i < a.length; i++) {
                if (!isEqual$1(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        // Hash table
        var keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length) {
            return false;
        }
        for (var i = 0; i < keys.length; i++) {
            if (!b.hasOwnProperty(keys[i])) {
                return false;
            }
            if (!isEqual$1(a[keys[i]], b[keys[i]])) {
                return false;
            }
        }
        return true;
    }
}
/*
 * Helpers
 */
var isJsonArray$1 = function (json) { return Array.isArray(json); };
var isJsonObject$1 = function (json) {
    return typeof json === 'object' && json !== null && !isJsonArray$1(json);
};
var typeString$1 = function (json) {
    switch (typeof json) {
        case 'string':
            return 'a string';
        case 'number':
            return 'a number';
        case 'boolean':
            return 'a boolean';
        case 'undefined':
            return 'undefined';
        case 'object':
            if (json instanceof Array) {
                return 'an array';
            }
            else if (json === null) {
                return 'null';
            }
            else {
                return 'an object';
            }
        default:
            return JSON.stringify(json);
    }
};
var expectedGot$1 = function (expected, got) {
    return "expected " + expected + ", got " + typeString$1(got);
};
var printPath$1 = function (paths) {
    return paths.map(function (path) { return (typeof path === 'string' ? "." + path : "[" + path + "]"); }).join('');
};
var prependAt$1 = function (newAt, _a) {
    var at = _a.at, rest = __rest$1(_a, ["at"]);
    return (__assign$1({ at: newAt + (at || '') }, rest));
};
/**
 * Decoders transform json objects with unknown structure into known and
 * verified forms. You can create objects of type `Decoder<A>` with either the
 * primitive decoder functions, such as `boolean()` and `string()`, or by
 * applying higher-order decoders to the primitives, such as `array(boolean())`
 * or `dict(string())`.
 *
 * Each of the decoder functions are available both as a static method on
 * `Decoder` and as a function alias -- for example the string decoder is
 * defined at `Decoder.string()`, but is also aliased to `string()`. Using the
 * function aliases exported with the library is recommended.
 *
 * `Decoder` exposes a number of 'run' methods, which all decode json in the
 * same way, but communicate success and failure in different ways. The `map`
 * and `andThen` methods modify decoders without having to call a 'run' method.
 *
 * Alternatively, the main decoder `run()` method returns an object of type
 * `Result<A, DecoderError>`. This library provides a number of helper
 * functions for dealing with the `Result` type, so you can do all the same
 * things with a `Result` as with the decoder methods.
 */
var Decoder$1 = /** @class */ (function () {
    /**
     * The Decoder class constructor is kept private to separate the internal
     * `decode` function from the external `run` function. The distinction
     * between the two functions is that `decode` returns a
     * `Partial<DecoderError>` on failure, which contains an unfinished error
     * report. When `run` is called on a decoder, the relevant series of `decode`
     * calls is made, and then on failure the resulting `Partial<DecoderError>`
     * is turned into a `DecoderError` by filling in the missing information.
     *
     * While hiding the constructor may seem restrictive, leveraging the
     * provided decoder combinators and helper functions such as
     * `andThen` and `map` should be enough to build specialized decoders as
     * needed.
     */
    function Decoder(decode) {
        var _this = this;
        this.decode = decode;
        /**
         * Run the decoder and return a `Result` with either the decoded value or a
         * `DecoderError` containing the json input, the location of the error, and
         * the error message.
         *
         * Examples:
         * ```
         * number().run(12)
         * // => {ok: true, result: 12}
         *
         * string().run(9001)
         * // =>
         * // {
         * //   ok: false,
         * //   error: {
         * //     kind: 'DecoderError',
         * //     input: 9001,
         * //     at: 'input',
         * //     message: 'expected a string, got 9001'
         * //   }
         * // }
         * ```
         */
        this.run = function (json) {
            return mapError$1(function (error) { return ({
                kind: 'DecoderError',
                input: json,
                at: 'input' + (error.at || ''),
                message: error.message || ''
            }); }, _this.decode(json));
        };
        /**
         * Run the decoder as a `Promise`.
         */
        this.runPromise = function (json) { return asPromise$1(_this.run(json)); };
        /**
         * Run the decoder and return the value on success, or throw an exception
         * with a formatted error string.
         */
        this.runWithException = function (json) { return withException$1(_this.run(json)); };
        /**
         * Construct a new decoder that applies a transformation to the decoded
         * result. If the decoder succeeds then `f` will be applied to the value. If
         * it fails the error will propagated through.
         *
         * Example:
         * ```
         * number().map(x => x * 5).run(10)
         * // => {ok: true, result: 50}
         * ```
         */
        this.map = function (f) {
            return new Decoder(function (json) { return map$1(f, _this.decode(json)); });
        };
        /**
         * Chain together a sequence of decoders. The first decoder will run, and
         * then the function will determine what decoder to run second. If the result
         * of the first decoder succeeds then `f` will be applied to the decoded
         * value. If it fails the error will propagate through.
         *
         * This is a very powerful method -- it can act as both the `map` and `where`
         * methods, can improve error messages for edge cases, and can be used to
         * make a decoder for custom types.
         *
         * Example of adding an error message:
         * ```
         * const versionDecoder = valueAt(['version'], number());
         * const infoDecoder3 = object({a: boolean()});
         *
         * const decoder = versionDecoder.andThen(version => {
         *   switch (version) {
         *     case 3:
         *       return infoDecoder3;
         *     default:
         *       return fail(`Unable to decode info, version ${version} is not supported.`);
         *   }
         * });
         *
         * decoder.run({version: 3, a: true})
         * // => {ok: true, result: {a: true}}
         *
         * decoder.run({version: 5, x: 'abc'})
         * // =>
         * // {
         * //   ok: false,
         * //   error: {... message: 'Unable to decode info, version 5 is not supported.'}
         * // }
         * ```
         *
         * Example of decoding a custom type:
         * ```
         * // nominal type for arrays with a length of at least one
         * type NonEmptyArray<T> = T[] & { __nonEmptyArrayBrand__: void };
         *
         * const nonEmptyArrayDecoder = <T>(values: Decoder<T>): Decoder<NonEmptyArray<T>> =>
         *   array(values).andThen(arr =>
         *     arr.length > 0
         *       ? succeed(createNonEmptyArray(arr))
         *       : fail(`expected a non-empty array, got an empty array`)
         *   );
         * ```
         */
        this.andThen = function (f) {
            return new Decoder(function (json) {
                return andThen$1(function (value) { return f(value).decode(json); }, _this.decode(json));
            });
        };
        /**
         * Add constraints to a decoder _without_ changing the resulting type. The
         * `test` argument is a predicate function which returns true for valid
         * inputs. When `test` fails on an input, the decoder fails with the given
         * `errorMessage`.
         *
         * ```
         * const chars = (length: number): Decoder<string> =>
         *   string().where(
         *     (s: string) => s.length === length,
         *     `expected a string of length ${length}`
         *   );
         *
         * chars(5).run('12345')
         * // => {ok: true, result: '12345'}
         *
         * chars(2).run('HELLO')
         * // => {ok: false, error: {... message: 'expected a string of length 2'}}
         *
         * chars(12).run(true)
         * // => {ok: false, error: {... message: 'expected a string, got a boolean'}}
         * ```
         */
        this.where = function (test, errorMessage) {
            return _this.andThen(function (value) { return (test(value) ? Decoder.succeed(value) : Decoder.fail(errorMessage)); });
        };
    }
    /**
     * Decoder primitive that validates strings, and fails on all other input.
     */
    Decoder.string = function () {
        return new Decoder(function (json) {
            return typeof json === 'string'
                ? ok$1(json)
                : err$1({ message: expectedGot$1('a string', json) });
        });
    };
    /**
     * Decoder primitive that validates numbers, and fails on all other input.
     */
    Decoder.number = function () {
        return new Decoder(function (json) {
            return typeof json === 'number'
                ? ok$1(json)
                : err$1({ message: expectedGot$1('a number', json) });
        });
    };
    /**
     * Decoder primitive that validates booleans, and fails on all other input.
     */
    Decoder.boolean = function () {
        return new Decoder(function (json) {
            return typeof json === 'boolean'
                ? ok$1(json)
                : err$1({ message: expectedGot$1('a boolean', json) });
        });
    };
    Decoder.constant = function (value) {
        return new Decoder(function (json) {
            return isEqual$1(json, value)
                ? ok$1(value)
                : err$1({ message: "expected " + JSON.stringify(value) + ", got " + JSON.stringify(json) });
        });
    };
    Decoder.object = function (decoders) {
        return new Decoder(function (json) {
            if (isJsonObject$1(json) && decoders) {
                var obj = {};
                for (var key in decoders) {
                    if (decoders.hasOwnProperty(key)) {
                        var r = decoders[key].decode(json[key]);
                        if (r.ok === true) {
                            // tslint:disable-next-line:strict-type-predicates
                            if (r.result !== undefined) {
                                obj[key] = r.result;
                            }
                        }
                        else if (json[key] === undefined) {
                            return err$1({ message: "the key '" + key + "' is required but was not present" });
                        }
                        else {
                            return err$1(prependAt$1("." + key, r.error));
                        }
                    }
                }
                return ok$1(obj);
            }
            else if (isJsonObject$1(json)) {
                return ok$1(json);
            }
            else {
                return err$1({ message: expectedGot$1('an object', json) });
            }
        });
    };
    Decoder.array = function (decoder) {
        return new Decoder(function (json) {
            if (isJsonArray$1(json) && decoder) {
                var decodeValue_1 = function (v, i) {
                    return mapError$1(function (err$$1) { return prependAt$1("[" + i + "]", err$$1); }, decoder.decode(v));
                };
                return json.reduce(function (acc, v, i) {
                    return map2$1(function (arr, result) { return arr.concat([result]); }, acc, decodeValue_1(v, i));
                }, ok$1([]));
            }
            else if (isJsonArray$1(json)) {
                return ok$1(json);
            }
            else {
                return err$1({ message: expectedGot$1('an array', json) });
            }
        });
    };
    Decoder.tuple = function (decoders) {
        return new Decoder(function (json) {
            if (isJsonArray$1(json)) {
                if (json.length !== decoders.length) {
                    return err$1({
                        message: "expected a tuple of length " + decoders.length + ", got one of length " + json.length
                    });
                }
                var result = [];
                for (var i = 0; i < decoders.length; i++) {
                    var nth = decoders[i].decode(json[i]);
                    if (nth.ok) {
                        result[i] = nth.result;
                    }
                    else {
                        return err$1(prependAt$1("[" + i + "]", nth.error));
                    }
                }
                return ok$1(result);
            }
            else {
                return err$1({ message: expectedGot$1("a tuple of length " + decoders.length, json) });
            }
        });
    };
    Decoder.union = function (ad, bd) {
        var decoders = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            decoders[_i - 2] = arguments[_i];
        }
        return Decoder.oneOf.apply(Decoder, [ad, bd].concat(decoders));
    };
    Decoder.intersection = function (ad, bd) {
        var ds = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            ds[_i - 2] = arguments[_i];
        }
        return new Decoder(function (json) {
            return [ad, bd].concat(ds).reduce(function (acc, decoder) { return map2$1(Object.assign, acc, decoder.decode(json)); }, ok$1({}));
        });
    };
    /**
     * Escape hatch to bypass validation. Always succeeds and types the result as
     * `any`. Useful for defining decoders incrementally, particularly for
     * complex objects.
     *
     * Example:
     * ```
     * interface User {
     *   name: string;
     *   complexUserData: ComplexType;
     * }
     *
     * const userDecoder: Decoder<User> = object({
     *   name: string(),
     *   complexUserData: anyJson()
     * });
     * ```
     */
    Decoder.anyJson = function () { return new Decoder(function (json) { return ok$1(json); }); };
    /**
     * Decoder identity function which always succeeds and types the result as
     * `unknown`.
     */
    Decoder.unknownJson = function () {
        return new Decoder(function (json) { return ok$1(json); });
    };
    /**
     * Decoder for json objects where the keys are unknown strings, but the values
     * should all be of the same type.
     *
     * Example:
     * ```
     * dict(number()).run({chocolate: 12, vanilla: 10, mint: 37});
     * // => {ok: true, result: {chocolate: 12, vanilla: 10, mint: 37}}
     * ```
     */
    Decoder.dict = function (decoder) {
        return new Decoder(function (json) {
            if (isJsonObject$1(json)) {
                var obj = {};
                for (var key in json) {
                    if (json.hasOwnProperty(key)) {
                        var r = decoder.decode(json[key]);
                        if (r.ok === true) {
                            obj[key] = r.result;
                        }
                        else {
                            return err$1(prependAt$1("." + key, r.error));
                        }
                    }
                }
                return ok$1(obj);
            }
            else {
                return err$1({ message: expectedGot$1('an object', json) });
            }
        });
    };
    /**
     * Decoder for values that may be `undefined`. This is primarily helpful for
     * decoding interfaces with optional fields.
     *
     * Example:
     * ```
     * interface User {
     *   id: number;
     *   isOwner?: boolean;
     * }
     *
     * const decoder: Decoder<User> = object({
     *   id: number(),
     *   isOwner: optional(boolean())
     * });
     * ```
     */
    Decoder.optional = function (decoder) {
        return new Decoder(function (json) { return (json === undefined || json === null ? ok$1(undefined) : decoder.decode(json)); });
    };
    /**
     * Decoder that attempts to run each decoder in `decoders` and either succeeds
     * with the first successful decoder, or fails after all decoders have failed.
     *
     * Note that `oneOf` expects the decoders to all have the same return type,
     * while `union` creates a decoder for the union type of all the input
     * decoders.
     *
     * Examples:
     * ```
     * oneOf(string(), number().map(String))
     * oneOf(constant('start'), constant('stop'), succeed('unknown'))
     * ```
     */
    Decoder.oneOf = function () {
        var decoders = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            decoders[_i] = arguments[_i];
        }
        return new Decoder(function (json) {
            var errors = [];
            for (var i = 0; i < decoders.length; i++) {
                var r = decoders[i].decode(json);
                if (r.ok === true) {
                    return r;
                }
                else {
                    errors[i] = r.error;
                }
            }
            var errorsList = errors
                .map(function (error) { return "at error" + (error.at || '') + ": " + error.message; })
                .join('", "');
            return err$1({
                message: "expected a value matching one of the decoders, got the errors [\"" + errorsList + "\"]"
            });
        });
    };
    /**
     * Decoder that always succeeds with either the decoded value, or a fallback
     * default value.
     */
    Decoder.withDefault = function (defaultValue, decoder) {
        return new Decoder(function (json) {
            return ok$1(withDefault$1(defaultValue, decoder.decode(json)));
        });
    };
    /**
     * Decoder that pulls a specific field out of a json structure, instead of
     * decoding and returning the full structure. The `paths` array describes the
     * object keys and array indices to traverse, so that values can be pulled out
     * of a nested structure.
     *
     * Example:
     * ```
     * const decoder = valueAt(['a', 'b', 0], string());
     *
     * decoder.run({a: {b: ['surprise!']}})
     * // => {ok: true, result: 'surprise!'}
     *
     * decoder.run({a: {x: 'cats'}})
     * // => {ok: false, error: {... at: 'input.a.b[0]' message: 'path does not exist'}}
     * ```
     *
     * Note that the `decoder` is ran on the value found at the last key in the
     * path, even if the last key is not found. This allows the `optional`
     * decoder to succeed when appropriate.
     * ```
     * const optionalDecoder = valueAt(['a', 'b', 'c'], optional(string()));
     *
     * optionalDecoder.run({a: {b: {c: 'surprise!'}}})
     * // => {ok: true, result: 'surprise!'}
     *
     * optionalDecoder.run({a: {b: 'cats'}})
     * // => {ok: false, error: {... at: 'input.a.b.c' message: 'expected an object, got "cats"'}
     *
     * optionalDecoder.run({a: {b: {z: 1}}})
     * // => {ok: true, result: undefined}
     * ```
     */
    Decoder.valueAt = function (paths, decoder) {
        return new Decoder(function (json) {
            var jsonAtPath = json;
            for (var i = 0; i < paths.length; i++) {
                if (jsonAtPath === undefined) {
                    return err$1({
                        at: printPath$1(paths.slice(0, i + 1)),
                        message: 'path does not exist'
                    });
                }
                else if (typeof paths[i] === 'string' && !isJsonObject$1(jsonAtPath)) {
                    return err$1({
                        at: printPath$1(paths.slice(0, i + 1)),
                        message: expectedGot$1('an object', jsonAtPath)
                    });
                }
                else if (typeof paths[i] === 'number' && !isJsonArray$1(jsonAtPath)) {
                    return err$1({
                        at: printPath$1(paths.slice(0, i + 1)),
                        message: expectedGot$1('an array', jsonAtPath)
                    });
                }
                else {
                    jsonAtPath = jsonAtPath[paths[i]];
                }
            }
            return mapError$1(function (error) {
                return jsonAtPath === undefined
                    ? { at: printPath$1(paths), message: 'path does not exist' }
                    : prependAt$1(printPath$1(paths), error);
            }, decoder.decode(jsonAtPath));
        });
    };
    /**
     * Decoder that ignores the input json and always succeeds with `fixedValue`.
     */
    Decoder.succeed = function (fixedValue) {
        return new Decoder(function (json) { return ok$1(fixedValue); });
    };
    /**
     * Decoder that ignores the input json and always fails with `errorMessage`.
     */
    Decoder.fail = function (errorMessage) {
        return new Decoder(function (json) { return err$1({ message: errorMessage }); });
    };
    /**
     * Decoder that allows for validating recursive data structures. Unlike with
     * functions, decoders assigned to variables can't reference themselves
     * before they are fully defined. We can avoid prematurely referencing the
     * decoder by wrapping it in a function that won't be called until use, at
     * which point the decoder has been defined.
     *
     * Example:
     * ```
     * interface Comment {
     *   msg: string;
     *   replies: Comment[];
     * }
     *
     * const decoder: Decoder<Comment> = object({
     *   msg: string(),
     *   replies: lazy(() => array(decoder))
     * });
     * ```
     */
    Decoder.lazy = function (mkDecoder) {
        return new Decoder(function (json) { return mkDecoder().decode(json); });
    };
    return Decoder;
}());

/* tslint:disable:variable-name */
/** See `Decoder.string` */
var string$1 = Decoder$1.string;
/** See `Decoder.number` */
var number$1 = Decoder$1.number;
/** See `Decoder.boolean` */
var boolean = Decoder$1.boolean;
/** See `Decoder.anyJson` */
var anyJson$1 = Decoder$1.anyJson;
/** See `Decoder.unknownJson` */
Decoder$1.unknownJson;
/** See `Decoder.constant` */
var constant$1 = Decoder$1.constant;
/** See `Decoder.object` */
var object$1 = Decoder$1.object;
/** See `Decoder.array` */
var array$1 = Decoder$1.array;
/** See `Decoder.tuple` */
Decoder$1.tuple;
/** See `Decoder.dict` */
var dict = Decoder$1.dict;
/** See `Decoder.optional` */
var optional$1 = Decoder$1.optional;
/** See `Decoder.oneOf` */
var oneOf$1 = Decoder$1.oneOf;
/** See `Decoder.union` */
Decoder$1.union;
/** See `Decoder.intersection` */
Decoder$1.intersection;
/** See `Decoder.withDefault` */
Decoder$1.withDefault;
/** See `Decoder.valueAt` */
Decoder$1.valueAt;
/** See `Decoder.succeed` */
Decoder$1.succeed;
/** See `Decoder.fail` */
Decoder$1.fail;
/** See `Decoder.lazy` */
Decoder$1.lazy;

const nonEmptyStringDecoder$1 = string$1().where((s) => s.length > 0, "Expected a non-empty string");
const nonNegativeNumberDecoder = number$1().where((num) => num >= 0, "Expected a non-negative number");

const intentDefinitionDecoder = object$1({
    name: nonEmptyStringDecoder$1,
    displayName: optional$1(string$1()),
    contexts: optional$1(array$1(string$1())),
    customConfig: optional$1(object$1())
});
const v2TypeDecoder = oneOf$1(constant$1("web"), constant$1("native"), constant$1("citrix"), constant$1("onlineNative"), constant$1("other"));
const v2DetailsDecoder = object$1({
    url: nonEmptyStringDecoder$1
});
const v2IconDecoder = object$1({
    src: nonEmptyStringDecoder$1,
    size: optional$1(nonEmptyStringDecoder$1),
    type: optional$1(nonEmptyStringDecoder$1)
});
const v2ScreenshotDecoder = object$1({
    src: nonEmptyStringDecoder$1,
    size: optional$1(nonEmptyStringDecoder$1),
    type: optional$1(nonEmptyStringDecoder$1),
    label: optional$1(nonEmptyStringDecoder$1)
});
const v2ListensForIntentDecoder = object$1({
    contexts: array$1(nonEmptyStringDecoder$1),
    displayName: optional$1(nonEmptyStringDecoder$1),
    resultType: optional$1(nonEmptyStringDecoder$1),
    customConfig: optional$1(anyJson$1())
});
const v2IntentsDecoder = object$1({
    listensFor: optional$1(dict(v2ListensForIntentDecoder)),
    raises: optional$1(dict(array$1(nonEmptyStringDecoder$1)))
});
const v2UserChannelDecoder = object$1({
    broadcasts: optional$1(array$1(nonEmptyStringDecoder$1)),
    listensFor: optional$1(array$1(nonEmptyStringDecoder$1))
});
const v2AppChannelDecoder = object$1({
    name: nonEmptyStringDecoder$1,
    description: optional$1(nonEmptyStringDecoder$1),
    broadcasts: optional$1(array$1(nonEmptyStringDecoder$1)),
    listensFor: optional$1(array$1(nonEmptyStringDecoder$1))
});
const v2InteropDecoder = object$1({
    intents: optional$1(v2IntentsDecoder),
    userChannels: optional$1(v2UserChannelDecoder),
    appChannels: optional$1(array$1(v2AppChannelDecoder))
});
const glue42ApplicationDetailsDecoder = object$1({
    url: optional$1(nonEmptyStringDecoder$1),
    top: optional$1(number$1()),
    left: optional$1(number$1()),
    width: optional$1(nonNegativeNumberDecoder),
    height: optional$1(nonNegativeNumberDecoder)
});
const glue42HostManifestsBrowserDecoder = object$1({
    name: optional$1(nonEmptyStringDecoder$1),
    type: optional$1(nonEmptyStringDecoder$1.where((s) => s === "window", "Expected a value of window")),
    title: optional$1(nonEmptyStringDecoder$1),
    version: optional$1(nonEmptyStringDecoder$1),
    customProperties: optional$1(anyJson$1()),
    icon: optional$1(string$1()),
    caption: optional$1(string$1()),
    details: optional$1(glue42ApplicationDetailsDecoder),
    intents: optional$1(array$1(intentDefinitionDecoder)),
    hidden: optional$1(boolean())
});
const v1DefinitionDecoder = object$1({
    name: nonEmptyStringDecoder$1,
    appId: nonEmptyStringDecoder$1,
    title: optional$1(nonEmptyStringDecoder$1),
    version: optional$1(nonEmptyStringDecoder$1),
    manifest: nonEmptyStringDecoder$1,
    manifestType: nonEmptyStringDecoder$1,
    tooltip: optional$1(nonEmptyStringDecoder$1),
    description: optional$1(nonEmptyStringDecoder$1),
    contactEmail: optional$1(nonEmptyStringDecoder$1),
    supportEmail: optional$1(nonEmptyStringDecoder$1),
    publisher: optional$1(nonEmptyStringDecoder$1),
    images: optional$1(array$1(object$1({ url: optional$1(nonEmptyStringDecoder$1) }))),
    icons: optional$1(array$1(object$1({ icon: optional$1(nonEmptyStringDecoder$1) }))),
    customConfig: anyJson$1(),
    intents: optional$1(array$1(intentDefinitionDecoder))
});
const v2LocalizedDefinitionDecoder = object$1({
    appId: optional$1(nonEmptyStringDecoder$1),
    name: optional$1(nonEmptyStringDecoder$1),
    details: optional$1(v2DetailsDecoder),
    version: optional$1(nonEmptyStringDecoder$1),
    title: optional$1(nonEmptyStringDecoder$1),
    tooltip: optional$1(nonEmptyStringDecoder$1),
    lang: optional$1(nonEmptyStringDecoder$1),
    description: optional$1(nonEmptyStringDecoder$1),
    categories: optional$1(array$1(nonEmptyStringDecoder$1)),
    icons: optional$1(array$1(v2IconDecoder)),
    screenshots: optional$1(array$1(v2ScreenshotDecoder)),
    contactEmail: optional$1(nonEmptyStringDecoder$1),
    supportEmail: optional$1(nonEmptyStringDecoder$1),
    moreInfo: optional$1(nonEmptyStringDecoder$1),
    publisher: optional$1(nonEmptyStringDecoder$1),
    customConfig: optional$1(array$1(anyJson$1())),
    hostManifests: optional$1(anyJson$1()),
    interop: optional$1(v2InteropDecoder)
});
const v2DefinitionDecoder = object$1({
    appId: nonEmptyStringDecoder$1,
    name: nonEmptyStringDecoder$1,
    type: v2TypeDecoder,
    details: v2DetailsDecoder,
    version: optional$1(nonEmptyStringDecoder$1),
    title: optional$1(nonEmptyStringDecoder$1),
    tooltip: optional$1(nonEmptyStringDecoder$1),
    lang: optional$1(nonEmptyStringDecoder$1),
    description: optional$1(nonEmptyStringDecoder$1),
    categories: optional$1(array$1(nonEmptyStringDecoder$1)),
    icons: optional$1(array$1(v2IconDecoder)),
    screenshots: optional$1(array$1(v2ScreenshotDecoder)),
    contactEmail: optional$1(nonEmptyStringDecoder$1),
    supportEmail: optional$1(nonEmptyStringDecoder$1),
    moreInfo: optional$1(nonEmptyStringDecoder$1),
    publisher: optional$1(nonEmptyStringDecoder$1),
    customConfig: optional$1(array$1(anyJson$1())),
    hostManifests: optional$1(anyJson$1()),
    interop: optional$1(v2InteropDecoder),
    localizedVersions: optional$1(dict(v2LocalizedDefinitionDecoder))
});
const allDefinitionsDecoder = oneOf$1(v1DefinitionDecoder, v2DefinitionDecoder);

const parseDecoderErrorToStringMessage = (error) => {
    return `${error.kind} at ${error.at}: ${JSON.stringify(error.input)}. Reason - ${error.message}`;
};

class FDC3Service {
    fdc3ToDesktopDefinitionType = {
        web: "window",
        native: "exe",
        citrix: "citrix",
        onlineNative: "clickonce",
        other: "window"
    };
    toApi() {
        return {
            isFdc3Definition: this.isFdc3Definition.bind(this),
            parseToBrowserBaseAppData: this.parseToBrowserBaseAppData.bind(this),
            parseToDesktopAppConfig: this.parseToDesktopAppConfig.bind(this)
        };
    }
    isFdc3Definition(definition) {
        const decodeRes = allDefinitionsDecoder.run(definition);
        if (!decodeRes.ok) {
            return { isFdc3: false, reason: parseDecoderErrorToStringMessage(decodeRes.error) };
        }
        if (definition.appId && definition.details) {
            return { isFdc3: true, version: "2.0" };
        }
        if (definition.manifest) {
            return { isFdc3: true, version: "1.2" };
        }
        return { isFdc3: false, reason: "The passed definition is not FDC3" };
    }
    parseToBrowserBaseAppData(definition) {
        const { isFdc3, version } = this.isFdc3Definition(definition);
        if (!isFdc3) {
            throw new Error("The passed definition is not FDC3");
        }
        const decodeRes = allDefinitionsDecoder.run(definition);
        if (!decodeRes.ok) {
            throw new Error(`Invalid FDC3 ${version} definition. Error: ${parseDecoderErrorToStringMessage(decodeRes.error)}`);
        }
        const userProperties = this.getUserPropertiesFromDefinition(definition, version);
        const createOptions = { url: this.getUrl(definition, version) };
        const baseApplicationData = {
            name: definition.appId,
            type: "window",
            createOptions,
            userProperties: {
                ...userProperties,
                intents: version === "1.2"
                    ? userProperties.intents
                    : this.getIntentsFromV2AppDefinition(definition),
                details: createOptions
            },
            title: definition.title,
            version: definition.version,
            icon: this.getIconFromDefinition(definition, version),
            caption: definition.description,
            fdc3: version === "2.0" ? { ...definition, definitionVersion: "2.0" } : undefined,
        };
        const ioConnectDefinition = definition.hostManifests?.ioConnect || definition.hostManifests?.["Glue42"];
        if (!ioConnectDefinition) {
            return baseApplicationData;
        }
        const ioDefinitionDecodeRes = glue42HostManifestsBrowserDecoder.run(ioConnectDefinition);
        if (!ioDefinitionDecodeRes.ok) {
            throw new Error(`Invalid FDC3 ${version} definition. Error: ${parseDecoderErrorToStringMessage(ioDefinitionDecodeRes.error)}`);
        }
        if (!Object.keys(ioDefinitionDecodeRes.result).length) {
            return baseApplicationData;
        }
        return this.mergeBaseAppDataWithGlueManifest(baseApplicationData, ioDefinitionDecodeRes.result);
    }
    parseToDesktopAppConfig(definition) {
        const { isFdc3, version } = this.isFdc3Definition(definition);
        if (!isFdc3) {
            throw new Error("The passed definition is not FDC3");
        }
        const decodeRes = allDefinitionsDecoder.run(definition);
        if (!decodeRes.ok) {
            throw new Error(`Invalid FDC3 ${version} definition. Error: ${parseDecoderErrorToStringMessage(decodeRes.error)}`);
        }
        if (version === "1.2") {
            const fdc3v1Definition = definition;
            return {
                name: fdc3v1Definition.appId,
                type: "window",
                details: {
                    url: this.getUrl(definition, version)
                },
                version: fdc3v1Definition.version,
                title: fdc3v1Definition.title,
                tooltip: fdc3v1Definition.tooltip,
                caption: fdc3v1Definition.description,
                icon: fdc3v1Definition.icons?.[0].icon,
                intents: fdc3v1Definition.intents,
                customProperties: {
                    manifestType: fdc3v1Definition.manifestType,
                    images: fdc3v1Definition.images,
                    contactEmail: fdc3v1Definition.contactEmail,
                    supportEmail: fdc3v1Definition.supportEmail,
                    publisher: fdc3v1Definition.publisher,
                    icons: fdc3v1Definition.icons,
                    customConfig: fdc3v1Definition.customConfig
                }
            };
        }
        const fdc3v2Definition = definition;
        const desktopDefinition = {
            name: fdc3v2Definition.appId,
            type: this.fdc3ToDesktopDefinitionType[fdc3v2Definition.type],
            details: fdc3v2Definition.details,
            version: fdc3v2Definition.version,
            title: fdc3v2Definition.title,
            tooltip: fdc3v2Definition.tooltip,
            caption: fdc3v2Definition.description,
            icon: this.getIconFromDefinition(fdc3v2Definition, "2.0"),
            intents: this.getIntentsFromV2AppDefinition(fdc3v2Definition),
            fdc3: { ...fdc3v2Definition, definitionVersion: "2.0" }
        };
        const ioConnectDefinition = definition.hostManifests?.ioConnect || definition.hostManifests?.["Glue42"];
        if (!ioConnectDefinition) {
            return desktopDefinition;
        }
        if (typeof ioConnectDefinition !== "object" || Array.isArray(ioConnectDefinition)) {
            throw new Error(`Invalid '${definition.hostManifests.ioConnect ? "hostManifests.ioConnect" : "hostManifests['Glue42']"}' key`);
        }
        return this.mergeDesktopConfigWithGlueManifest(desktopDefinition, ioConnectDefinition);
    }
    getUserPropertiesFromDefinition(definition, version) {
        if (version === "1.2") {
            return Object.fromEntries(Object.entries(definition).filter(([key]) => !connectBrowserAppProps.includes(key)));
        }
        return Object.fromEntries(Object.entries(definition).filter(([key]) => !connectBrowserAppProps.includes(key) && !fdc3v2AppProps.includes(key)));
    }
    getUrl(definition, version) {
        let url;
        if (version === "1.2") {
            const parsedManifest = JSON.parse(definition.manifest);
            url = parsedManifest.details?.url || parsedManifest.url;
        }
        else {
            url = definition.details?.url;
        }
        if (!url || typeof url !== "string") {
            throw new Error(`Invalid FDC3 ${version} definition. Provide valid 'url' under '${version === "1.2" ? "manifest" : "details"}' key`);
        }
        return url;
    }
    getIntentsFromV2AppDefinition(definition) {
        const fdc3Intents = definition.interop?.intents?.listensFor;
        if (!fdc3Intents) {
            return;
        }
        const intents = Object.entries(fdc3Intents).map((fdc3Intent) => {
            const [intentName, intentData] = fdc3Intent;
            return {
                name: intentName,
                ...intentData
            };
        });
        return intents;
    }
    getIconFromDefinition(definition, version) {
        if (version === "1.2") {
            return definition.icons?.find((iconDef) => iconDef.icon)?.icon || undefined;
        }
        return definition.icons?.find((iconDef) => iconDef.src)?.src || undefined;
    }
    mergeBaseAppDataWithGlueManifest(baseAppData, hostManifestDefinition) {
        let baseApplicationDefinition = baseAppData;
        if (hostManifestDefinition.details) {
            const details = { ...baseAppData.createOptions, ...hostManifestDefinition.details };
            baseApplicationDefinition.createOptions = details;
            baseApplicationDefinition.userProperties.details = details;
        }
        if (Array.isArray(hostManifestDefinition.intents)) {
            baseApplicationDefinition.userProperties.intents = (baseApplicationDefinition.userProperties.intents || []).concat(hostManifestDefinition.intents);
        }
        baseApplicationDefinition = { ...baseApplicationDefinition, ...hostManifestDefinition };
        delete baseApplicationDefinition.details;
        delete baseApplicationDefinition.intents;
        return baseApplicationDefinition;
    }
    mergeDesktopConfigWithGlueManifest(config, desktopDefinition) {
        const appConfig = Object.assign({}, config, desktopDefinition, { details: { ...config.details, ...desktopDefinition.details } });
        if (Array.isArray(desktopDefinition.intents)) {
            appConfig.intents = (config.intents || []).concat(desktopDefinition.intents);
        }
        return appConfig;
    }
}

const decoders$1 = {
    common: {
        nonEmptyStringDecoder: nonEmptyStringDecoder$1,
        nonNegativeNumberDecoder
    },
    fdc3: {
        allDefinitionsDecoder,
        v1DefinitionDecoder,
        v2DefinitionDecoder
    }
};

var INTENTS_ERRORS;
(function (INTENTS_ERRORS) {
    INTENTS_ERRORS["USER_CANCELLED"] = "User Closed Intents Resolver UI without choosing a handler";
    INTENTS_ERRORS["CALLER_NOT_DEFINED"] = "Caller Id is not defined";
    INTENTS_ERRORS["TIMEOUT_HIT"] = "Timeout hit";
    INTENTS_ERRORS["INTENT_NOT_FOUND"] = "Cannot find Intent";
    INTENTS_ERRORS["HANDLER_NOT_FOUND"] = "Cannot find Intent Handler";
    INTENTS_ERRORS["TARGET_INSTANCE_UNAVAILABLE"] = "Cannot start Target Instance";
    INTENTS_ERRORS["INTENT_DELIVERY_FAILED"] = "Target Instance did not add a listener";
    INTENTS_ERRORS["RESOLVER_UNAVAILABLE"] = "Intents Resolver UI unavailable";
    INTENTS_ERRORS["RESOLVER_TIMEOUT"] = "User did not choose a handler";
    INTENTS_ERRORS["INVALID_RESOLVER_RESPONSE"] = "Intents Resolver UI returned invalid response";
    INTENTS_ERRORS["INTENT_HANDLER_REJECTION"] = "Intent Handler function processing the raised intent threw an error or rejected the promise it returned";
})(INTENTS_ERRORS || (INTENTS_ERRORS = {}));

let IoC$1 = class IoC {
    _fdc3;
    _decoders = decoders$1;
    _errors = {
        intents: INTENTS_ERRORS
    };
    get fdc3() {
        if (!this._fdc3) {
            this._fdc3 = new FDC3Service().toApi();
        }
        return this._fdc3;
    }
    get decoders() {
        return this._decoders;
    }
    get errors() {
        return this._errors;
    }
};

const ioc = new IoC$1();
ioc.fdc3;
ioc.decoders;
const errors = ioc.errors;

var IntentHandlerResultTypes;
(function (IntentHandlerResultTypes) {
    IntentHandlerResultTypes["Context"] = "Context";
    IntentHandlerResultTypes["Channel"] = "Channel";
})(IntentHandlerResultTypes || (IntentHandlerResultTypes = {}));
var ChannelTypes;
(function (ChannelTypes) {
    ChannelTypes["User"] = "user";
    ChannelTypes["App"] = "app";
    ChannelTypes["Private"] = "private";
})(ChannelTypes || (ChannelTypes = {}));
const defaultChannelsProps = ["id", "type", "broadcast", "addContextListener", "getCurrentContext"];
const defaultContextProps = ["type"];
const defaultGlue42APIs = ["contexts", "channels", "interop", "intents", "appManager", "windows"];
const glueChannelNamePrefix = "___channel___";
const fdc3NothingContextType = "fdc3.nothing";
const RaiseTimeoutMs = 75 * 1000;
const IntentsMethodPrefix = "Tick42.FDC3.Intents.";
const IO_ERRORS = errors.intents;
const BrowserClientControlMethodName = "T42.Web.Client.Control";
const DesktopClientControlMethodName = "T42.Channels.Command";

const ioConnectFDC3SystemMethod = "FDC3.Collaborate";
const PrivateChannelPrefix = "___privateFDC3Channel___";
var PrivateChannelEventMethods;
(function (PrivateChannelEventMethods) {
    PrivateChannelEventMethods["ListenerAdded"] = "listenerAdded";
    PrivateChannelEventMethods["OnAddContextListener"] = "onAddContextListener";
    PrivateChannelEventMethods["OnUnsubscribe"] = "onUnsubscribe";
    PrivateChannelEventMethods["OnDisconnect"] = "onDisconnect";
})(PrivateChannelEventMethods || (PrivateChannelEventMethods = {}));

/**
 * Wraps values in an `Ok` type.
 *
 * Example: `ok(5) // => {ok: true, result: 5}`
 */
var ok = function (result) { return ({ ok: true, result: result }); };
/**
 * Wraps errors in an `Err` type.
 *
 * Example: `err('on fire') // => {ok: false, error: 'on fire'}`
 */
var err = function (error) { return ({ ok: false, error: error }); };
/**
 * Create a `Promise` that either resolves with the result of `Ok` or rejects
 * with the error of `Err`.
 */
var asPromise = function (r) {
    return r.ok === true ? Promise.resolve(r.result) : Promise.reject(r.error);
};
/**
 * Unwraps a `Result` and returns either the result of an `Ok`, or
 * `defaultValue`.
 *
 * Example:
 * ```
 * Result.withDefault(5, number().run(json))
 * ```
 *
 * It would be nice if `Decoder` had an instance method that mirrored this
 * function. Such a method would look something like this:
 * ```
 * class Decoder<A> {
 *   runWithDefault = (defaultValue: A, json: any): A =>
 *     Result.withDefault(defaultValue, this.run(json));
 * }
 *
 * number().runWithDefault(5, json)
 * ```
 * Unfortunately, the type of `defaultValue: A` on the method causes issues
 * with type inference on  the `object` decoder in some situations. While these
 * inference issues can be solved by providing the optional type argument for
 * `object`s, the extra trouble and confusion doesn't seem worth it.
 */
var withDefault = function (defaultValue, r) {
    return r.ok === true ? r.result : defaultValue;
};
/**
 * Return the successful result, or throw an error.
 */
var withException = function (r) {
    if (r.ok === true) {
        return r.result;
    }
    else {
        throw r.error;
    }
};
/**
 * Apply `f` to the result of an `Ok`, or pass the error through.
 */
var map = function (f, r) {
    return r.ok === true ? ok(f(r.result)) : r;
};
/**
 * Apply `f` to the result of two `Ok`s, or pass an error through. If both
 * `Result`s are errors then the first one is returned.
 */
var map2 = function (f, ar, br) {
    return ar.ok === false ? ar :
        br.ok === false ? br :
            ok(f(ar.result, br.result));
};
/**
 * Apply `f` to the error of an `Err`, or pass the success through.
 */
var mapError = function (f, r) {
    return r.ok === true ? r : err(f(r.error));
};
/**
 * Chain together a sequence of computations that may fail, similar to a
 * `Promise`. If the first computation fails then the error will propagate
 * through. If it succeeds, then `f` will be applied to the value, returning a
 * new `Result`.
 */
var andThen = function (f, r) {
    return r.ok === true ? f(r.result) : r;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */



var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function isEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (a === null && b === null) {
        return true;
    }
    if (typeof (a) !== typeof (b)) {
        return false;
    }
    if (typeof (a) === 'object') {
        // Array
        if (Array.isArray(a)) {
            if (!Array.isArray(b)) {
                return false;
            }
            if (a.length !== b.length) {
                return false;
            }
            for (var i = 0; i < a.length; i++) {
                if (!isEqual(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        // Hash table
        var keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length) {
            return false;
        }
        for (var i = 0; i < keys.length; i++) {
            if (!b.hasOwnProperty(keys[i])) {
                return false;
            }
            if (!isEqual(a[keys[i]], b[keys[i]])) {
                return false;
            }
        }
        return true;
    }
}
/*
 * Helpers
 */
var isJsonArray = function (json) { return Array.isArray(json); };
var isJsonObject = function (json) {
    return typeof json === 'object' && json !== null && !isJsonArray(json);
};
var typeString = function (json) {
    switch (typeof json) {
        case 'string':
            return 'a string';
        case 'number':
            return 'a number';
        case 'boolean':
            return 'a boolean';
        case 'undefined':
            return 'undefined';
        case 'object':
            if (json instanceof Array) {
                return 'an array';
            }
            else if (json === null) {
                return 'null';
            }
            else {
                return 'an object';
            }
        default:
            return JSON.stringify(json);
    }
};
var expectedGot = function (expected, got) {
    return "expected " + expected + ", got " + typeString(got);
};
var printPath = function (paths) {
    return paths.map(function (path) { return (typeof path === 'string' ? "." + path : "[" + path + "]"); }).join('');
};
var prependAt = function (newAt, _a) {
    var at = _a.at, rest = __rest(_a, ["at"]);
    return (__assign({ at: newAt + (at || '') }, rest));
};
/**
 * Decoders transform json objects with unknown structure into known and
 * verified forms. You can create objects of type `Decoder<A>` with either the
 * primitive decoder functions, such as `boolean()` and `string()`, or by
 * applying higher-order decoders to the primitives, such as `array(boolean())`
 * or `dict(string())`.
 *
 * Each of the decoder functions are available both as a static method on
 * `Decoder` and as a function alias -- for example the string decoder is
 * defined at `Decoder.string()`, but is also aliased to `string()`. Using the
 * function aliases exported with the library is recommended.
 *
 * `Decoder` exposes a number of 'run' methods, which all decode json in the
 * same way, but communicate success and failure in different ways. The `map`
 * and `andThen` methods modify decoders without having to call a 'run' method.
 *
 * Alternatively, the main decoder `run()` method returns an object of type
 * `Result<A, DecoderError>`. This library provides a number of helper
 * functions for dealing with the `Result` type, so you can do all the same
 * things with a `Result` as with the decoder methods.
 */
var Decoder = /** @class */ (function () {
    /**
     * The Decoder class constructor is kept private to separate the internal
     * `decode` function from the external `run` function. The distinction
     * between the two functions is that `decode` returns a
     * `Partial<DecoderError>` on failure, which contains an unfinished error
     * report. When `run` is called on a decoder, the relevant series of `decode`
     * calls is made, and then on failure the resulting `Partial<DecoderError>`
     * is turned into a `DecoderError` by filling in the missing information.
     *
     * While hiding the constructor may seem restrictive, leveraging the
     * provided decoder combinators and helper functions such as
     * `andThen` and `map` should be enough to build specialized decoders as
     * needed.
     */
    function Decoder(decode) {
        var _this = this;
        this.decode = decode;
        /**
         * Run the decoder and return a `Result` with either the decoded value or a
         * `DecoderError` containing the json input, the location of the error, and
         * the error message.
         *
         * Examples:
         * ```
         * number().run(12)
         * // => {ok: true, result: 12}
         *
         * string().run(9001)
         * // =>
         * // {
         * //   ok: false,
         * //   error: {
         * //     kind: 'DecoderError',
         * //     input: 9001,
         * //     at: 'input',
         * //     message: 'expected a string, got 9001'
         * //   }
         * // }
         * ```
         */
        this.run = function (json) {
            return mapError(function (error) { return ({
                kind: 'DecoderError',
                input: json,
                at: 'input' + (error.at || ''),
                message: error.message || ''
            }); }, _this.decode(json));
        };
        /**
         * Run the decoder as a `Promise`.
         */
        this.runPromise = function (json) { return asPromise(_this.run(json)); };
        /**
         * Run the decoder and return the value on success, or throw an exception
         * with a formatted error string.
         */
        this.runWithException = function (json) { return withException(_this.run(json)); };
        /**
         * Construct a new decoder that applies a transformation to the decoded
         * result. If the decoder succeeds then `f` will be applied to the value. If
         * it fails the error will propagated through.
         *
         * Example:
         * ```
         * number().map(x => x * 5).run(10)
         * // => {ok: true, result: 50}
         * ```
         */
        this.map = function (f) {
            return new Decoder(function (json) { return map(f, _this.decode(json)); });
        };
        /**
         * Chain together a sequence of decoders. The first decoder will run, and
         * then the function will determine what decoder to run second. If the result
         * of the first decoder succeeds then `f` will be applied to the decoded
         * value. If it fails the error will propagate through.
         *
         * This is a very powerful method -- it can act as both the `map` and `where`
         * methods, can improve error messages for edge cases, and can be used to
         * make a decoder for custom types.
         *
         * Example of adding an error message:
         * ```
         * const versionDecoder = valueAt(['version'], number());
         * const infoDecoder3 = object({a: boolean()});
         *
         * const decoder = versionDecoder.andThen(version => {
         *   switch (version) {
         *     case 3:
         *       return infoDecoder3;
         *     default:
         *       return fail(`Unable to decode info, version ${version} is not supported.`);
         *   }
         * });
         *
         * decoder.run({version: 3, a: true})
         * // => {ok: true, result: {a: true}}
         *
         * decoder.run({version: 5, x: 'abc'})
         * // =>
         * // {
         * //   ok: false,
         * //   error: {... message: 'Unable to decode info, version 5 is not supported.'}
         * // }
         * ```
         *
         * Example of decoding a custom type:
         * ```
         * // nominal type for arrays with a length of at least one
         * type NonEmptyArray<T> = T[] & { __nonEmptyArrayBrand__: void };
         *
         * const nonEmptyArrayDecoder = <T>(values: Decoder<T>): Decoder<NonEmptyArray<T>> =>
         *   array(values).andThen(arr =>
         *     arr.length > 0
         *       ? succeed(createNonEmptyArray(arr))
         *       : fail(`expected a non-empty array, got an empty array`)
         *   );
         * ```
         */
        this.andThen = function (f) {
            return new Decoder(function (json) {
                return andThen(function (value) { return f(value).decode(json); }, _this.decode(json));
            });
        };
        /**
         * Add constraints to a decoder _without_ changing the resulting type. The
         * `test` argument is a predicate function which returns true for valid
         * inputs. When `test` fails on an input, the decoder fails with the given
         * `errorMessage`.
         *
         * ```
         * const chars = (length: number): Decoder<string> =>
         *   string().where(
         *     (s: string) => s.length === length,
         *     `expected a string of length ${length}`
         *   );
         *
         * chars(5).run('12345')
         * // => {ok: true, result: '12345'}
         *
         * chars(2).run('HELLO')
         * // => {ok: false, error: {... message: 'expected a string of length 2'}}
         *
         * chars(12).run(true)
         * // => {ok: false, error: {... message: 'expected a string, got a boolean'}}
         * ```
         */
        this.where = function (test, errorMessage) {
            return _this.andThen(function (value) { return (test(value) ? Decoder.succeed(value) : Decoder.fail(errorMessage)); });
        };
    }
    /**
     * Decoder primitive that validates strings, and fails on all other input.
     */
    Decoder.string = function () {
        return new Decoder(function (json) {
            return typeof json === 'string'
                ? ok(json)
                : err({ message: expectedGot('a string', json) });
        });
    };
    /**
     * Decoder primitive that validates numbers, and fails on all other input.
     */
    Decoder.number = function () {
        return new Decoder(function (json) {
            return typeof json === 'number'
                ? ok(json)
                : err({ message: expectedGot('a number', json) });
        });
    };
    /**
     * Decoder primitive that validates booleans, and fails on all other input.
     */
    Decoder.boolean = function () {
        return new Decoder(function (json) {
            return typeof json === 'boolean'
                ? ok(json)
                : err({ message: expectedGot('a boolean', json) });
        });
    };
    Decoder.constant = function (value) {
        return new Decoder(function (json) {
            return isEqual(json, value)
                ? ok(value)
                : err({ message: "expected " + JSON.stringify(value) + ", got " + JSON.stringify(json) });
        });
    };
    Decoder.object = function (decoders) {
        return new Decoder(function (json) {
            if (isJsonObject(json) && decoders) {
                var obj = {};
                for (var key in decoders) {
                    if (decoders.hasOwnProperty(key)) {
                        var r = decoders[key].decode(json[key]);
                        if (r.ok === true) {
                            // tslint:disable-next-line:strict-type-predicates
                            if (r.result !== undefined) {
                                obj[key] = r.result;
                            }
                        }
                        else if (json[key] === undefined) {
                            return err({ message: "the key '" + key + "' is required but was not present" });
                        }
                        else {
                            return err(prependAt("." + key, r.error));
                        }
                    }
                }
                return ok(obj);
            }
            else if (isJsonObject(json)) {
                return ok(json);
            }
            else {
                return err({ message: expectedGot('an object', json) });
            }
        });
    };
    Decoder.array = function (decoder) {
        return new Decoder(function (json) {
            if (isJsonArray(json) && decoder) {
                var decodeValue_1 = function (v, i) {
                    return mapError(function (err$$1) { return prependAt("[" + i + "]", err$$1); }, decoder.decode(v));
                };
                return json.reduce(function (acc, v, i) {
                    return map2(function (arr, result) { return arr.concat([result]); }, acc, decodeValue_1(v, i));
                }, ok([]));
            }
            else if (isJsonArray(json)) {
                return ok(json);
            }
            else {
                return err({ message: expectedGot('an array', json) });
            }
        });
    };
    Decoder.tuple = function (decoders) {
        return new Decoder(function (json) {
            if (isJsonArray(json)) {
                if (json.length !== decoders.length) {
                    return err({
                        message: "expected a tuple of length " + decoders.length + ", got one of length " + json.length
                    });
                }
                var result = [];
                for (var i = 0; i < decoders.length; i++) {
                    var nth = decoders[i].decode(json[i]);
                    if (nth.ok) {
                        result[i] = nth.result;
                    }
                    else {
                        return err(prependAt("[" + i + "]", nth.error));
                    }
                }
                return ok(result);
            }
            else {
                return err({ message: expectedGot("a tuple of length " + decoders.length, json) });
            }
        });
    };
    Decoder.union = function (ad, bd) {
        var decoders = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            decoders[_i - 2] = arguments[_i];
        }
        return Decoder.oneOf.apply(Decoder, [ad, bd].concat(decoders));
    };
    Decoder.intersection = function (ad, bd) {
        var ds = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            ds[_i - 2] = arguments[_i];
        }
        return new Decoder(function (json) {
            return [ad, bd].concat(ds).reduce(function (acc, decoder) { return map2(Object.assign, acc, decoder.decode(json)); }, ok({}));
        });
    };
    /**
     * Escape hatch to bypass validation. Always succeeds and types the result as
     * `any`. Useful for defining decoders incrementally, particularly for
     * complex objects.
     *
     * Example:
     * ```
     * interface User {
     *   name: string;
     *   complexUserData: ComplexType;
     * }
     *
     * const userDecoder: Decoder<User> = object({
     *   name: string(),
     *   complexUserData: anyJson()
     * });
     * ```
     */
    Decoder.anyJson = function () { return new Decoder(function (json) { return ok(json); }); };
    /**
     * Decoder identity function which always succeeds and types the result as
     * `unknown`.
     */
    Decoder.unknownJson = function () {
        return new Decoder(function (json) { return ok(json); });
    };
    /**
     * Decoder for json objects where the keys are unknown strings, but the values
     * should all be of the same type.
     *
     * Example:
     * ```
     * dict(number()).run({chocolate: 12, vanilla: 10, mint: 37});
     * // => {ok: true, result: {chocolate: 12, vanilla: 10, mint: 37}}
     * ```
     */
    Decoder.dict = function (decoder) {
        return new Decoder(function (json) {
            if (isJsonObject(json)) {
                var obj = {};
                for (var key in json) {
                    if (json.hasOwnProperty(key)) {
                        var r = decoder.decode(json[key]);
                        if (r.ok === true) {
                            obj[key] = r.result;
                        }
                        else {
                            return err(prependAt("." + key, r.error));
                        }
                    }
                }
                return ok(obj);
            }
            else {
                return err({ message: expectedGot('an object', json) });
            }
        });
    };
    /**
     * Decoder for values that may be `undefined`. This is primarily helpful for
     * decoding interfaces with optional fields.
     *
     * Example:
     * ```
     * interface User {
     *   id: number;
     *   isOwner?: boolean;
     * }
     *
     * const decoder: Decoder<User> = object({
     *   id: number(),
     *   isOwner: optional(boolean())
     * });
     * ```
     */
    Decoder.optional = function (decoder) {
        return new Decoder(function (json) { return (json === undefined || json === null ? ok(undefined) : decoder.decode(json)); });
    };
    /**
     * Decoder that attempts to run each decoder in `decoders` and either succeeds
     * with the first successful decoder, or fails after all decoders have failed.
     *
     * Note that `oneOf` expects the decoders to all have the same return type,
     * while `union` creates a decoder for the union type of all the input
     * decoders.
     *
     * Examples:
     * ```
     * oneOf(string(), number().map(String))
     * oneOf(constant('start'), constant('stop'), succeed('unknown'))
     * ```
     */
    Decoder.oneOf = function () {
        var decoders = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            decoders[_i] = arguments[_i];
        }
        return new Decoder(function (json) {
            var errors = [];
            for (var i = 0; i < decoders.length; i++) {
                var r = decoders[i].decode(json);
                if (r.ok === true) {
                    return r;
                }
                else {
                    errors[i] = r.error;
                }
            }
            var errorsList = errors
                .map(function (error) { return "at error" + (error.at || '') + ": " + error.message; })
                .join('", "');
            return err({
                message: "expected a value matching one of the decoders, got the errors [\"" + errorsList + "\"]"
            });
        });
    };
    /**
     * Decoder that always succeeds with either the decoded value, or a fallback
     * default value.
     */
    Decoder.withDefault = function (defaultValue, decoder) {
        return new Decoder(function (json) {
            return ok(withDefault(defaultValue, decoder.decode(json)));
        });
    };
    /**
     * Decoder that pulls a specific field out of a json structure, instead of
     * decoding and returning the full structure. The `paths` array describes the
     * object keys and array indices to traverse, so that values can be pulled out
     * of a nested structure.
     *
     * Example:
     * ```
     * const decoder = valueAt(['a', 'b', 0], string());
     *
     * decoder.run({a: {b: ['surprise!']}})
     * // => {ok: true, result: 'surprise!'}
     *
     * decoder.run({a: {x: 'cats'}})
     * // => {ok: false, error: {... at: 'input.a.b[0]' message: 'path does not exist'}}
     * ```
     *
     * Note that the `decoder` is ran on the value found at the last key in the
     * path, even if the last key is not found. This allows the `optional`
     * decoder to succeed when appropriate.
     * ```
     * const optionalDecoder = valueAt(['a', 'b', 'c'], optional(string()));
     *
     * optionalDecoder.run({a: {b: {c: 'surprise!'}}})
     * // => {ok: true, result: 'surprise!'}
     *
     * optionalDecoder.run({a: {b: 'cats'}})
     * // => {ok: false, error: {... at: 'input.a.b.c' message: 'expected an object, got "cats"'}
     *
     * optionalDecoder.run({a: {b: {z: 1}}})
     * // => {ok: true, result: undefined}
     * ```
     */
    Decoder.valueAt = function (paths, decoder) {
        return new Decoder(function (json) {
            var jsonAtPath = json;
            for (var i = 0; i < paths.length; i++) {
                if (jsonAtPath === undefined) {
                    return err({
                        at: printPath(paths.slice(0, i + 1)),
                        message: 'path does not exist'
                    });
                }
                else if (typeof paths[i] === 'string' && !isJsonObject(jsonAtPath)) {
                    return err({
                        at: printPath(paths.slice(0, i + 1)),
                        message: expectedGot('an object', jsonAtPath)
                    });
                }
                else if (typeof paths[i] === 'number' && !isJsonArray(jsonAtPath)) {
                    return err({
                        at: printPath(paths.slice(0, i + 1)),
                        message: expectedGot('an array', jsonAtPath)
                    });
                }
                else {
                    jsonAtPath = jsonAtPath[paths[i]];
                }
            }
            return mapError(function (error) {
                return jsonAtPath === undefined
                    ? { at: printPath(paths), message: 'path does not exist' }
                    : prependAt(printPath(paths), error);
            }, decoder.decode(jsonAtPath));
        });
    };
    /**
     * Decoder that ignores the input json and always succeeds with `fixedValue`.
     */
    Decoder.succeed = function (fixedValue) {
        return new Decoder(function (json) { return ok(fixedValue); });
    };
    /**
     * Decoder that ignores the input json and always fails with `errorMessage`.
     */
    Decoder.fail = function (errorMessage) {
        return new Decoder(function (json) { return err({ message: errorMessage }); });
    };
    /**
     * Decoder that allows for validating recursive data structures. Unlike with
     * functions, decoders assigned to variables can't reference themselves
     * before they are fully defined. We can avoid prematurely referencing the
     * decoder by wrapping it in a function that won't be called until use, at
     * which point the decoder has been defined.
     *
     * Example:
     * ```
     * interface Comment {
     *   msg: string;
     *   replies: Comment[];
     * }
     *
     * const decoder: Decoder<Comment> = object({
     *   msg: string(),
     *   replies: lazy(() => array(decoder))
     * });
     * ```
     */
    Decoder.lazy = function (mkDecoder) {
        return new Decoder(function (json) { return mkDecoder().decode(json); });
    };
    return Decoder;
}());

/* tslint:disable:variable-name */
/** See `Decoder.string` */
var string = Decoder.string;
/** See `Decoder.number` */
var number = Decoder.number;
/** See `Decoder.boolean` */
Decoder.boolean;
/** See `Decoder.anyJson` */
var anyJson = Decoder.anyJson;
/** See `Decoder.unknownJson` */
Decoder.unknownJson;
/** See `Decoder.constant` */
var constant = Decoder.constant;
/** See `Decoder.object` */
var object = Decoder.object;
/** See `Decoder.array` */
var array = Decoder.array;
/** See `Decoder.tuple` */
Decoder.tuple;
/** See `Decoder.dict` */
Decoder.dict;
/** See `Decoder.optional` */
var optional = Decoder.optional;
/** See `Decoder.oneOf` */
var oneOf = Decoder.oneOf;
/** See `Decoder.union` */
Decoder.union;
/** See `Decoder.intersection` */
Decoder.intersection;
/** See `Decoder.withDefault` */
Decoder.withDefault;
/** See `Decoder.valueAt` */
Decoder.valueAt;
/** See `Decoder.succeed` */
Decoder.succeed;
/** See `Decoder.fail` */
Decoder.fail;
/** See `Decoder.lazy` */
Decoder.lazy;

const nonEmptyStringDecoder = string().where((s) => s.length > 0, "Expected a non-empty string");
number().where((num) => num >= 0, "Expected a non-negative number");
const iconDecoder = object({
    src: nonEmptyStringDecoder,
    size: optional(string()),
    type: optional(string())
});
const imageDecoder = object({
    src: nonEmptyStringDecoder,
    size: optional(string()),
    type: optional(string()),
    label: optional(string())
});
object({
    appId: nonEmptyStringDecoder,
    instanceId: optional(string()),
    name: optional(string()),
    version: optional(string()),
    title: optional(string()),
    tooltip: optional(string()),
    description: optional(string()),
    icons: optional(array(iconDecoder)),
    images: optional(array(imageDecoder)),
});
const appIdentifierDecoder = object({
    appId: nonEmptyStringDecoder,
    instanceId: optional(string())
});
const targetAppDecoder = oneOf(nonEmptyStringDecoder, appIdentifierDecoder);
const contextDecoder = object({
    type: nonEmptyStringDecoder,
    name: optional(nonEmptyStringDecoder),
    id: optional(anyJson()),
});
const optionalContextDecoder = optional(contextDecoder);
const optionalTargetApp = optional(appIdentifierDecoder);
const optionalAppIdentifier = optional(targetAppDecoder);
const optionalNonEmptyStringDecoder = optional(nonEmptyStringDecoder);
const SystemMethodActionDecoder = oneOf(constant("joinPrivateChannel"), constant("publishOnPrivateChannel"), constant("addedContextListenerOnPrivateChannel"), constant("removedContextListenerOnPrivateChannel"), constant("disconnectedFromPrivateChannel"), constant("startupContextOpened"));
const CollaborationObjectDecoder = object({
    channelId: optional(nonEmptyStringDecoder),
    contextType: optional(nonEmptyStringDecoder),
    payload: optional(contextDecoder)
});
const SystemMethodInvocationArgumentDecoder = object({
    action: SystemMethodActionDecoder,
    correlationId: nonEmptyStringDecoder,
    collaborationObject: optional(CollaborationObjectDecoder)
});
const FDC3StartupContextDecoder = object({
    fdc3: object({
        collaborationId: nonEmptyStringDecoder,
        openApp: object({
            appId: nonEmptyStringDecoder,
            instanceId: nonEmptyStringDecoder
        }),
        context: object({
            contextType: optional(string()),
            payload: contextDecoder
        })
    })
});
object({
    channelId: optional(nonEmptyStringDecoder)
});

class GlueController {
    channelsParser;
    channelsStateStore;
    glue;
    _logger;
    glueInitPromise;
    resolveGluePromise;
    rejectGluePromise;
    defaultGluePromiseTimeout = 120 * 1000;
    constructor(channelsParser, channelsStateStore) {
        this.channelsParser = channelsParser;
        this.channelsStateStore = channelsStateStore;
    }
    get gluePromise() {
        return this.glueInitPromise.then(this.initializeLogger.bind(this));
    }
    initialize(glue) {
        this.glue = glue;
        this.resolveGluePromise();
    }
    initializeFailed(reason) {
        this.rejectGluePromise(reason);
    }
    createGluePromise() {
        this.glueInitPromise = promisePlus(() => {
            return new Promise((resolve, reject) => {
                this.resolveGluePromise = resolve;
                this.rejectGluePromise = reject;
            });
        }, this.defaultGluePromiseTimeout, `Timeout of ${this.defaultGluePromiseTimeout}ms waiting for Glue to initialize`);
    }
    get logger() {
        return this._logger;
    }
    validateGlue(glue) {
        if (typeof glue !== "object" || Array.isArray(glue)) {
            return { isValid: false, error: { message: "Glue is not a valid object" } };
        }
        const apisToValidate = Object.keys(glue);
        const missingApis = defaultGlue42APIs.filter((api) => !apisToValidate.includes(api));
        if (missingApis.length) {
            return { isValid: false, error: { message: `Fdc3 cannot initialize correctly - Glue is missing the following ${missingApis.length > 1 ? "properties" : "property"}: ${missingApis.join(", ")}` } };
        }
        return { isValid: true };
    }
    interopInstance() {
        return this.glue.interop.instance;
    }
    getApplication(name) {
        return this.glue.appManager.application(name);
    }
    getApplicationInstances(appName) {
        return this.glue.appManager.instances().filter(inst => inst.application.name === appName);
    }
    getAppInstanceById(id) {
        return this.glue.appManager.instances().find(inst => inst.id === id);
    }
    async findIntents(intentFilter) {
        return this.glue.intents.find(intentFilter);
    }
    async raiseIntent(request) {
        return this.glue.intents.raise(request);
    }
    doesFilterHandlersExist() {
        return !!this.glue.intents.filterHandlers;
    }
    async filterHandlers(handlerFilter) {
        if (!this.glue.intents.filterHandlers) {
            throw new Error("Intents method 'filterHandlers' does not exist");
        }
        return this.glue.intents.filterHandlers(handlerFilter);
    }
    doesGetIntentsExist() {
        return !!this.glue.intents.getIntents;
    }
    getIntents(handler) {
        if (!this.glue.intents.getIntents) {
            throw new Error("Intents method 'getIntents' does not exist");
        }
        return this.glue.intents.getIntents(handler);
    }
    async getMyWindowContext() {
        const myWin = this.getMyWindow();
        if (!myWin) {
            return;
        }
        return myWin.getContext();
    }
    addIntentListener(intent, handler) {
        const registerMethodExists = this.glue.intents.register;
        return registerMethodExists
            ? this.glue.intents.register(intent, handler)
            : this.glue.intents.addIntentListener(intent, handler);
    }
    getAllContexts() {
        return this.glue.contexts.all();
    }
    async getContext(contextId) {
        return this.glue.contexts.get(contextId);
    }
    async updateContext(contextId, data) {
        return this.glue.contexts.update(contextId, data);
    }
    async updateContextWithLatestFdc3Type(contextId, context) {
        const { path, value } = this.channelsParser.parseFDC3ContextToGlueContexts(context);
        const latestTypePathValue = { path: "latest_fdc3_type", value: this.channelsParser.mapFDC3TypeToChannelsDelimiter(context.type) };
        await this.contextsSetPaths(contextId, [{ path: `data.${path}`, value: value }, latestTypePathValue]);
    }
    async channelsUpdate(data, options) {
        return this.glue.channels.publish(data, options);
    }
    getChannelsMode() {
        return this.glue.channels.mode;
    }
    async getMyChannels() {
        if (!this.glue.channels.getMyChannels) {
            const myChannel = await this.glue.channels.getMy();
            return [myChannel];
        }
        return this.glue.channels.getMyChannels();
    }
    async joinChannel(channelId) {
        return this.glue.channels.join(channelId);
    }
    async leaveChannel(options) {
        return this.glue.channels.leave(options);
    }
    getCurrentChannel() {
        if (!this.glue.channels.myChannels) {
            return this.glue.channels.my();
        }
        const myChannels = this.glue.channels.myChannels();
        return myChannels[myChannels.length - 1];
    }
    async getIoChannelNameByFDC3ChannelId(channelId) {
        const userChannels = await this.listAllChannels();
        return userChannels.find((channel) => channel.meta.fdc3?.id === channelId)?.name;
    }
    async getFDC3ChannelIdByIoChannelName(channelName) {
        const fdc3UserChannels = (await this.listAllChannels()).filter((channel) => channel.meta.fdc3);
        const searchedChannel = fdc3UserChannels.find((channel) => channel.name === channelName);
        return searchedChannel?.meta.fdc3.id;
    }
    getMyChannel() {
        return this.glue.channels.getMy();
    }
    setOnChannelChanged(callback) {
        if (!this.glue.channels.onChannelsChanged) {
            return this.glue.channels.changed(callback);
        }
        const wrappedCallback = (channels) => {
            const channelId = channels[channels.length - 1];
            callback(channelId);
        };
        return this.glue.channels.onChannelsChanged(wrappedCallback);
    }
    async getAllChannels() {
        return this.glue.channels.all();
    }
    async listAllChannels() {
        return this.glue.channels.list();
    }
    async getChannel(channelId) {
        return this.glue.channels.get(channelId);
    }
    getMyWindow() {
        const win = this.glue.windows.my();
        return isValidNonEmptyObject(win) ? win : undefined;
    }
    getMyInteropInstance() {
        return this.glue.interop.instance;
    }
    getGlueVersion() {
        return this.glue?.version;
    }
    registerOnInstanceStopped(cb) {
        return this.glue.appManager.onInstanceStopped(cb);
    }
    async unregisterMethod(methodName) {
        return this.glue.interop.unregister(methodName);
    }
    invokeSystemMethod(argumentObj, target) {
        SystemMethodInvocationArgumentDecoder.runWithException(argumentObj);
        return this.glue.interop.invoke(ioConnectFDC3SystemMethod, argumentObj, { instance: target });
    }
    registerMethod(name, handler) {
        return this.glue.interop.register(name, handler);
    }
    getInteropMethods(filter) {
        return this.glue.interop.methods(filter);
    }
    legacyChannelsSubscribe(callback, contextType) {
        const didReplay = { replayed: false };
        return this.glue.channels.subscribe(async (data, contextData, updaterId) => {
            if (this.isUpdateFromMe(updaterId) || !contextData || !contextData.latest_fdc3_type) {
                return;
            }
            const channelId = await this.getFDC3ChannelIdByIoChannelName(contextData.name);
            if (didReplay.replayed) {
                return this.parseDataAndInvokeSubscribeCallback({ callback, contextData, metadata: this.getContextMetadata(updaterId), contextType, channelId });
            }
            this.invokePreviouslyBroadcastedData({ callback, contextData, metadata: this.getContextMetadata(updaterId), contextType, channelId });
            didReplay.replayed = true;
        });
    }
    channelsSubscribe(callback, contextType) {
        const didReplay = { replayed: false };
        let prevContext;
        return this.glue.channels.subscribe(async (data, contextData, updaterId) => {
            if (this.isUpdateFromMe(updaterId) || !contextData || !data.fdc3) {
                return;
            }
            const channelId = await this.getFDC3ChannelIdByIoChannelName(contextData.name);
            if (contextType && data.fdc3.type !== contextType && !didReplay.replayed) {
                this.invokePreviouslyBroadcastedData({ callback, contextData, metadata: this.getContextMetadata(updaterId), contextType, channelId });
                didReplay.replayed = true;
                prevContext = data.fdc3;
                return;
            }
            if (prevContext && deepEqual$1(prevContext, data.fdc3, { strict: true })) {
                return;
            }
            callback(data.fdc3, this.getContextMetadata(updaterId), channelId);
            didReplay.replayed = true;
            prevContext = data.fdc3;
        });
    }
    contextsSubscribe(contextName, callback) {
        const didReplay = { replayed: false };
        return this.glue.contexts.subscribe(contextName, (contextData, addedData, removed, _, extraData) => {
            if (this.isUpdateFromMe(extraData?.updaterId)) {
                return;
            }
            if (!this.checkIfShouldInvokeInitialReplay(didReplay, contextData)) {
                return;
            }
            this.parseDataAndInvokeSubscribeCallback({ callback, contextData, metadata: this.getContextMetadata(extraData?.updaterId) });
        });
    }
    getInteropServers(methodFilter) {
        return this.glue.interop.servers(methodFilter);
    }
    initSubLogger(name) {
        return this.logger?.subLogger(name);
    }
    getPrefs(app) {
        return this.glue.prefs.get(app);
    }
    async checkIsFdc3DataWrappingSupported() {
        const globalBrowserNamespace = window.glue42core || window.iobrowser;
        const methodName = globalBrowserNamespace ? BrowserClientControlMethodName : DesktopClientControlMethodName;
        const myServer = this.glue.interop.servers().find((server) => server.instance === this.glue.interop.instance.instance);
        if (!myServer) {
            return false;
        }
        const registersControlMethod = myServer.getMethods().some((method) => method.name === methodName);
        if (!registersControlMethod) {
            return false;
        }
        const data = globalBrowserNamespace ? { domain: "system", operation: "isFdc3DataWrappingSupported" } : { command: "isFdc3DataWrappingSupported" };
        try {
            const res = await this.glue.interop.invoke(methodName, data, { instance: this.interopInstance().instance });
            return res.returned.isSupported;
        }
        catch (error) {
            return false;
        }
    }
    invokePreviouslyBroadcastedData({ callback, contextData, metadata, contextType, channelId }) {
        const invokeForType = contextType || this.channelsParser.mapChannelsDelimiterToFDC3Type(contextData.latest_fdc3_type);
        const dataForContextType = this.getLatestBroadcastedDataByContextType(contextData, invokeForType);
        if (dataForContextType) {
            callback(dataForContextType, metadata, channelId);
        }
    }
    isUpdateFromMe(updaterId) {
        return this.glue.interop.instance.peerId === updaterId;
    }
    getContextMetadata(updaterId) {
        const instanceServer = this.glue.interop.servers().find((server) => server.peerId === updaterId);
        if (!instanceServer) {
            return;
        }
        return {
            source: {
                appId: instanceServer.applicationName,
                instanceId: instanceServer.instance
            }
        };
    }
    initializeLogger() {
        this._logger = this.glue.logger;
    }
    parseDataAndInvokeSubscribeCallback({ callback, contextData, metadata, contextType, channelId }) {
        if (!contextType) {
            const parsedData = this.channelsParser.parseContextsDataToInitialFDC3Data({ data: contextData.data, latest_fdc3_type: contextData.latest_fdc3_type });
            callback(parsedData, metadata, channelId);
            return;
        }
        const latestPublishedType = this.channelsParser.mapChannelsDelimiterToFDC3Type(contextData.latest_fdc3_type);
        if (latestPublishedType !== contextType) {
            return;
        }
        const dataForContextType = this.getLatestBroadcastedDataByContextType(contextData, contextType);
        if (dataForContextType) {
            callback(dataForContextType, metadata, channelId);
        }
    }
    getLatestBroadcastedDataByContextType(contextData, contextType) {
        let foundData;
        Object.entries(contextData.data).forEach(([key, value]) => {
            if (!this.channelsParser.isFdc3DataKey(key)) {
                return;
            }
            const parsedType = this.channelsParser.revertGlueParsedTypeToInitialFDC3Type(key);
            if (parsedType !== contextType) {
                return;
            }
            foundData = { type: parsedType, ...value };
        });
        return foundData;
    }
    checkIfShouldInvokeInitialReplay(didReplay, contextData) {
        if (!didReplay.replayed) {
            didReplay.replayed = true;
            return false;
        }
        if (!contextData.latest_fdc3_type) {
            return false;
        }
        return true;
    }
    async contextsSetPaths(name, paths) {
        await this.glue.contexts.setPaths(name, paths);
    }
}

const GLUE42_EVENT_NAME = "Glue42";
const START = "start";
const NOTIFY_STARTED = "notifyStarted";
const REQUEST_GLUE = "requestGlue";
const REQUEST_GLUE_RESPONSE = "requestGlueResponse";
const FDC3_READY = "fdc3Ready";

class EventDispatcher {
    fireFdc3Ready() {
        const event = new Event(FDC3_READY);
        window.dispatchEvent(event);
    }
    fireNotifyStarted() {
        this.send(NOTIFY_STARTED);
    }
    fireRequestGlue() {
        this.send(REQUEST_GLUE);
    }
    send(eventName, message) {
        const payload = { glue42: { event: eventName, message } };
        const event = new CustomEvent(GLUE42_EVENT_NAME, { detail: payload });
        window.dispatchEvent(event);
    }
}

// To parse this data:
//
//   import { Convert, AgentErrorResponseMessage, AgentRequestMessage, AgentResponseMessage, BridgeErrorResponseMessage, BridgeRequestMessage, BridgeResponseMessage, BroadcastAgentRequest, BroadcastBridgeRequest, ConnectionStepMessage, ConnectionStep2Hello, ConnectionStep3Handshake, ConnectionStep4AuthenticationFailed, ConnectionStep6ConnectedAgentsUpdate, FindInstancesAgentErrorResponse, FindInstancesAgentRequest, FindInstancesAgentResponse, FindInstancesBridgeErrorResponse, FindInstancesBridgeRequest, FindInstancesBridgeResponse, FindIntentAgentErrorResponse, FindIntentAgentRequest, FindIntentAgentResponse, FindIntentBridgeErrorResponse, FindIntentBridgeRequest, FindIntentBridgeResponse, FindIntentsByContextAgentErrorResponse, FindIntentsByContextAgentRequest, FindIntentsByContextAgentResponse, FindIntentsByContextBridgeErrorResponse, FindIntentsByContextBridgeRequest, FindIntentsByContextBridgeResponse, GetAppMetadataAgentErrorResponse, GetAppMetadataAgentRequest, GetAppMetadataAgentResponse, GetAppMetadataBridgeErrorResponse, GetAppMetadataBridgeRequest, GetAppMetadataBridgeResponse, OpenAgentErrorResponse, OpenAgentRequest, OpenAgentResponse, OpenBridgeErrorResponse, OpenBridgeRequest, OpenBridgeResponse, PrivateChannelBroadcastAgentRequest, PrivateChannelBroadcastBridgeRequest, PrivateChannelEventListenerAddedAgentRequest, PrivateChannelEventListenerAddedBridgeRequest, PrivateChannelEventListenerRemovedAgentRequest, PrivateChannelEventListenerRemovedBridgeRequest, PrivateChannelOnAddContextListenerAgentRequest, PrivateChannelOnAddContextListenerBridgeRequest, PrivateChannelOnDisconnectAgentRequest, PrivateChannelOnDisconnectBridgeRequest, PrivateChannelOnUnsubscribeAgentRequest, PrivateChannelOnUnsubscribeBridgeRequest, RaiseIntentAgentErrorResponse, RaiseIntentAgentRequest, RaiseIntentAgentResponse, RaiseIntentBridgeErrorResponse, RaiseIntentBridgeRequest, RaiseIntentBridgeResponse, RaiseIntentResultAgentErrorResponse, RaiseIntentResultAgentResponse, RaiseIntentResultBridgeErrorResponse, RaiseIntentResultBridgeResponse, Context } from "./file";
//
//   const fDC3DesktopAgentAPISchema = Convert.toFDC3DesktopAgentAPISchema(json);
//   const agentErrorResponseMessage = Convert.toAgentErrorResponseMessage(json);
//   const agentRequestMessage = Convert.toAgentRequestMessage(json);
//   const agentResponseMessage = Convert.toAgentResponseMessage(json);
//   const bridgeErrorResponseMessage = Convert.toBridgeErrorResponseMessage(json);
//   const bridgeRequestMessage = Convert.toBridgeRequestMessage(json);
//   const bridgeResponseMessage = Convert.toBridgeResponseMessage(json);
//   const broadcastAgentRequest = Convert.toBroadcastAgentRequest(json);
//   const broadcastBridgeRequest = Convert.toBroadcastBridgeRequest(json);
//   const bridgingCommons = Convert.toBridgingCommons(json);
//   const connectionStepMessage = Convert.toConnectionStepMessage(json);
//   const connectionStep2Hello = Convert.toConnectionStep2Hello(json);
//   const connectionStep3Handshake = Convert.toConnectionStep3Handshake(json);
//   const connectionStep4AuthenticationFailed = Convert.toConnectionStep4AuthenticationFailed(json);
//   const connectionStep6ConnectedAgentsUpdate = Convert.toConnectionStep6ConnectedAgentsUpdate(json);
//   const findInstancesAgentErrorResponse = Convert.toFindInstancesAgentErrorResponse(json);
//   const findInstancesAgentRequest = Convert.toFindInstancesAgentRequest(json);
//   const findInstancesAgentResponse = Convert.toFindInstancesAgentResponse(json);
//   const findInstancesBridgeErrorResponse = Convert.toFindInstancesBridgeErrorResponse(json);
//   const findInstancesBridgeRequest = Convert.toFindInstancesBridgeRequest(json);
//   const findInstancesBridgeResponse = Convert.toFindInstancesBridgeResponse(json);
//   const findIntentAgentErrorResponse = Convert.toFindIntentAgentErrorResponse(json);
//   const findIntentAgentRequest = Convert.toFindIntentAgentRequest(json);
//   const findIntentAgentResponse = Convert.toFindIntentAgentResponse(json);
//   const findIntentBridgeErrorResponse = Convert.toFindIntentBridgeErrorResponse(json);
//   const findIntentBridgeRequest = Convert.toFindIntentBridgeRequest(json);
//   const findIntentBridgeResponse = Convert.toFindIntentBridgeResponse(json);
//   const findIntentsByContextAgentErrorResponse = Convert.toFindIntentsByContextAgentErrorResponse(json);
//   const findIntentsByContextAgentRequest = Convert.toFindIntentsByContextAgentRequest(json);
//   const findIntentsByContextAgentResponse = Convert.toFindIntentsByContextAgentResponse(json);
//   const findIntentsByContextBridgeErrorResponse = Convert.toFindIntentsByContextBridgeErrorResponse(json);
//   const findIntentsByContextBridgeRequest = Convert.toFindIntentsByContextBridgeRequest(json);
//   const findIntentsByContextBridgeResponse = Convert.toFindIntentsByContextBridgeResponse(json);
//   const getAppMetadataAgentErrorResponse = Convert.toGetAppMetadataAgentErrorResponse(json);
//   const getAppMetadataAgentRequest = Convert.toGetAppMetadataAgentRequest(json);
//   const getAppMetadataAgentResponse = Convert.toGetAppMetadataAgentResponse(json);
//   const getAppMetadataBridgeErrorResponse = Convert.toGetAppMetadataBridgeErrorResponse(json);
//   const getAppMetadataBridgeRequest = Convert.toGetAppMetadataBridgeRequest(json);
//   const getAppMetadataBridgeResponse = Convert.toGetAppMetadataBridgeResponse(json);
//   const openAgentErrorResponse = Convert.toOpenAgentErrorResponse(json);
//   const openAgentRequest = Convert.toOpenAgentRequest(json);
//   const openAgentResponse = Convert.toOpenAgentResponse(json);
//   const openBridgeErrorResponse = Convert.toOpenBridgeErrorResponse(json);
//   const openBridgeRequest = Convert.toOpenBridgeRequest(json);
//   const openBridgeResponse = Convert.toOpenBridgeResponse(json);
//   const privateChannelBroadcastAgentRequest = Convert.toPrivateChannelBroadcastAgentRequest(json);
//   const privateChannelBroadcastBridgeRequest = Convert.toPrivateChannelBroadcastBridgeRequest(json);
//   const privateChannelEventListenerAddedAgentRequest = Convert.toPrivateChannelEventListenerAddedAgentRequest(json);
//   const privateChannelEventListenerAddedBridgeRequest = Convert.toPrivateChannelEventListenerAddedBridgeRequest(json);
//   const privateChannelEventListenerRemovedAgentRequest = Convert.toPrivateChannelEventListenerRemovedAgentRequest(json);
//   const privateChannelEventListenerRemovedBridgeRequest = Convert.toPrivateChannelEventListenerRemovedBridgeRequest(json);
//   const privateChannelOnAddContextListenerAgentRequest = Convert.toPrivateChannelOnAddContextListenerAgentRequest(json);
//   const privateChannelOnAddContextListenerBridgeRequest = Convert.toPrivateChannelOnAddContextListenerBridgeRequest(json);
//   const privateChannelOnDisconnectAgentRequest = Convert.toPrivateChannelOnDisconnectAgentRequest(json);
//   const privateChannelOnDisconnectBridgeRequest = Convert.toPrivateChannelOnDisconnectBridgeRequest(json);
//   const privateChannelOnUnsubscribeAgentRequest = Convert.toPrivateChannelOnUnsubscribeAgentRequest(json);
//   const privateChannelOnUnsubscribeBridgeRequest = Convert.toPrivateChannelOnUnsubscribeBridgeRequest(json);
//   const raiseIntentAgentErrorResponse = Convert.toRaiseIntentAgentErrorResponse(json);
//   const raiseIntentAgentRequest = Convert.toRaiseIntentAgentRequest(json);
//   const raiseIntentAgentResponse = Convert.toRaiseIntentAgentResponse(json);
//   const raiseIntentBridgeErrorResponse = Convert.toRaiseIntentBridgeErrorResponse(json);
//   const raiseIntentBridgeRequest = Convert.toRaiseIntentBridgeRequest(json);
//   const raiseIntentBridgeResponse = Convert.toRaiseIntentBridgeResponse(json);
//   const raiseIntentResultAgentErrorResponse = Convert.toRaiseIntentResultAgentErrorResponse(json);
//   const raiseIntentResultAgentResponse = Convert.toRaiseIntentResultAgentResponse(json);
//   const raiseIntentResultBridgeErrorResponse = Convert.toRaiseIntentResultBridgeErrorResponse(json);
//   const raiseIntentResultBridgeResponse = Convert.toRaiseIntentResultBridgeResponse(json);
//   const context = Convert.toContext(json);
//
// These functions will throw an error if the JSON doesn't
// match the expected interface, even if the JSON is valid.
// Converts JSON strings to/from your types
// and asserts the results of JSON.parse at runtime

/**
 * SPDX-License-Identifier: Apache-2.0
 * Copyright FINOS FDC3 contributors - see NOTICE file
 */
/** Constants representing the errors that can be encountered when calling the `open` method on the DesktopAgent object (`fdc3`). */
var OpenError;
(function (OpenError) {
    /** Returned if the specified application is not found.*/
    OpenError["AppNotFound"] = "AppNotFound";
    /** Returned if the specified application fails to launch correctly.*/
    OpenError["ErrorOnLaunch"] = "ErrorOnLaunch";
    /** Returned if the specified application launches but fails to add a context listener in order to receive the context passed to the `fdc3.open` call.*/
    OpenError["AppTimeout"] = "AppTimeout";
    /** Returned if the FDC3 desktop agent implementation is not currently able to handle the request.*/
    OpenError["ResolverUnavailable"] = "ResolverUnavailable";
    /** Returned if a call to the `open` function is made with an invalid context argument. Contexts should be Objects with at least a `type` field that has a `string` value.*/
    OpenError["MalformedContext"] = "MalformedContext";
    /** @experimental Returned if the specified Desktop Agent is not found, via a connected Desktop Agent Bridge.*/
    OpenError["DesktopAgentNotFound"] = "DesktopAgentNotFound";
})(OpenError || (OpenError = {}));
/** Constants representing the errors that can be encountered when calling the `findIntent`, `findIntentsByContext`, `raiseIntent` or `raiseIntentForContext` methods on the DesktopAgent (`fdc3`). */
var ResolveError;
(function (ResolveError) {
    /** SHOULD be returned if no apps are available that can resolve the intent and context combination.*/
    ResolveError["NoAppsFound"] = "NoAppsFound";
    /** Returned if the FDC3 desktop agent implementation is not currently able to handle the request.*/
    ResolveError["ResolverUnavailable"] = "ResolverUnavailable";
    /** Returned if the user cancelled the resolution request, for example by closing or cancelling a resolver UI.*/
    ResolveError["UserCancelled"] = "UserCancelledResolution";
    /** SHOULD be returned if a timeout cancels an intent resolution that required user interaction. Please use `ResolverUnavailable` instead for situations where a resolver UI or similar fails.*/
    ResolveError["ResolverTimeout"] = "ResolverTimeout";
    /** Returned if a specified target application is not available or a new instance of it cannot be opened. */
    ResolveError["TargetAppUnavailable"] = "TargetAppUnavailable";
    /** Returned if a specified target application instance is not available, for example because it has been closed. */
    ResolveError["TargetInstanceUnavailable"] = "TargetInstanceUnavailable";
    /** Returned if the intent and context could not be delivered to the selected application or instance, for example because it has not added an intent handler within a timeout.*/
    ResolveError["IntentDeliveryFailed"] = "IntentDeliveryFailed";
    /** Returned if a call to one of the `raiseIntent` functions is made with an invalid context argument. Contexts should be Objects with at least a `type` field that has a `string` value.*/
    ResolveError["MalformedContext"] = "MalformedContext";
    /** @experimental Returned if the specified Desktop Agent is not found, via a connected Desktop Agent Bridge.*/
    ResolveError["DesktopAgentNotFound"] = "DesktopAgentNotFound";
})(ResolveError || (ResolveError = {}));
var ResultError;
(function (ResultError) {
    /** Returned if the intent handler exited without returning a valid result (a promise resolving to a Context, Channel object or void). */
    ResultError["NoResultReturned"] = "NoResultReturned";
    /** Returned if the Intent handler function processing the raised intent throws an error or rejects the Promise it returned. */
    ResultError["IntentHandlerRejected"] = "IntentHandlerRejected";
})(ResultError || (ResultError = {}));
var ChannelError;
(function (ChannelError) {
    /** Returned if the specified channel is not found when attempting to join a channel via the `joinUserChannel` function  of the DesktopAgent (`fdc3`).*/
    ChannelError["NoChannelFound"] = "NoChannelFound";
    /** SHOULD be returned when a request to join a user channel or to a retrieve a Channel object via the `joinUserChannel` or `getOrCreateChannel` methods of the DesktopAgent (`fdc3`) object is denied. */
    ChannelError["AccessDenied"] = "AccessDenied";
    /** SHOULD be returned when a channel cannot be created or retrieved via the `getOrCreateChannel` method of the DesktopAgent (`fdc3`).*/
    ChannelError["CreationFailed"] = "CreationFailed";
    /** Returned if a call to the `broadcast` functions is made with an invalid context argument. Contexts should be Objects with at least a `type` field that has a `string` value.*/
    ChannelError["MalformedContext"] = "MalformedContext";
})(ChannelError || (ChannelError = {}));
var BridgingError;
(function (BridgingError) {
    /** @experimental Returned if a Desktop Agent did not return a response, via Desktop Agent Bridging, within the alloted timeout. */
    BridgingError["ResponseTimedOut"] = "ResponseToBridgeTimedOut";
    /** @experimental Returned if a Desktop Agent that has been targeted by a particular request has been disconnected from the Bridge before a response has been received from it. */
    BridgingError["AgentDisconnected"] = "AgentDisconnected";
    /** @experimental Returned for FDC3 API calls that are specified with arguments indicating that a remote Desktop agent should be targeted (e.g. raiseIntent with an app on a remote DesktopAgent targeted), when the local Desktop Agent is not connected to a bridge. */
    BridgingError["NotConnectedToBridge"] = "NotConnectedToBridge";
    /** @experimental Returned if a message to a Bridge deviates from the schema for that message sufficiently that it could not be processed. */
    BridgingError["MalformedMessage"] = "MalformedMessage";
})(BridgingError || (BridgingError = {}));

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Ensures at compile time that the given string tuple is exhaustive on a given union type, i.e. contains ALL possible values of the given UNION_TYPE.
 */
var exhaustiveStringTuple = function () { return function () {
    var tuple = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        tuple[_i] = arguments[_i];
    }
    return tuple;
}; };

var STANDARD_CONTEXT_TYPES = exhaustiveStringTuple()('fdc3.action', 'fdc3.chart', 'fdc3.chat.initSettings', 'fdc3.chat.message', 'fdc3.chat.room', 'fdc3.chat.searchCriteria', 'fdc3.contact', 'fdc3.contactList', 'fdc3.country', 'fdc3.currency', 'fdc3.email', 'fdc3.instrument', 'fdc3.instrumentList', 'fdc3.interaction', 'fdc3.message', 'fdc3.organization', 'fdc3.portfolio', 'fdc3.position', 'fdc3.nothing', 'fdc3.timerange', 'fdc3.transactionResult', 'fdc3.valuation');
// used internally to check if a given intent/context is a standard one
new Set(STANDARD_CONTEXT_TYPES);

var STANDARD_INTENTS = exhaustiveStringTuple()('CreateInteraction', 'SendChatMessage', 'StartCall', 'StartChat', 'StartEmail', 'ViewAnalysis', 'ViewChat', 'ViewChart', 'ViewContact', 'ViewHoldings', 'ViewInstrument', 'ViewInteractions', 'ViewMessages', 'ViewNews', 'ViewOrders', 'ViewProfile', 'ViewQuote', 'ViewResearch');
// used internally to check if a given intent/context is a standard one
new Set(STANDARD_INTENTS);

/**
 * SPDX-License-Identifier: Apache-2.0
 * Copyright FINOS FDC3 contributors - see NOTICE file
 */
/**
 * @deprecated Use {@link StandardContextType} instead
 */
var ContextTypes;
(function (ContextTypes) {
    ContextTypes["Chart"] = "fdc3.chart";
    ContextTypes["ChatInitSettings"] = "fdc3.chat.initSettings";
    ContextTypes["ChatRoom"] = "fdc3.chat.room";
    ContextTypes["Contact"] = "fdc3.contact";
    ContextTypes["ContactList"] = "fdc3.contactList";
    ContextTypes["Country"] = "fdc3.country";
    ContextTypes["Currency"] = "fdc3.currency";
    ContextTypes["Email"] = "fdc3.email";
    ContextTypes["Instrument"] = "fdc3.instrument";
    ContextTypes["InstrumentList"] = "fdc3.instrumentList";
    ContextTypes["Interaction"] = "fdc3.interaction";
    ContextTypes["Nothing"] = "fdc3.nothing";
    ContextTypes["Organization"] = "fdc3.organization";
    ContextTypes["Portfolio"] = "fdc3.portfolio";
    ContextTypes["Position"] = "fdc3.position";
    ContextTypes["ChatSearchCriteria"] = "fdc3.chat.searchCriteria";
    ContextTypes["TimeRange"] = "fdc3.timerange";
    ContextTypes["TransactionResult"] = "fdc3.transactionResult";
    ContextTypes["Valuation"] = "fdc3.valuation";
})(ContextTypes || (ContextTypes = {}));

/**
 * SPDX-License-Identifier: Apache-2.0
 * Copyright FINOS FDC3 contributors - see NOTICE file
 */
/**
 * @deprecated Use {@link StandardIntent} instead
 */
var Intents;
(function (Intents) {
    Intents["CreateInteraction"] = "CreateInteraction";
    Intents["SendChatMessage"] = "SendChatMessage";
    Intents["StartCall"] = "StartCall";
    Intents["StartChat"] = "StartChat";
    Intents["StartEmail"] = "StartEmail";
    Intents["ViewAnalysis"] = "ViewAnalysis";
    Intents["ViewChat"] = "ViewChat";
    Intents["ViewChart"] = "ViewChart";
    Intents["ViewContact"] = "ViewContact";
    Intents["ViewHoldings"] = "ViewHoldings";
    Intents["ViewInstrument"] = "ViewInstrument";
    Intents["ViewInteractions"] = "ViewInteractions";
    Intents["ViewMessages"] = "ViewMessages";
    Intents["ViewNews"] = "ViewNews";
    Intents["ViewOrders"] = "ViewOrders";
    Intents["ViewProfile"] = "ViewProfile";
    Intents["ViewQuote"] = "ViewQuote";
    Intents["ViewResearch"] = "ViewResearch";
})(Intents || (Intents = {}));

class DesktopAgent {
    intentsController;
    applicationController;
    channelsController;
    constructor(intentsController, applicationController, channelsController) {
        this.intentsController = intentsController;
        this.applicationController = applicationController;
        this.channelsController = channelsController;
    }
    toApi() {
        const api = {
            getStartupContext: this.getStartupContext.bind(this),
            addContextListener: this.addContextListener.bind(this),
            addIntentListener: this.addIntentListener.bind(this),
            broadcast: this.broadcast.bind(this),
            createPrivateChannel: this.createPrivateChannel.bind(this),
            findInstances: this.findInstances.bind(this),
            findIntent: this.findIntent.bind(this),
            findIntentsByContext: this.findIntentsByContext.bind(this),
            getAppMetadata: this.getAppMetadata.bind(this),
            getCurrentChannel: this.getCurrentChannel.bind(this),
            getInfo: this.getInfo.bind(this),
            getOrCreateChannel: this.getOrCreateChannel.bind(this),
            getSystemChannels: this.getSystemChannels.bind(this),
            getUserChannels: this.getSystemChannels.bind(this),
            joinChannel: this.joinChannel.bind(this),
            joinUserChannel: this.joinUserChannel.bind(this),
            leaveCurrentChannel: this.leaveCurrentChannel.bind(this),
            open: this.open.bind(this),
            raiseIntent: this.raiseIntent.bind(this),
            raiseIntentForContext: this.raiseIntentForContext.bind(this),
            getCurrentChannels: this.getCurrentChannels.bind(this),
            leaveChannel: this.leaveChannel.bind(this),
            leaveCurrentChannels: this.leaveCurrentChannels.bind(this)
        };
        return api;
    }
    async open(target, context) {
        targetAppDecoder.runWithException(target);
        const contextDecoderResult = optionalContextDecoder.run(context);
        if (!contextDecoderResult.ok) {
            throw new Error(OpenError.MalformedContext);
        }
        return this.applicationController.open({ commandId: generateCommandId(), target, context });
    }
    async findInstances(app) {
        appIdentifierDecoder.runWithException(app);
        return this.applicationController.findInstances({ commandId: generateCommandId(), appIdentifier: app });
    }
    async getAppMetadata(app) {
        appIdentifierDecoder.runWithException(app);
        return this.applicationController.getAppMetadata({ commandId: generateCommandId(), appIdentifier: app });
    }
    async getInfo() {
        return this.applicationController.getInfo({ commandId: generateCommandId() });
    }
    async broadcast(context) {
        const contextDecoderResult = contextDecoder.run(context);
        if (!contextDecoderResult.ok) {
            throw new Error(ChannelError.MalformedContext);
        }
        return this.channelsController.broadcast(generateCommandId(), context);
    }
    async addContextListener(contextType, handler) {
        if (arguments.length === 1) {
            if (typeof contextType !== "function") {
                throw new Error("Please provide the handler as a function!");
            }
            return this.channelsController.addContextListener({ commandId: generateCommandId(), handler: contextType });
        }
        const contextTypeDecoder = optionalNonEmptyStringDecoder.runWithException(contextType);
        if (typeof handler !== "function") {
            throw new Error("Please provide the handler as a function!");
        }
        return this.channelsController.addContextListener({ commandId: generateCommandId(), handler, contextType: contextTypeDecoder });
    }
    async findIntent(intent, context, resultType) {
        nonEmptyStringDecoder.runWithException(intent);
        const contextDecoderResult = optionalContextDecoder.run(context);
        if (!contextDecoderResult.ok) {
            throw new Error(ResolveError.MalformedContext);
        }
        optionalNonEmptyStringDecoder.runWithException(resultType);
        return this.intentsController.findIntent({ commandId: generateCommandId(), intent, context: contextDecoderResult.result, resultType });
    }
    async findIntentsByContext(context, resultType) {
        const contextDecoderResult = contextDecoder.run(context);
        if (!contextDecoderResult.ok) {
            throw new Error(ResolveError.MalformedContext);
        }
        optionalNonEmptyStringDecoder.runWithException(resultType);
        return this.intentsController.findIntentsByContext({ commandId: generateCommandId(), context: contextDecoderResult.result, resultType });
    }
    async raiseIntent(intent, context, app) {
        nonEmptyStringDecoder.runWithException(intent);
        const contextDecoderResult = contextDecoder.run(context);
        if (!contextDecoderResult.ok) {
            throw new Error(ResolveError.MalformedContext);
        }
        optionalAppIdentifier.runWithException(app);
        return this.intentsController.raiseIntent({ commandId: generateCommandId(), intent, context, target: app });
    }
    async raiseIntentForContext(context, app) {
        const contextDecoderResult = contextDecoder.run(context);
        if (!contextDecoderResult.ok) {
            throw new Error(ResolveError.MalformedContext);
        }
        optionalTargetApp.runWithException(app);
        return this.intentsController.raiseIntentForContext({ commandId: generateCommandId(), context, target: app });
    }
    async addIntentListener(intent, handler) {
        nonEmptyStringDecoder.runWithException(intent);
        if (typeof handler !== "function") {
            throw new Error("Please provide the handler as a function!");
        }
        return this.intentsController.addIntentListener({ commandId: generateCommandId(), intent, handler });
    }
    async getStartupContext() {
        return this.channelsController.getStartupContext();
    }
    async getOrCreateChannel(channelId) {
        nonEmptyStringDecoder.runWithException(channelId);
        return this.channelsController.getOrCreateChannel({ commandId: generateCommandId(), channelId });
    }
    async getSystemChannels() {
        return this.channelsController.getUserChannels(generateCommandId());
    }
    async joinChannel(channelId) {
        nonEmptyStringDecoder.runWithException(channelId);
        return this.channelsController.joinUserChannel({ commandId: generateCommandId(), channelId });
    }
    async joinUserChannel(channelId) {
        nonEmptyStringDecoder.runWithException(channelId);
        return this.channelsController.joinUserChannel({ commandId: generateCommandId(), channelId });
    }
    async getCurrentChannel() {
        return this.channelsController.getCurrentChannel(generateCommandId());
    }
    async leaveCurrentChannel() {
        return this.channelsController.leaveCurrentChannel(generateCommandId());
    }
    async createPrivateChannel() {
        return this.channelsController.createPrivateChannel(generateCommandId());
    }
    async getCurrentChannels() {
        return this.channelsController.getCurrentChannels(generateCommandId());
    }
    async leaveChannel(channelId) {
        nonEmptyStringDecoder.runWithException(channelId);
        return this.channelsController.leave(generateCommandId(), { channelId });
    }
    async leaveCurrentChannels() {
        return this.channelsController.leave(generateCommandId());
    }
}

class AppChannel {
    channelsController;
    id;
    type = ChannelTypes.App;
    constructor(channelsController, id) {
        this.channelsController = channelsController;
        this.id = id;
    }
    toApi() {
        const api = {
            id: this.id,
            type: this.type,
            broadcast: this.broadcast.bind(this),
            getCurrentContext: this.getCurrentContext.bind(this),
            addContextListener: this.addContextListener.bind(this),
        };
        return api;
    }
    async broadcast(context) {
        const contextDecoderResult = contextDecoder.run(context);
        if (!contextDecoderResult.ok) {
            throw new Error(ChannelError.MalformedContext);
        }
        return this.channelsController.broadcast(generateCommandId(), context, this.id);
    }
    async getCurrentContext(contextType) {
        optionalNonEmptyStringDecoder.runWithException(contextType);
        return this.channelsController.getContextForChannel({ commandId: generateCommandId(), channelId: this.id, contextType });
    }
    async addContextListener(contextType, handler) {
        if (arguments.length === 1) {
            if (typeof contextType !== "function") {
                throw new Error("Please provide the handler as a function!");
            }
            return this.channelsController.addContextListener({ commandId: generateCommandId(), handler: contextType, channelId: this.id });
        }
        const contextTypeDecoder = optionalNonEmptyStringDecoder.runWithException(contextType);
        if (typeof handler !== "function") {
            throw new Error("Please provide the handler as a function!");
        }
        return this.channelsController.addContextListener({ commandId: generateCommandId(), handler, contextType: contextTypeDecoder, channelId: this.id });
    }
}

class ChannelsParser {
    fdc3Delimiter = "&";
    channelsFdc3DataPrefix = "fdc3_";
    mapChannelNameToContextName(channelName) {
        return `${glueChannelNamePrefix}${channelName}`;
    }
    parseContextsDataToInitialFDC3Data(context) {
        const { data, latest_fdc3_type } = context;
        const parsedType = this.mapChannelsDelimiterToFDC3Type(latest_fdc3_type);
        return { type: parsedType, ...data[`${this.channelsFdc3DataPrefix}${latest_fdc3_type}`] };
    }
    revertGlueParsedTypeToInitialFDC3Type(string) {
        const withoutPrefix = string.replace(this.channelsFdc3DataPrefix, "");
        return this.mapChannelsDelimiterToFDC3Type(withoutPrefix);
    }
    parseFDC3ContextToGlueContexts(context) {
        const { type, ...rest } = context;
        const parsedType = this.mapFDC3TypeToChannelsDelimiter(type);
        return { path: `${this.channelsFdc3DataPrefix}${parsedType}`, value: rest };
    }
    mapFDC3TypeToChannelsDelimiter(type) {
        return type.split(".").join(this.fdc3Delimiter);
    }
    isFdc3DataKey(key) {
        return !!key.startsWith(this.channelsFdc3DataPrefix);
    }
    mapChannelsDelimiterToFDC3Type(type) {
        return type.split(this.fdc3Delimiter).join(".");
    }
}

class UserChannel {
    channelsController;
    id;
    type = ChannelTypes.User;
    displayMetadata;
    constructor(channelsController, glueChannel) {
        this.channelsController = channelsController;
        this.id = glueChannel.meta.fdc3
            ? glueChannel.meta.fdc3.id
            : glueChannel.name;
        this.displayMetadata = {
            name: glueChannel.name,
            color: glueChannel.meta.color
        };
    }
    toApi() {
        const api = {
            id: this.id,
            type: this.type,
            displayMetadata: this.displayMetadata,
            broadcast: this.broadcast.bind(this),
            getCurrentContext: this.getCurrentContext.bind(this),
            addContextListener: this.addContextListener.bind(this),
        };
        return api;
    }
    async broadcast(context) {
        const contextDecoderResult = contextDecoder.run(context);
        if (!contextDecoderResult.ok) {
            throw new Error(ChannelError.MalformedContext);
        }
        return this.channelsController.broadcast(generateCommandId(), context, this.id);
    }
    async getCurrentContext(contextType) {
        optionalNonEmptyStringDecoder.run(contextType);
        return this.channelsController.getContextForChannel({ commandId: generateCommandId(), channelId: this.id, contextType });
    }
    async addContextListener(contextType, handler) {
        if (arguments.length === 1) {
            if (typeof contextType !== "function") {
                throw { message: ChannelError.AccessDenied, reason: `Expected function as an argument, got ${typeof contextType}` };
            }
            return this.channelsController.addContextListener({ commandId: generateCommandId(), handler: contextType, channelId: this.id });
        }
        const contextTypeDecoder = optionalNonEmptyStringDecoder.runWithException(contextType);
        if (typeof handler !== "function") {
            throw { message: ChannelError.AccessDenied, reason: `Expected function as an argument, got ${typeof handler}` };
        }
        return this.channelsController.addContextListener({ commandId: generateCommandId(), handler, contextType: contextTypeDecoder, channelId: this.id });
    }
}

const isChannel = (data) => {
    return defaultChannelsProps.every(prop => Object.keys(data).includes(prop));
};
const isContext = (data) => {
    return defaultContextProps.every(prop => Object.keys(data).includes(prop));
};
const extractChannelMetadata = (channel) => {
    return {
        id: channel.id,
        type: channel.type,
        displayMetadata: channel.displayMetadata
    };
};
const parseContextHandler = (handler, contextType) => {
    const subHandler = (data, metadata, channelId) => {
        if (contextType) {
            if (data.type === contextType) {
                handler(data, metadata, channelId);
            }
            return;
        }
        handler(data, metadata, channelId);
    };
    return subHandler;
};

class IntentsController {
    glueController;
    channelsController;
    channelsFactory;
    glueEventsController;
    _logger;
    ioToFDC3ErrorsDict = {
        [IO_ERRORS.USER_CANCELLED]: ResolveError.UserCancelled,
        [IO_ERRORS.TIMEOUT_HIT]: ResolveError.IntentDeliveryFailed,
        [IO_ERRORS.TARGET_INSTANCE_UNAVAILABLE]: ResolveError.TargetInstanceUnavailable,
        [IO_ERRORS.RESOLVER_UNAVAILABLE]: ResolveError.ResolverUnavailable,
        [IO_ERRORS.RESOLVER_TIMEOUT]: ResolveError.ResolverTimeout,
        [IO_ERRORS.INVALID_RESOLVER_RESPONSE]: ResolveError.IntentDeliveryFailed,
        [IO_ERRORS.INTENT_NOT_FOUND]: ResolveError.NoAppsFound,
        [IO_ERRORS.INTENT_DELIVERY_FAILED]: ResolveError.IntentDeliveryFailed,
        [IO_ERRORS.HANDLER_NOT_FOUND]: ResolveError.NoAppsFound,
        [IO_ERRORS.CALLER_NOT_DEFINED]: ResolveError.IntentDeliveryFailed,
        [IO_ERRORS.INTENT_HANDLER_REJECTION]: ResultError.IntentHandlerRejected
    };
    constructor(glueController, channelsController, channelsFactory, glueEventsController) {
        this.glueController = glueController;
        this.channelsController = channelsController;
        this.channelsFactory = channelsFactory;
        this.glueEventsController = glueEventsController;
    }
    get logger() {
        if (!this._logger) {
            this._logger = this.glueController.initSubLogger("fdc3.intents.controller");
        }
        return this._logger;
    }
    async findIntent({ commandId, intent, context, resultType }) {
        await this.glueController.gluePromise;
        this.logger?.info(`[${commandId}] - findIntent() invoked for intent ${intent} with contextType ${context?.type} and resultType ${resultType}`);
        const glueIntents = await this.glueController.findIntents({ name: intent });
        if (!glueIntents.length) {
            throw { message: ResolveError.NoAppsFound, reason: `There are no apps handling the passed intent ${intent}` };
        }
        const searchedGlueIntent = glueIntents.find((glueIntent) => glueIntent.name === intent);
        if (!searchedGlueIntent) {
            throw { message: ResolveError.NoAppsFound, reason: `There are no apps handling the passed intent ${intent}` };
        }
        if (!context && !resultType) {
            return this.convertGlue42IntentToFDC3Intent(searchedGlueIntent);
        }
        const contextType = (context && context.type === fdc3NothingContextType) ? undefined : context?.type;
        const filteredIntent = this.getGlueIntentWithFilteredHandlers(searchedGlueIntent, { contextType, resultType });
        if (!filteredIntent.handlers.length) {
            throw { message: ResolveError.NoAppsFound, reason: `No apps handling intent ${intent} with contextType ${context?.type} and resultType ${resultType}` };
        }
        return this.convertGlue42IntentToFDC3Intent(filteredIntent);
    }
    async findIntentsByContext({ commandId, context, resultType }) {
        await this.glueController.gluePromise;
        this.logger?.info(`[${commandId}] - findIntentsByContext() invoked for context type ${context.type} and resultType ${resultType}`);
        const glueIntents = await this.glueController.findIntents({ contextType: context.type, resultType });
        if (!glueIntents.length) {
            throw { message: ResolveError.NoAppsFound, reason: `No apps registering intent with contextType ${context.type} ${resultType ? `and resultType ${resultType}` : ""}` };
        }
        this.logger?.info(`[${commandId}] - parsing glue intents to fdc3 intents and returning`);
        return glueIntents.map((glueIntent) => {
            const intentWithFilteredHandlers = this.getGlueIntentWithFilteredHandlers(glueIntent, { contextType: context.type, resultType });
            return this.convertGlue42IntentToFDC3Intent(intentWithFilteredHandlers);
        });
    }
    async raiseIntent({ commandId, intent, context, target }) {
        await this.glueController.gluePromise;
        this.logger?.info(`[${commandId}] - raiseIntent() invoked for intent ${intent} with contextType: ${context.type} and target: ${target}`);
        const glueContext = { type: context.type, data: { ...context } };
        const searchedGlueIntent = (await this.glueController.findIntents({ name: intent })).find(glueIntent => glueIntent.name === intent);
        if (!searchedGlueIntent) {
            throw { message: ResolveError.NoAppsFound, reason: `There's no app registering an intent '${intent}'` };
        }
        if (!target) {
            const filteredGlueIntent = this.filterGlueIntentHandlers({ commandId, intent: searchedGlueIntent, context, target });
            this.logger?.info(`[${commandId}] - raising intent ${intent} with contextType ${context.type} and handlers ${filteredGlueIntent.handlers.map(h => h.applicationName && h.instanceId)}`);
            return this.invokeRaiseIntent(commandId, { intent, context: glueContext, handlers: filteredGlueIntent.handlers });
        }
        if (target?.instanceId) {
            this.logger?.info(`[${commandId}] - raising intent ${intent} with contextType ${context.type} to target instance of app ${target.appId} and id ${target.instanceId}`);
            return this.invokeRaiseIntent(commandId, {
                intent,
                context: glueContext,
                target: { instance: target.instanceId }
            });
        }
        const targetAppName = typeof target === "string" ? target : target.appId;
        return this.invokeRaiseIntent(commandId, {
            intent,
            context: glueContext,
            target: { app: targetAppName }
        });
    }
    async raiseIntentForContext({ commandId, context, target }) {
        await this.glueController.gluePromise;
        this.logger?.info(`[${commandId}] - raiseIntentForContext() invoked with contextType ${context.type} and target ${target}`);
        const filteredHandlersMethodExist = this.glueController.doesFilterHandlersExist();
        const getIntentsMethodExist = this.glueController.doesGetIntentsExist();
        const rememberedIntentHandlerForContextType = await this.checkForRememberedIntentHandlerForContext(context.type);
        const glueContext = { type: context.type, data: { ...context } };
        if (rememberedIntentHandlerForContextType) {
            return this.invokeRaiseIntent(commandId, { context: glueContext, intent: rememberedIntentHandlerForContextType.intent });
        }
        if (!filteredHandlersMethodExist || !getIntentsMethodExist || target) {
            return this.legacyRaiseIntentForContext({ commandId, context, target });
        }
        const filteredHandlersResPromise = this.glueController.filterHandlers({ contextTypes: [context.type] })
            .catch((err) => {
            throw this.parseIoToFdc3Error(err);
        });
        const { handlers } = await filteredHandlersResPromise;
        if (!handlers.length) {
            const errorMsg = `${ResolveError.NoAppsFound} - Cannot find Intent Handlers for intents with context type ${context.type}`;
            this._logger?.warn(`[${commandId}] - ${errorMsg}`);
            throw new Error(ResolveError.NoAppsFound);
        }
        if (handlers.length > 1) {
            return this.legacyRaiseIntentForContext({ commandId, context, target });
        }
        const handler = handlers[0];
        const { intents } = await this.glueController.getIntents(handler);
        const validIntent = intents.find((intentInfo) => intentInfo.contextTypes?.includes(context.type));
        if (!validIntent) {
            this.logger?.warn(`[${commandId}] - ${ResolveError.IntentDeliveryFailed} - There's no valid intent for handler ${JSON.stringify(handler)} and context type ${context.type}`);
            throw new Error(ResolveError.IntentDeliveryFailed);
        }
        return this.invokeRaiseIntent(commandId, {
            intent: validIntent.intent,
            context: glueContext,
            target: { app: handler.applicationName, instance: handler.instanceId }
        });
    }
    async addIntentListener({ commandId, intent, handler }) {
        await this.glueController.gluePromise;
        this.logger?.info(`[${commandId}] - addIntentListener() invoked for intent ${intent}`);
        const wrappedHandler = this.getWrappedIntentHandler(handler);
        return this.glueController.addIntentListener(intent, wrappedHandler);
    }
    async checkForRememberedIntentHandlerForContext(contextType) {
        let prefs;
        try {
            prefs = await this.glueController.getPrefs();
        }
        catch (error) {
            this._logger?.warn(`Cannot get prefs due to the following error: ${error}`);
            return;
        }
        const intentPrefs = prefs.data?.intents;
        if (!intentPrefs) {
            return;
        }
        const prefsForContextType = Object.entries(intentPrefs).find(([intentName, savedValue]) => savedValue.filter?.contextTypes?.includes(contextType));
        if (!prefsForContextType) {
            return;
        }
        const [intent, rememberedHandlerWithFilter] = prefsForContextType;
        return {
            intent,
            handler: rememberedHandlerWithFilter.handler
        };
    }
    filterGlueIntentHandlers({ commandId, intent, context, target }) {
        let filteredGlueIntent;
        filteredGlueIntent = this.filterIntentHandlersByContext(intent, context);
        if (!target) {
            this.logger?.info(`[${commandId}] - There's no passed target, intent handlers are filtered only by context type`);
            return filteredGlueIntent;
        }
        this.logger?.log(`[${commandId}] - filtering handlers by target (${JSON.stringify(target)}) for intent ${intent.name}`);
        filteredGlueIntent = this.filterIntentHandlersByTarget({ intent, target, commandId });
        return filteredGlueIntent;
    }
    filterIntentHandlersByTarget({ intent, target, commandId }) {
        const appName = typeof target === "string" ? target : target.appId;
        const instanceId = typeof target === "string" ? undefined : target.instanceId;
        this.logger?.info(`[${commandId}] - Checking if application with name ${appName} exists`);
        const app = this.glueController.getApplication(appName);
        const serverInstances = this.serverInstanceAsIntentHandler(intent.name);
        if (!app && (typeof target === "string" || !target.instanceId || !serverInstances.length)) {
            throw { message: ResolveError.TargetAppUnavailable, reason: `There's no app with appId ${appName}` };
        }
        this.logger?.info(`[${commandId}] - target app ${appName} found. Filtering handlers by applicationName: ${appName}`);
        const validHandlersByApplicationName = intent.handlers.filter((handler) => handler.applicationName === appName);
        if (!validHandlersByApplicationName.length) {
            throw { message: ResolveError.NoAppsFound, reason: `Intent ${intent.name} exists but there's no app with appId ${appName} registering it` };
        }
        if (!instanceId) {
            this.logger?.log(`[${commandId}] - returning all handlers for intent ${intent.name} and target: ${JSON.stringify(target)}`);
            return { name: intent.name, handlers: validHandlersByApplicationName };
        }
        const isValidInstanceOfTheApp = app
            ? app.instances.find((inst) => inst.id === instanceId)
            : serverInstances.find((inst) => inst.instance === instanceId);
        if (!isValidInstanceOfTheApp) {
            throw { message: ResolveError.TargetInstanceUnavailable, reason: `There's no instance with id ${instanceId} of the passed app ${appName}` };
        }
        this.logger?.info(`[${commandId}] - Filtering handlers by instanceId: ${instanceId}`);
        const validHandlersByInstanceId = validHandlersByApplicationName.filter((handler) => handler.instanceId === instanceId);
        if (!validHandlersByInstanceId.length) {
            throw { message: ResolveError.IntentDeliveryFailed, reason: `There's no instance with id ${instanceId} of app ${appName} registering intent ${intent.name}` };
        }
        return { name: intent.name, handlers: validHandlersByInstanceId };
    }
    serverInstanceAsIntentHandler(intentName) {
        const interopMethodName = `${IntentsMethodPrefix}${intentName}`;
        const servers = this.glueController.getInteropServers({ name: interopMethodName });
        return servers;
    }
    filterIntentHandlersByContext(intent, context) {
        const filteredGlueIntent = this.getGlueIntentWithFilteredHandlers(intent, { contextType: context.type });
        if (!filteredGlueIntent.handlers.length) {
            throw { message: ResolveError.NoAppsFound, reason: `There's no app registering an intent with the passed context type ${context.type}` };
        }
        return filteredGlueIntent;
    }
    async getResult(commandId, glueIntentResult) {
        this.logger?.info(`[${commandId}] - getResult() of IntentResolution invoked`);
        const { result } = glueIntentResult;
        if (result.fdc3error) {
            throw result.fdc3error;
        }
        if (!result || typeof result !== "object" || Array.isArray(result) || (isValidNonEmptyObject(result) && !result.fdc3intentContext && !result.fdc3intentChannel && !result.fdc3error)) {
            this.logger?.warn(`[${commandId}] - ${ResultError.NoResultReturned} - The intent handler exited without returning a valid result - a promise resolving to a Context, Channel object or void`);
            throw new Error(ResultError.NoResultReturned);
        }
        if (!isValidNonEmptyObject(result)) {
            return;
        }
        if (!result.fdc3intentChannel && !result.fdc3intentContext) {
            return result;
        }
        if (result.fdc3intentContext) {
            return result.fdc3intentContext.payload;
        }
        const { fdc3intentChannel } = result;
        if (fdc3intentChannel.type === ChannelTypes.User) {
            const glueChannel = (await this.glueController.listAllChannels()).find(ch => ch.name === fdc3intentChannel.displayMetadata.name);
            return this.channelsFactory.buildModel({ type: ChannelTypes.User, ...fdc3intentChannel, displayMetadata: { ...fdc3intentChannel.displayMetadata, glueChannel } });
        }
        if (fdc3intentChannel.type === ChannelTypes.App) {
            return this.channelsFactory.buildModel(fdc3intentChannel);
        }
        await this.glueEventsController.initializeCollaborateMethod();
        const channel = this.channelsController.buildPrivateChannel(fdc3intentChannel.id, commandId, false);
        channel.setCollaborator({ appId: glueIntentResult.handler.applicationName, instanceId: glueIntentResult.handler.instanceId }, commandId);
        const joinChannelArgs = {
            action: "joinPrivateChannel",
            correlationId: channel.id,
            collaborationObject: {
                channelId: channel.id
            }
        };
        await this.glueController.invokeSystemMethod(joinChannelArgs, glueIntentResult.handler.instanceId);
        this.logger?.info(`[${commandId}] - returning private channel`);
        return channel.toApi();
    }
    convertGlue42IntentToFDC3Intent(glueIntent) {
        const { name, handlers } = glueIntent;
        const appIntent = {
            intent: { name, displayName: handlers[0].displayName || "" },
            apps: handlers.map((handler) => {
                const appName = handler.applicationName;
                const app = this.glueController.getApplication(appName);
                return {
                    appId: appName,
                    instanceId: handler.instanceId,
                    name: appName,
                    title: handler.applicationTitle || handler.instanceTitle || appName,
                    tooltip: app?.userProperties.tooltip || `${appName} (${handler.type})`,
                    description: handler.applicationDescription,
                    icons: handler.applicationIcon ? [handler.applicationIcon, ...(app?.userProperties.icons || [])] : app?.userProperties.icons,
                    images: app?.userProperties.images,
                    resultType: handler.resultType
                };
            })
        };
        return appIntent;
    }
    getResultType(data) {
        if (isChannel(data)) {
            return IntentHandlerResultTypes.Channel;
        }
        if (isContext(data)) {
            return IntentHandlerResultTypes.Context;
        }
    }
    getWrappedIntentHandler(handler) {
        const wrappedHandler = async (glue42Context, caller) => {
            const contextMetadata = caller
                ? {
                    source: {
                        appId: caller.application || caller.applicationName || "",
                        instanceId: caller.instance
                    }
                }
                : undefined;
            let handlerResult;
            try {
                handlerResult = await handler({ ...glue42Context.data, type: glue42Context.type || "" }, contextMetadata);
            }
            catch (error) {
                this.logger?.warn(typeof error === "string" ? error : error.message || JSON.stringify(error));
                throw new Error(ResultError.IntentHandlerRejected);
            }
            if (!handlerResult) {
                return;
            }
            const handlerResultType = this.getResultType(handlerResult);
            if (!handlerResultType) {
                return {
                    fdc3error: { message: ResultError.NoResultReturned, reason: "The intent handler exited without returning a valid result - a promise resolving to a Context, Channel object or void" }
                };
            }
            return handlerResultType === IntentHandlerResultTypes.Channel
                ? { fdc3intentChannel: extractChannelMetadata(handlerResult) }
                : { fdc3intentContext: { contextType: handlerResult.type, payload: handlerResult } };
        };
        return wrappedHandler;
    }
    getGlueIntentWithFilteredHandlers(glueIntent, filter) {
        const { name, handlers } = glueIntent;
        let filteredHandlers = handlers;
        const contextType = filter.contextType;
        if (contextType) {
            filteredHandlers = handlers.filter((handler) => handler.instanceId ? true : handler.contextTypes?.includes(contextType));
        }
        const resultType = filter.resultType;
        if (resultType) {
            filteredHandlers = handlers.filter((handler) => handler.instanceId ? true : handler.resultType?.includes(resultType));
        }
        return { name, handlers: filteredHandlers };
    }
    async invokeRaiseIntent(commandId, request) {
        try {
            const glueIntentResult = await this.glueController.raiseIntent({ ...request, timeout: RaiseTimeoutMs });
            return {
                source: {
                    appId: glueIntentResult.handler.applicationName,
                    instanceId: glueIntentResult.handler.instanceId
                },
                intent: request.intent,
                getResult: (() => this.getResult(commandId, glueIntentResult)).bind(this)
            };
        }
        catch (error) {
            throw this.parseIoToFdc3Error(error);
        }
    }
    parseIoToFdc3Error(error) {
        const ioError = Object.keys(this.ioToFDC3ErrorsDict).find(((ioError) => error?.message?.includes(ioError)));
        const fdc3Error = ioError ? this.ioToFDC3ErrorsDict[ioError] : ResolveError.IntentDeliveryFailed;
        const stringifiedError = typeof error === "string" ? error : JSON.stringify(error);
        const reason = error instanceof Error ? error.message : stringifiedError;
        return { message: fdc3Error, reason };
    }
    async legacyRaiseIntentForContext({ commandId, context, target }) {
        this.logger?.info(`[${commandId}] - raiseIntentForContext() invoked with contextType ${context.type} and target ${target}`);
        const appIntents = await this.findIntentsByContext({ commandId, context });
        if (!appIntents || appIntents.length === 0) {
            throw {
                message: ResolveError.NoAppsFound,
                reason: `No apps registering intent with contextType ${context.type} ${target ? `and target ${JSON.stringify(target)}` : ""}`
            };
        }
        return this.raiseIntent({ commandId, intent: appIntents[0].intent.name, context, target });
    }
}

class ApplicationsController {
    glueController;
    appsStateStore;
    glueEventsController;
    _logger;
    defaultContextListenerInvokedPromiseTimeout = 120 * 1000;
    constructor(glueController, appsStateStore, glueEventsController) {
        this.glueController = glueController;
        this.appsStateStore = appsStateStore;
        this.glueEventsController = glueEventsController;
    }
    get logger() {
        if (!this._logger) {
            this._logger = this.glueController.initSubLogger("fdc3.application.controller");
        }
        return this._logger;
    }
    async open({ commandId, target, context }) {
        await this.glueController.gluePromise;
        this.logger?.log(`[${commandId}] - open() invoked with target ${target} ${context ? `and contextType ${context.type}` : ""}`);
        const name = typeof target === "object" ? target.appId : target;
        const app = this.glueController.getApplication(name);
        if (!app) {
            throw { message: OpenError.AppNotFound, reason: `Cannot find targeted ${name} application` };
        }
        if (context) {
            await this.glueEventsController.initializeCollaborateMethod();
            this.logger?.info(`[${commandId}] - opening app ${app} with startup context`);
            return this.openAppWithContext(app, context);
        }
        try {
            this.logger?.info(`[${commandId}] - opening app ${app}`);
            const glueInst = await app.start();
            this.logger?.info(`[${commandId}] - instance with id ${glueInst.id} started`);
            return this.parseGlueInstToAppIdentifier(glueInst);
        }
        catch (error) {
            throw { message: OpenError.ErrorOnLaunch, reason: typeof error === "string" ? error : JSON.stringify(error) };
        }
    }
    async findInstances({ commandId, appIdentifier }) {
        await this.glueController.gluePromise;
        this.logger?.info(`[${commandId}] - findInstances() invoked with appIdentifier ${appIdentifier}`);
        const { appId } = appIdentifier;
        const app = this.glueController.getApplication(appId);
        if (!app) {
            throw { message: ResolveError.NoAppsFound, reason: `App with appId: ${appId} does not exist` };
        }
        const glueInstances = this.glueController.getApplicationInstances(appId);
        const fdc3Instances = glueInstances.map(glueInst => this.parseGlueInstToAppIdentifier(glueInst));
        this.logger?.info(`[${commandId}] - ids of opened instances for appIdentifier ${appIdentifier}: ${JSON.stringify(fdc3Instances.map(inst => inst.instanceId))}`);
        return fdc3Instances;
    }
    async getAppMetadata({ commandId, appIdentifier }) {
        await this.glueController.gluePromise;
        this.logger?.info(`[${commandId}] - getAppMetadata() invoked with appIdentifier ${appIdentifier}`);
        const { appId, instanceId } = appIdentifier;
        const app = this.glueController.getApplication(appId);
        if (!app) {
            throw { message: OpenError.AppNotFound, reason: `Cannot find application with appId: ${appId}` };
        }
        if (!instanceId) {
            this.logger?.info(`[${commandId}] - no opened instances found. Parsing app ${app}`);
            return this.parseGlueAppToAppMetadata(app);
        }
        const instance = this.glueController.getAppInstanceById(instanceId);
        const appMetadata = this.parseGlueAppToAppMetadata(app, instance);
        this.logger?.info(`[${commandId}] - found app metadata: ${appMetadata}`);
        return appMetadata;
    }
    async getInfo({ commandId }) {
        await this.glueController.gluePromise;
        this.logger?.info(`${commandId} - getInfo() invoked`);
        const appMetadata = await this.getCurrentAppMetadata();
        const { provider, providerVersion, standardVersion } = window.fdc3Info;
        return {
            provider,
            providerVersion,
            fdc3Version: standardVersion,
            optionalFeatures: {
                OriginatingAppMetadata: true,
                UserChannelMembershipAPIs: true,
                DesktopAgentBridging: false
            },
            appMetadata
        };
    }
    getCurrentAppMetadata() {
        const myInstance = this.glueController.interopInstance();
        return Promise.resolve({
            appId: myInstance.applicationName,
            instanceId: myInstance.instance
        });
    }
    parseGlueInstToAppIdentifier(glueInst) {
        return {
            appId: glueInst.application.name,
            instanceId: glueInst.id
        };
    }
    async parseGlueAppToAppMetadata(app, instance) {
        const appMetadata = await this.getBaseGlueAppToAppMetadata(app);
        if (!instance) {
            return appMetadata;
        }
        return this.addInstanceMetadataToAppMetadata(appMetadata, instance);
    }
    async getBaseGlueAppToAppMetadata(app) {
        const desktopGlobal = window.glue42gd || window.iodesktop;
        const appConfiguration = desktopGlobal
            ? await app.getConfiguration()
            : app.userProperties;
        const icon = desktopGlobal
            ? (await app.getConfiguration()).icon
            : app.icon;
        return {
            appId: app.name,
            name: app.name,
            version: app.version,
            description: appConfiguration.description,
            title: app.title,
            icons: icon ? [{ src: icon }] : [],
            tooltip: appConfiguration.tooltip,
            screenshots: desktopGlobal
                ? appConfiguration.customProperties.screenshots
                : appConfiguration.screenshots
        };
    }
    addInstanceMetadataToAppMetadata(appMetadata, instance) {
        return { ...appMetadata, instanceId: instance.id, instanceMetadata: instance.agm };
    }
    async openAppWithContext(app, context) {
        const guid = nanoid();
        const startContext = this.buildStartContext(context, guid);
        const wrappedPromise = this.createContextListenerWrappedPromise(app);
        this.appsStateStore.addOpenAppPromise(guid, wrappedPromise);
        try {
            const glueInst = await app.start(startContext);
            await wrappedPromise.promise;
            this.appsStateStore.removeOpenAppPromise(guid);
            return this.parseGlueInstToAppIdentifier(glueInst);
        }
        catch (error) {
            this.appsStateStore.removeOpenAppPromise(guid);
            throw { message: OpenError.AppTimeout, reason: typeof error === "string" ? error : JSON.stringify(error) };
        }
    }
    buildStartContext(fdc3Context, guid) {
        const myInteropInstance = this.glueController.getMyInteropInstance();
        return {
            fdc3: {
                collaborationId: guid,
                openApp: {
                    appId: myInteropInstance.application || myInteropInstance.applicationName || "",
                    instanceId: myInteropInstance.instance
                },
                context: {
                    contextType: fdc3Context.type,
                    payload: fdc3Context
                }
            }
        };
    }
    createContextListenerWrappedPromise(app) {
        let resolve = () => { };
        let reject = () => { };
        const promise = promisePlus(() => {
            return new Promise((res, rej) => {
                resolve = res;
                reject = rej;
            });
        }, this.defaultContextListenerInvokedPromiseTimeout, `Timeout of ${this.defaultContextListenerInvokedPromiseTimeout}ms hit waiting for application with appId: ${app.name} to register context listener`);
        return { promise, resolve, reject };
    }
}

class EventReceiver {
    glueController;
    eventDispatcher;
    glueResponseReceived = false;
    glueInitialized = false;
    _glueReceiverHandler;
    events = {
        "start": { name: START, handle: this.handleStart.bind(this) },
        "requestGlueResponse": { name: REQUEST_GLUE_RESPONSE, handle: this.handleRequestGlueResponse.bind(this) }
    };
    constructor(glueController, eventDispatcher) {
        this.glueController = glueController;
        this.eventDispatcher = eventDispatcher;
    }
    start() {
        this.wireCustomEventListener();
        this.eventDispatcher.fireNotifyStarted();
    }
    wireCustomEventListener() {
        this._glueReceiverHandler = this.glueReceiverHandler.bind(this);
        window.addEventListener(GLUE42_EVENT_NAME, this._glueReceiverHandler);
    }
    handleStart() {
        this.eventDispatcher.fireRequestGlue();
    }
    glueReceiverHandler(event) {
        const data = event.detail;
        if (!data || !data.glue42) {
            return;
        }
        const glue42Event = data.glue42.event;
        const foundHandler = this.events[glue42Event];
        if (!foundHandler) {
            return;
        }
        foundHandler.handle(data.glue42.message);
    }
    async handleRequestGlueResponse(data) {
        if (this.glueResponseReceived && this.glueInitialized) {
            return;
        }
        this.glueResponseReceived = true;
        const { glue } = data;
        const glueValidator = this.glueController.validateGlue(glue);
        if (!glueValidator.isValid) {
            this.glueController.initializeFailed(glueValidator.error);
            window.removeEventListener(GLUE42_EVENT_NAME, this._glueReceiverHandler);
            return;
        }
        window.removeEventListener(GLUE42_EVENT_NAME, this._glueReceiverHandler);
        this.glueController.initialize(glue);
        this.eventDispatcher.fireFdc3Ready();
        this.glueInitialized = true;
    }
}

class ChannelsStateStore {
    _privateChannels = {};
    addPrivateChannel(privateChannel) {
        this._privateChannels[privateChannel.id] = privateChannel;
    }
    getPrivateChannelById(id) {
        return this._privateChannels[id];
    }
    removePrivateChannelById(id) {
        delete this._privateChannels[id];
    }
}

function createRegistry(options) {
    if (options && options.errorHandling
        && typeof options.errorHandling !== "function"
        && options.errorHandling !== "log"
        && options.errorHandling !== "silent"
        && options.errorHandling !== "throw") {
        throw new Error("Invalid options passed to createRegistry. Prop errorHandling should be [\"log\" | \"silent\" | \"throw\" | (err) => void], but " + typeof options.errorHandling + " was passed");
    }
    var _userErrorHandler = options && typeof options.errorHandling === "function" && options.errorHandling;
    var callbacks = {};
    function add(key, callback, replayArgumentsArr) {
        var callbacksForKey = callbacks[key];
        if (!callbacksForKey) {
            callbacksForKey = [];
            callbacks[key] = callbacksForKey;
        }
        callbacksForKey.push(callback);
        if (replayArgumentsArr) {
            setTimeout(function () {
                replayArgumentsArr.forEach(function (replayArgument) {
                    var _a;
                    if ((_a = callbacks[key]) === null || _a === void 0 ? void 0 : _a.includes(callback)) {
                        try {
                            if (Array.isArray(replayArgument)) {
                                callback.apply(undefined, replayArgument);
                            }
                            else {
                                callback.apply(undefined, [replayArgument]);
                            }
                        }
                        catch (err) {
                            _handleError(err, key);
                        }
                    }
                });
            }, 0);
        }
        return function () {
            var allForKey = callbacks[key];
            if (!allForKey) {
                return;
            }
            allForKey = allForKey.reduce(function (acc, element, index) {
                if (!(element === callback && acc.length === index)) {
                    acc.push(element);
                }
                return acc;
            }, []);
            if (allForKey.length === 0) {
                delete callbacks[key];
            }
            else {
                callbacks[key] = allForKey;
            }
        };
    }
    function execute(key) {
        var argumentsArr = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            argumentsArr[_i - 1] = arguments[_i];
        }
        var callbacksForKey = callbacks[key];
        if (!callbacksForKey || callbacksForKey.length === 0) {
            return [];
        }
        var results = [];
        callbacksForKey.forEach(function (callback) {
            try {
                var result = callback.apply(undefined, argumentsArr);
                results.push(result);
            }
            catch (err) {
                results.push(undefined);
                _handleError(err, key);
            }
        });
        return results;
    }
    function _handleError(exceptionArtifact, key) {
        var errParam = exceptionArtifact instanceof Error ? exceptionArtifact : new Error(exceptionArtifact);
        if (_userErrorHandler) {
            _userErrorHandler(errParam);
            return;
        }
        var msg = "[ERROR] callback-registry: User callback for key \"" + key + "\" failed: " + errParam.stack;
        if (options) {
            switch (options.errorHandling) {
                case "log":
                    return console.error(msg);
                case "silent":
                    return;
                case "throw":
                    throw new Error(msg);
            }
        }
        console.error(msg);
    }
    function clear() {
        callbacks = {};
    }
    function clearKey(key) {
        var callbacksForKey = callbacks[key];
        if (!callbacksForKey) {
            return;
        }
        delete callbacks[key];
    }
    return {
        add: add,
        execute: execute,
        clear: clear,
        clearKey: clearKey
    };
}
createRegistry.default = createRegistry;
var lib = createRegistry;


var CallbackRegistryFactory = /*@__PURE__*/getDefaultExportFromCjs(lib);

class PrivateChannel {
    channelsController;
    logger;
    isCreator;
    id;
    type = ChannelTypes.Private;
    displayMetadata;
    myAppMetadata;
    unsubFromInstanceStopped;
    collaborator;
    disconnected = false;
    lastBroadcastedContextType;
    broadcastedContexts = {};
    collaboratorListenerTypes = [];
    myListenerTypesBeforeBound = [];
    registry = CallbackRegistryFactory();
    constructor(channelsController, logger, channelId, isCreator) {
        this.channelsController = channelsController;
        this.logger = logger;
        this.isCreator = isCreator;
        this.id = channelId;
        const myServerInstance = this.channelsController.getMyServerInstance();
        this.myAppMetadata = { source: { appId: myServerInstance.applicationName, instanceId: myServerInstance.instance } };
    }
    toApi() {
        const api = {
            id: this.id,
            type: this.type,
            displayMetadata: this.displayMetadata,
            broadcast: this.broadcast.bind(this),
            getCurrentContext: this.getCurrentContext.bind(this),
            addContextListener: this.addContextListener.bind(this),
            onAddContextListener: this.onAddContextListener.bind(this),
            onUnsubscribe: this.onUnsubscribe.bind(this),
            onDisconnect: this.onDisconnect.bind(this),
            disconnect: this.disconnect.bind(this),
        };
        return api;
    }
    getCollaborator() {
        return this.collaborator;
    }
    setCollaborator(collaborator, commandId) {
        if (this.collaborator && this.collaborator.instanceId !== collaborator.instanceId) {
            throw new Error(`There's already a collaborator for private channel with id ${this.id}`);
        }
        this.collaborator = collaborator;
        this.subscribeForCollaboratorInstanceStop(commandId);
    }
    async handleCollaboratorJoin(collaborator, commandId) {
        this.setCollaborator(collaborator, commandId);
        await Promise.all(this.myListenerTypesBeforeBound.map((contextType) => {
            const listenerAddedArgs = {
                action: "addedContextListenerOnPrivateChannel",
                correlationId: this.id,
                collaborationObject: {
                    channelId: this.id,
                    contextType: contextType || undefined
                }
            };
            this.logger?.trace(`[${commandId}] - announcing ${"addedContextListenerOnPrivateChannel"} to collaborator ${JSON.stringify(this.collaborator)}`);
            return this.channelsController.invokeSystemMethod(listenerAddedArgs, this.collaborator?.instanceId);
        })).catch((err) => this.logger?.error(err));
    }
    handleCollaboratorBroadcast(context, metadata, commandId) {
        this.logger?.trace(`[${commandId}] - heard context with type ${context.type} broadcasted on the channel`);
        this.lastBroadcastedContextType = context.type;
        this.broadcastedContexts[context.type] = { context, metadata };
        this.logger?.trace(`[${commandId}] - invoking all context listeners`);
        this.registry.execute(PrivateChannelEventMethods.ListenerAdded, context, metadata);
    }
    handleCollaboratorAddContextListener(contextType, commandId) {
        this.logger?.trace(`[${commandId}] - heard collaborator added context listener for type ${contextType}`);
        this.collaboratorListenerTypes.push(contextType);
        this.registry.execute(PrivateChannelEventMethods.OnAddContextListener, contextType);
    }
    handleCollaboratorRemovedListener(contextType, commandId) {
        this.logger?.trace(`[${commandId}] - heard collaborator removed context listener with type ${contextType}`);
        const index = this.collaboratorListenerTypes.indexOf(contextType);
        this.collaboratorListenerTypes.splice(index, 1);
        this.registry.execute(PrivateChannelEventMethods.OnUnsubscribe, contextType);
    }
    handleCollaboratorDisconnect() {
        this.disconnected = true;
        this.collaboratorListenerTypes.forEach((contextType) => this.registry.execute(PrivateChannelEventMethods.OnUnsubscribe, contextType));
        this.registry.execute(PrivateChannelEventMethods.OnDisconnect);
    }
    async announceJoin(targetInstance, commandId) {
        const joinChannelArgs = {
            action: "joinPrivateChannel",
            correlationId: this.id,
            collaborationObject: {
                channelId: this.id
            }
        };
        this.logger?.trace(`[${commandId}] - announcing ${"joinPrivateChannel"} to target instance with id ${JSON.stringify(targetInstance)}`);
        await this.channelsController.invokeSystemMethod(joinChannelArgs, targetInstance);
        this.logger?.trace(`[${commandId}] - collaborator received ${"joinPrivateChannel"} action`);
    }
    async broadcast(context) {
        const contextDecoderResult = contextDecoder.run(context);
        if (!contextDecoderResult.ok) {
            throw new Error(ChannelError.MalformedContext);
        }
        const commandId = generateCommandId();
        this.ensureAlive(commandId);
        this.ensureBound(commandId, "broadcast");
        this.lastBroadcastedContextType = context.type;
        this.broadcastedContexts[context.type] = { context, metadata: this.myAppMetadata };
        const broadcastArgs = {
            action: "publishOnPrivateChannel",
            correlationId: this.id,
            collaborationObject: {
                channelId: this.id,
                contextType: context.type,
                payload: context
            }
        };
        this.logger?.trace(`[${commandId}] - announcing ${"publishOnPrivateChannel"} to collaborator ${JSON.stringify(this.collaborator)}`);
        await this.channelsController.invokeSystemMethod(broadcastArgs, this.collaborator?.instanceId);
        this.logger?.trace(`[${commandId}] - collaborator received context for action ${"publishOnPrivateChannel"}`);
    }
    async getCurrentContext(contextType) {
        const commandId = generateCommandId();
        this.ensureAlive(commandId);
        const contextTypeMessage = contextType ? ` with contextType ${contextType}` : "";
        this.logger?.trace(`[${commandId}] - getCurrentContext invoked ${contextTypeMessage}`);
        optionalNonEmptyStringDecoder.runWithException(contextType);
        if (!contextType && !this.lastBroadcastedContextType) {
            return null;
        }
        const searchedType = contextType || this.lastBroadcastedContextType;
        this.logger?.trace(`[${commandId}] - Returning context with type ${searchedType}`);
        return this.broadcastedContexts[searchedType].context;
    }
    async addContextListener(contextType, handler) {
        const commandId = generateCommandId();
        this.ensureAlive(commandId);
        optionalNonEmptyStringDecoder.runWithException(contextType);
        if (typeof handler !== "function") {
            throw { message: ChannelError.AccessDenied, reason: `Expected function as an argument, got ${typeof contextType}` };
        }
        this.logger?.trace(`[${commandId}] - adding subscription for broadcasted contexts with type: ${contextType}`);
        const subHandler = (data, metadata) => {
            if (contextType) {
                if (data.type === contextType) {
                    handler(data, metadata);
                }
                return;
            }
            handler(data, metadata);
        };
        const lastBroadcastedContextPerType = this.retrieveLatestBroadcastedContextPerType(contextType);
        const replayArgs = lastBroadcastedContextPerType ? [[lastBroadcastedContextPerType.context, lastBroadcastedContextPerType.metadata]] : undefined;
        const unsub = this.registry.add(PrivateChannelEventMethods.ListenerAdded, subHandler, replayArgs);
        if (!this.collaborator) {
            this.myListenerTypesBeforeBound.push(contextType);
            const unsubscribe = this.getAddContextListenerUnsub(unsub, contextType, commandId);
            return AsyncListener(unsubscribe);
        }
        const listenerAddedArgs = {
            action: "addedContextListenerOnPrivateChannel",
            correlationId: this.id,
            collaborationObject: {
                channelId: this.id,
                contextType: contextType || undefined
            }
        };
        this.logger?.trace(`[${commandId}] - announcing ${"addedContextListenerOnPrivateChannel"} to collaborator ${JSON.stringify(this.collaborator)}`);
        await this.channelsController.invokeSystemMethod(listenerAddedArgs, this.collaborator?.instanceId);
        this.logger?.trace(`[${commandId}] - collaborator received action ${"addedContextListenerOnPrivateChannel"}`);
        const unsubscribe = this.getAddContextListenerUnsub(unsub, contextType, commandId);
        return AsyncListener(unsubscribe);
    }
    retrieveLatestBroadcastedContextPerType(contextType) {
        if (!contextType && !this.lastBroadcastedContextType) {
            return;
        }
        if (!contextType && this.lastBroadcastedContextType) {
            return {
                context: this.broadcastedContexts[this.lastBroadcastedContextType].context,
                metadata: this.broadcastedContexts[this.lastBroadcastedContextType].metadata
            };
        }
        return this.broadcastedContexts[contextType];
    }
    getAddContextListenerUnsub(unsub, contextType, commandId) {
        return async () => {
            unsub();
            if (!this.collaborator) {
                const index = this.myListenerTypesBeforeBound.indexOf(contextType);
                this.myListenerTypesBeforeBound.splice(index, 1);
                return;
            }
            const unsubArgs = {
                action: "removedContextListenerOnPrivateChannel",
                correlationId: this.id,
                collaborationObject: {
                    channelId: this.id,
                    contextType: contextType || undefined
                }
            };
            this.logger?.trace(`[${commandId}] - announcing unsubscribe from context listener for type ${contextType}`);
            await this.channelsController.invokeSystemMethod(unsubArgs, this.collaborator?.instanceId);
            this.logger?.trace(`[${commandId}] - collaborator heard ${"removedContextListenerOnPrivateChannel"}`);
        };
    }
    onAddContextListener(handler) {
        if (typeof handler !== "function") {
            throw { message: ChannelError.AccessDenied, reason: `Expected function as an argument, got ${typeof handler}` };
        }
        const commandId = generateCommandId();
        this.ensureAlive(commandId);
        const unsub = this.registry.add(PrivateChannelEventMethods.OnAddContextListener, handler, this.collaboratorListenerTypes);
        return AsyncListener(unsub);
    }
    onUnsubscribe(handler) {
        if (typeof handler !== "function") {
            throw { message: ChannelError.AccessDenied, reason: `Expected function as an argument, got ${typeof handler}` };
        }
        const commandId = generateCommandId();
        this.ensureAlive(commandId);
        const unsub = this.registry.add(PrivateChannelEventMethods.OnUnsubscribe, handler);
        return AsyncListener(unsub);
    }
    onDisconnect(handler) {
        if (typeof handler !== "function") {
            throw { message: ChannelError.AccessDenied, reason: `Expected function as an argument, got ${typeof handler}` };
        }
        const commandId = generateCommandId();
        this.ensureAlive(commandId);
        const unsub = this.registry.add(PrivateChannelEventMethods.OnDisconnect, handler);
        return AsyncListener(unsub);
    }
    async disconnect() {
        const commandId = generateCommandId();
        if (this.isCreator && !this.collaborator) {
            this.disconnected = true;
            return;
        }
        this.ensureAlive(commandId);
        this.ensureBound(commandId, "disconnect");
        this.logger?.trace(`[${commandId}] - disconnect invoked`);
        this.disconnected = true;
        this.logger?.trace(`[${commandId}] - announcing ${"disconnectedFromPrivateChannel"} to collaborator ${JSON.stringify(this.collaborator)}`);
        const disconnectArgs = {
            action: "disconnectedFromPrivateChannel",
            correlationId: this.id,
            collaborationObject: {
                channelId: this.id
            }
        };
        this.channelsController.removePrivateChannelFromStoreById(this.id);
        await this.channelsController.invokeSystemMethod(disconnectArgs, this.collaborator?.instanceId);
        this.logger?.trace(`[${commandId}] - collaborator received action ${"disconnectedFromPrivateChannel"}`);
        if (this.unsubFromInstanceStopped) {
            this.unsubFromInstanceStopped();
        }
    }
    ensureAlive(commandId) {
        if (!this.disconnected) {
            return;
        }
        const errorMsg = "Channel is disconnected - operation is no longer available";
        this.logger?.error(`[${commandId}] - ${errorMsg}`);
        throw { message: ChannelError.AccessDenied, reason: errorMsg };
    }
    ensureBound(commandId, operation) {
        if (this.collaborator) {
            return;
        }
        const errorMsg = `There's no collaborator on the other side of the channel - operation ${operation} is unavailable`;
        this.logger?.error(`[${commandId}] - ${errorMsg}`);
        throw { message: ChannelError.AccessDenied, reason: errorMsg };
    }
    subscribeForCollaboratorInstanceStop(commandId) {
        const handler = (instance) => {
            if (instance.id !== this.collaborator?.instanceId) {
                return;
            }
            this.handleCollaboratorDisconnect();
        };
        this.unsubFromInstanceStopped = this.channelsController.subscribeOnInstanceStop(this.id, handler.bind(this), commandId);
    }
}

class ChannelsFactory {
    createUserChannelFn;
    createAppChannel;
    createPrivateChannel;
    constructor(createUserChannelFn, createAppChannel, createPrivateChannel) {
        this.createUserChannelFn = createUserChannelFn;
        this.createAppChannel = createAppChannel;
        this.createPrivateChannel = createPrivateChannel;
    }
    buildPrivateChannel(data) {
        return this.createPrivateChannel(data.logger, data.id, data.isCreator);
    }
    buildModel(data) {
        if (data.type === ChannelTypes.User) {
            return this.createUserChannelFn(data.displayMetadata.glueChannel);
        }
        if (data.type === ChannelTypes.App) {
            return this.createAppChannel(data.id);
        }
        throw new Error("Pass one of the supported channel types: user, app, private");
    }
}

class GlueEventsController {
    glueController;
    channelsStateStore;
    appsStateStore;
    _logger;
    actionDictionary = {
        joinPrivateChannel: this.handleJoin.bind(this),
        publishOnPrivateChannel: this.handlePublish.bind(this),
        addedContextListenerOnPrivateChannel: this.handleContextListenerAdded.bind(this),
        removedContextListenerOnPrivateChannel: this.handleContextListenerRemoved.bind(this),
        disconnectedFromPrivateChannel: this.handleDisconnect.bind(this),
        startupContextOpened: this.handleStartupContextOpened.bind(this)
    };
    constructor(glueController, channelsStateStore, appsStateStore) {
        this.glueController = glueController;
        this.channelsStateStore = channelsStateStore;
        this.appsStateStore = appsStateStore;
    }
    async initializeCollaborateMethod() {
        const methodRegisteredByMe = this.checkSystemMethodRegistered();
        if (methodRegisteredByMe) {
            return;
        }
        await this.glueController.registerMethod(ioConnectFDC3SystemMethod, this.handleReceivedAction.bind(this));
    }
    checkSystemMethodRegistered() {
        const methods = this.glueController.getInteropMethods(ioConnectFDC3SystemMethod);
        const myId = this.glueController.getMyInteropInstance().instance;
        const methodsByThisInstance = methods.filter(method => {
            return method.getServers().find(server => server.instance === myId)
                ? method
                : undefined;
        });
        return !!methodsByThisInstance.length;
    }
    async handleReceivedAction(eventArgs, instance) {
        const argsDecodeResult = SystemMethodInvocationArgumentDecoder.run(eventArgs);
        if (!argsDecodeResult.ok) {
            throw new Error(`Interop Method ${ioConnectFDC3SystemMethod} invoked with invalid argument object - ${argsDecodeResult.error}`);
        }
        const commandId = generateCommandId();
        this.logger?.log(`${commandId} - received system method from instance with id ${instance.instance} for action ${eventArgs.action} with arguments: ${JSON.stringify(eventArgs)}`);
        const operation = this.actionDictionary[eventArgs.action];
        if (!operation) {
            const errorMsg = `Unsupported private channel action: ${eventArgs.action}`;
            this.logger?.error(`[${commandId}] - ${errorMsg}`);
            throw new Error(errorMsg);
        }
        await operation(eventArgs, instance, commandId);
    }
    get logger() {
        if (!this._logger) {
            this._logger = this.glueController.initSubLogger("fdc3.private.channels.controller");
        }
        return this._logger;
    }
    validateAndRetrieveChannel({ action, correlationId }, instance, commandId) {
        const privateChannel = this.channelsStateStore.getPrivateChannelById(correlationId);
        if (!privateChannel) {
            const errorMsg = `There's no private channel with id ${correlationId}`;
            this.logger?.error(`[${commandId}] - ${errorMsg}`);
            throw new Error(errorMsg);
        }
        const channelCollaborator = privateChannel.getCollaborator();
        if (action === "joinPrivateChannel") {
            return privateChannel;
        }
        if (channelCollaborator && channelCollaborator.instanceId === instance.instance) {
            this.logger?.log(`[${commandId}] - request sent from correct collaborator with id ${instance.instance}. Returning channel`);
            return privateChannel;
        }
        const errorMsg = `Cannot proceed with action ${action} - ${channelCollaborator
            ? `private channel ${correlationId} established communication with collaborator with id ${channelCollaborator}`
            : `no collaborator joined private channel with id ${correlationId}`}`;
        this.logger?.error(errorMsg);
        throw new Error(errorMsg);
    }
    async handleJoin(eventArgs, instance, commandId) {
        const collaborator = { appId: instance.application || instance.applicationName, instanceId: instance.instance };
        const privateChannel = this.validateAndRetrieveChannel(eventArgs, instance, commandId);
        await privateChannel.handleCollaboratorJoin(collaborator, commandId);
        this.logger?.log(`[${commandId}] - collaborator ${JSON.stringify(collaborator)} set for private channel with id ${eventArgs.correlationId}`);
    }
    handlePublish(eventArgs, instance, commandId) {
        this.logger?.log(`[${commandId}] - received ${eventArgs.action} action, adding context with type ${eventArgs.collaborationObject?.contextType} to the private channel broadcasted contexts`);
        const privateChannel = this.validateAndRetrieveChannel(eventArgs, instance, commandId);
        const metadata = {
            source: {
                appId: instance.application || instance.applicationName || "",
                instanceId: instance.instance
            }
        };
        privateChannel.handleCollaboratorBroadcast(eventArgs.collaborationObject?.payload, metadata, commandId);
    }
    handleContextListenerAdded(eventArgs, instance, commandId) {
        this.logger?.log(`[${commandId}] - received ${eventArgs.action} action, invoking all 'onAddContextListener' callbacks`);
        const privateChannel = this.validateAndRetrieveChannel(eventArgs, instance, commandId);
        privateChannel.handleCollaboratorAddContextListener(eventArgs.collaborationObject?.contextType || null, commandId);
    }
    handleContextListenerRemoved(eventArgs, instance, commandId) {
        this.logger?.log(`[${commandId}] - received ${eventArgs.action} action, invoking all 'onUnsubscribe' callbacks`);
        const privateChannel = this.validateAndRetrieveChannel(eventArgs, instance, commandId);
        privateChannel.handleCollaboratorRemovedListener(eventArgs.collaborationObject?.contextType || null, commandId);
    }
    handleDisconnect(eventArgs, instance, commandId) {
        this.logger?.log(`[${commandId}] - received ${eventArgs.action} action, invoking all 'onDisconnect' callbacks`);
        const privateChannel = this.validateAndRetrieveChannel(eventArgs, instance, commandId);
        privateChannel.handleCollaboratorDisconnect();
    }
    handleStartupContextOpened(eventArgs, instance, commandId) {
        this.logger?.log(`[${commandId}] - received ${eventArgs.action} with correlationId: ${eventArgs.correlationId} from instance with id ${instance.instance}`);
        const wrappedPromise = this.appsStateStore.getOpenAppPromise(eventArgs.correlationId);
        if (!wrappedPromise) {
            this.logger?.log(`[${commandId}] - there's no open app promise related to guid ${eventArgs.correlationId}`);
            return;
        }
        this.logger?.log(`[${commandId}] - resolving open app promise related to guid ${eventArgs.correlationId} from instance with id ${instance.instance}`);
        wrappedPromise.resolve();
    }
}

class ApplicationsStateStore {
    openAppPromises = {};
    addOpenAppPromise(guid, promise) {
        this.openAppPromises[guid] = promise;
    }
    getOpenAppPromise(guid) {
        return this.openAppPromises[guid];
    }
    removeOpenAppPromise(guid) {
        delete this.openAppPromises[guid];
    }
}

class ChannelsBaseController {
    glueController;
    stateStore;
    parser;
    channelsFactory;
    glueEventsController;
    legacyController;
    ioFdc3SupportedController;
    _logger;
    initDonePromise;
    invokeContextHandlerWithStartupContext = true;
    isFdc3DataWrappingSupported;
    constructor(glueController, stateStore, parser, channelsFactory, glueEventsController, legacyController, ioFdc3SupportedController) {
        this.glueController = glueController;
        this.stateStore = stateStore;
        this.parser = parser;
        this.channelsFactory = channelsFactory;
        this.glueEventsController = glueEventsController;
        this.legacyController = legacyController;
        this.ioFdc3SupportedController = ioFdc3SupportedController;
        this.initDonePromise = this.initialize();
        this.initDonePromise.catch((err) => {
            this.logger?.error(err);
        });
    }
    async getStartupContext() {
        await this.initDonePromise;
        const fdc3StartupContext = await this.glueController.getMyWindowContext();
        return fdc3StartupContext?.fdc3?.context?.payload || null;
    }
    async addContextListener({ commandId, handler, contextType, channelId }) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - addContextListener() invoked for contextType ${contextType} and channelId ${channelId}`);
        if (this.invokeContextHandlerWithStartupContext && !channelId) {
            this.logger?.info(`[${commandId}] - trying to invoke context handler with window context`);
            this.handleWindowContextOnOpening(commandId, handler, contextType).catch((err) => this.logger?.warn(`[${commandId}] - ${err}`));
        }
        const channelIdToSubscribeTo = channelId || (await this.getCurrentChannel(commandId))?.id;
        const onMultiChannels = this.glueController.getChannelsMode() === "multi" && (await this.glueController.getMyChannels()).length > 1;
        const subHandler = parseContextHandler(handler, contextType);
        if (!channelIdToSubscribeTo || onMultiChannels) {
            const unsubscribe = this.glueController.channelsSubscribe(subHandler, contextType);
            return { unsubscribe };
        }
        return this.addContextListenerByChannelId({ commandId, handler: subHandler, invokedOnChannelModel: !!channelId, channelId: channelIdToSubscribeTo, contextType });
    }
    async broadcast(commandId, context, channelId) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - broadcast() invoked with contextType ${context.type} and channelId ${channelId}`);
        const canBroadcast = await this.isBroadcastPermitted(commandId, channelId);
        if (!canBroadcast) {
            return;
        }
        const channelIdToBroadcastTo = channelId || (await this.getCurrentChannel(commandId))?.id;
        if (!channelIdToBroadcastTo) {
            return;
        }
        const onMultiChannels = this.glueController.getChannelsMode() === "multi" && (await this.glueController.getMyChannels()).length > 1;
        if (!channelIdToBroadcastTo || onMultiChannels) {
            return this.glueController.channelsUpdate(context, { fdc3: true });
        }
        return this.broadcastByChannelId(commandId, channelIdToBroadcastTo, context);
    }
    async getUserChannels(commandId) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - getUserChannels() invoked`);
        const ioChannels = await this.glueController.listAllChannels();
        return this.mapIoToFDC3Channels(ioChannels);
    }
    async getOrCreateChannel({ commandId, channelId }) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - getOrCreateChannel() invoked for channel with id ${channelId}`);
        const userChannel = (await this.getUserChannels(commandId)).find((ch) => ch.id === channelId);
        if (userChannel) {
            return userChannel;
        }
        const isPrivateChannel = this.stateStore.getPrivateChannelById(channelId);
        if (isPrivateChannel) {
            this.logger?.error("Cannot retrieve a private channel");
            throw new Error(ChannelError.AccessDenied);
        }
        return this.getOrCreateAppChannel(commandId, channelId);
    }
    async joinUserChannel({ commandId, channelId }) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - joinUserChannel() invoked for channel with id ${channelId}`);
        const isAppChannel = this.doesAppChannelExist(channelId);
        if (isAppChannel) {
            this.logger?.error("Cannot join an app channel");
            throw new Error(ChannelError.AccessDenied);
        }
        const channels = await this.getUserChannels(commandId);
        const channelToJoin = channels.find((ch) => ch.id === channelId);
        if (!channelToJoin) {
            this.logger?.error(`Cannot find user channel with id ${channelId}`);
            throw new Error(ChannelError.NoChannelFound);
        }
        const ioChannelName = (await this.getOrCreateChannel({ commandId, channelId }))?.displayMetadata?.name;
        if (!ioChannelName) {
            this.logger?.error(`[${commandId}] - Cannot find io channel name for fdc3 channel with id ${channelId}`);
            throw new Error(ChannelError.NoChannelFound);
        }
        this.logger?.info(`[${commandId}] - joining fdc3 user channel with id ${channelId} (underlying io channel: ${ioChannelName})`);
        await this.glueController.joinChannel(ioChannelName);
    }
    async getCurrentChannel(commandId) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - getCurrentChannel() invoked`);
        const currentIoChannel = await this.glueController.getMyChannel();
        if (!currentIoChannel?.meta.fdc3) {
            return null;
        }
        return this.channelsFactory.buildModel({ type: ChannelTypes.User, displayMetadata: { glueChannel: currentIoChannel } });
    }
    async leaveCurrentChannel(commandId) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - leaveCurrentChannel() invoked`);
        const currentChannel = await this.getCurrentChannel(commandId);
        if (!currentChannel) {
            this.logger?.info(`[${commandId}] - no channel to leave`);
            return;
        }
        await this.glueController.leaveChannel();
        this.logger?.info(`[${commandId}] - current channel is left. unsubscribing from all listeners`);
    }
    async getContextForChannel({ commandId, channelId, contextType }) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - getContextForChannel() invoked for channel with id ${channelId}`);
        const isUserChannel = await this.isUserChannel(commandId, channelId);
        if (isUserChannel) {
            return this.userChannelsSupportController.getContext({ commandId, channelId, contextType });
        }
        if (!contextType) {
            const context = await this.glueController.getContext(channelId);
            return context.latest_fdc3_type ? this.parser.parseContextsDataToInitialFDC3Data(context) : null;
        }
        const parsedType = this.parser.mapFDC3TypeToChannelsDelimiter(contextType);
        const { data } = await this.glueController.getContext(channelId);
        return data?.[`fdc3_${parsedType}`]
            ? this.parser.parseContextsDataToInitialFDC3Data({ data, latest_fdc3_type: parsedType })
            : null;
    }
    async createPrivateChannel(commandId) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - createPrivateChannel() invoked`);
        const channelId = `${PrivateChannelPrefix}${nanoid()}`;
        await this.glueEventsController.initializeCollaborateMethod();
        const pc = this.buildPrivateChannel(channelId, commandId, true);
        return pc.toApi();
    }
    async removePrivateChannelFromStoreById(id) {
        this.stateStore.removePrivateChannelById(id);
    }
    async invokeSystemMethod(args, target) {
        if (!target) {
            return;
        }
        return this.glueController.invokeSystemMethod(args, target);
    }
    getMyServerInstance() {
        return this.glueController.getMyInteropInstance();
    }
    async addClientToPrivateChannel(commandId, channelId, clientId) {
        this.logger?.info(`[${commandId}] - client with id ${clientId} added to private channel with id ${channelId}`);
        await this.glueController.updateContext(channelId, { clientId });
    }
    async isPrivateChannelDisconnected({ commandId, channelId }) {
        this.logger?.info(`[${commandId}] - checking if private channel with id ${channelId} is disconnected`);
        const context = await this.glueController.getContext(channelId);
        return !!context.disconnected;
    }
    subscribeOnInstanceStop(channelId, handler, commandId) {
        this.logger?.info(`[${commandId}] - subscribing onInstanceStopped callback for channel with id ${channelId}`);
        return this.glueController.registerOnInstanceStopped(handler.bind(this));
    }
    buildPrivateChannel(channelId, commandId, isCreator) {
        const logger = this.glueController.initSubLogger(channelId);
        const channel = this.channelsFactory.buildPrivateChannel({ id: channelId, logger, isCreator });
        this.logger?.info(`[${commandId}] - private channel with id ${channelId} created. Adding it to the store`);
        this.stateStore.addPrivateChannel(channel);
        return channel;
    }
    buildChannel(type, data) {
        return this.channelsFactory.buildModel({ type, ...data });
    }
    async publish(commandId, context) {
        const myGlueChannels = await this.glueController.getMyChannels();
        if (!myGlueChannels.length) {
            this.logger?.info(`[${commandId}] - invocation of publish ignored - no channel to publish to`);
            console.warn("You need to join a user channel to broadcast data");
            return;
        }
        return this.glueController.channelsUpdate(context, { fdc3: true });
    }
    async getCurrentChannels(commandId) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - getCurrentChannels() invoked`);
        const ioChannels = await this.glueController.getMyChannels();
        return this.mapIoToFDC3Channels(ioChannels);
    }
    async leave(commandId, options) {
        await this.initDonePromise;
        this.logger?.info(`[${commandId}] - leave() invoked with options: ${JSON.stringify(options)}`);
        if (!options?.channelId) {
            this.logger?.info(`[${commandId}] - leaving all channels`);
            return this.glueController.leaveChannel();
        }
        const allIoChannels = await this.glueController.listAllChannels();
        const ioChannelToLeave = allIoChannels.find((ch) => ch.meta.fdc3?.id === options.channelId);
        if (!ioChannelToLeave) {
            throw new Error(ChannelError.NoChannelFound);
        }
        this.logger?.info(`[${commandId}] - leaving channel '${ioChannelToLeave.name}'`);
        return this.glueController.leaveChannel({ channel: ioChannelToLeave.name });
    }
    get logger() {
        if (!this._logger) {
            this._logger = this.glueController.initSubLogger("fdc3.channels.controller");
        }
        return this._logger;
    }
    get userChannelsSupportController() {
        return this.isFdc3DataWrappingSupported ? this.ioFdc3SupportedController : this.legacyController;
    }
    async initialize() {
        await this.glueController.gluePromise;
        this.isFdc3DataWrappingSupported = await this.glueController.checkIsFdc3DataWrappingSupported();
    }
    async isBroadcastPermitted(commandId, channelId) {
        if (channelId) {
            return true;
        }
        const currentChannel = await this.getCurrentChannel(commandId);
        if (!currentChannel) {
            this.logger?.info(`[${commandId}] - invocation of broadcast ignored - no channel to broadcast to`);
            console.warn("You need to join a user channel in order to broadcast");
            return false;
        }
        if (currentChannel.type === ChannelTypes.App) {
            this.logger?.info(`[${commandId}] - invocation of broadcast ignored - cannot broadcast on app channel directly`);
            console.error("You can't broadcast to an app channel directly - use channel's broadcast method instead");
            return false;
        }
        return true;
    }
    mapIoToFDC3Channels(ioChannels) {
        return ioChannels
            .filter((ioChannel) => ioChannel.meta.fdc3)
            .map((ioChannel) => this.channelsFactory.buildModel({ type: ChannelTypes.User, displayMetadata: { glueChannel: ioChannel } }));
    }
    async handleWindowContextOnOpening(commandId, handler, contextType) {
        const myWindow = this.glueController.getMyWindow();
        if (!myWindow) {
            this.logger?.trace(`[${commandId}] - Cannot get window context because this is not a Glue window, it's probably an iframe`);
            this.invokeContextHandlerWithStartupContext = false;
            return;
        }
        const windowContext = await myWindow.getContext();
        if (!windowContext) {
            this.logger?.trace(`[${commandId}] - Cannot get window context because this is not a Glue window, it's probably an iframe`);
            this.invokeContextHandlerWithStartupContext = false;
            return;
        }
        if (!isValidNonEmptyObject(windowContext) || !windowContext.fdc3) {
            this.logger?.info(`[${commandId}] - addContextListener handler won't be invoked - startup context is empty`);
            this.invokeContextHandlerWithStartupContext = false;
            return;
        }
        await this.glueEventsController.initializeCollaborateMethod();
        FDC3StartupContextDecoder.runWithException(windowContext);
        const { fdc3 } = windowContext;
        this.logger?.trace(`[${commandId}] - received FDC3 startup context from ${JSON.stringify(fdc3.openApp)} for contextType ${fdc3.context.contextType}`);
        const isSameContextType = contextType ? fdc3.context.contextType === contextType : true;
        if (!isSameContextType) {
            this.logger?.info(`[${commandId}] - addContextListener handler won't be invoked for contextType ${contextType} for startup context with type: ${fdc3.context.contextType}`);
            return;
        }
        this.logger?.info(`[${commandId}] - invoking addContextListener handler with startup context with type ${fdc3.context.contextType}`);
        try {
            handler(fdc3.context.payload, { source: fdc3.openApp });
        }
        catch (error) {
            const errorMsg = error.message ? JSON.stringify(error.message) : JSON.stringify(error);
            this.logger?.error(typeof error === "string" ? error : errorMsg);
        }
        this.invokeContextHandlerWithStartupContext = false;
        this.logger?.trace(`[${commandId}] - invoking response method to with target ${JSON.stringify(fdc3.openApp)}`);
        await this.invokeSystemMethod({ action: "startupContextOpened", correlationId: fdc3.collaborationId }, fdc3.openApp.instanceId);
        this.logger?.trace(`[${commandId}] - system method invocation success for 'startupContextOpened' heard`);
    }
    async getOrCreateAppChannel(commandId, channelId) {
        const exists = this.doesAppChannelExist(channelId);
        if (!exists) {
            this.logger?.info(`[${commandId}] - app channel with id ${channelId} does not exist. Creating one`);
            await this.glueController.updateContext(channelId, {});
        }
        this.logger?.info(`[${commandId}] - returning app channel with id ${channelId}`);
        const logger = this.glueController.initSubLogger(`app.channel.${channelId}`);
        return this.channelsFactory.buildModel({ type: ChannelTypes.App, id: channelId, logger });
    }
    doesAppChannelExist(name) {
        return !name.includes(PrivateChannelPrefix) && this.glueController.getAllContexts().some((ctxName) => ctxName === name);
    }
    async isUserChannel(commandId, channelId) {
        if (!channelId) {
            return false;
        }
        const userChannels = await this.getUserChannels(commandId);
        return userChannels.some((channel) => channel.id === channelId);
    }
    async broadcastByChannelId(commandId, channelId, context) {
        const isUserChannel = await this.isUserChannel(commandId, channelId);
        if (!isUserChannel) {
            this.logger?.info(`[${commandId}] - broadcasting on app channel with id ${channelId}`);
            return this.glueController.updateContextWithLatestFdc3Type(channelId, context);
        }
        const ioChannelName = (await this.getOrCreateChannel({ commandId, channelId }))?.displayMetadata?.name;
        if (!ioChannelName) {
            this.logger?.error(`[${commandId}] - Cannot find io channel name for fdc3 channel with id ${channelId}`);
            throw new Error(ChannelError.NoChannelFound);
        }
        this.logger?.info(`[${commandId}] - broadcasting on fdc3 user channel with id ${channelId} (underlying glue channel: ${ioChannelName})`);
        return this.userChannelsSupportController.broadcast({ ioChannelName, context });
    }
    async addContextListenerByChannelId({ commandId, channelId, handler, contextType, invokedOnChannelModel }) {
        const subHandler = parseContextHandler(handler, contextType);
        const channelType = await this.getChannelTypeById(commandId, channelId);
        if (channelType === ChannelTypes.User) {
            return this.userChannelsSupportController.addContextListener({ commandId, channelId, handler: subHandler, contextType, invokedOnChannelModel });
        }
        if (channelType === ChannelTypes.App) {
            this.logger?.info(`[${commandId}] - subscribing for fdc3 app channel with id ${channelId} (underlying glue context with same name)`);
            const unsubscribe = await this.glueController.contextsSubscribe(channelId, subHandler);
            return {
                unsubscribe: () => {
                    this.logger?.info(`[${commandId}] - invoking unsubscribe for app channel with id ${channelId}`);
                    unsubscribe();
                }
            };
        }
        this.logger?.error("Cannot add a context listener on an invalid channel");
        throw new Error(ChannelError.AccessDenied);
    }
    async getChannelTypeById(commandId, channelId) {
        const isUser = await this.isUserChannel(commandId, channelId);
        if (isUser) {
            return ChannelTypes.User;
        }
        const isApp = this.doesAppChannelExist(channelId);
        if (isApp) {
            return ChannelTypes.App;
        }
        this.logger?.error(`Channel with id: ${channelId} does not exist`);
        throw new Error(ChannelError.NoChannelFound);
    }
}

class LegacyDataWrappingChannelsController {
    parser;
    glueController;
    _logger;
    constructor(parser, glueController) {
        this.parser = parser;
        this.glueController = glueController;
    }
    async getContext({ commandId, channelId, contextType }) {
        this.logger?.info(`[${commandId}] - retrieving latest context of type ${contextType}  broadcasted on channel with id ${channelId}`);
        const ioChannelName = await this.glueController.getIoChannelNameByFDC3ChannelId(channelId);
        if (!ioChannelName) {
            this.logger?.error(`[${commandId}] - io channel with fdc3 channel id ${channelId} not found`);
            throw new Error(ChannelError.AccessDenied);
        }
        if (!contextType) {
            const glueChannelWithPrefix = this.parser.mapChannelNameToContextName(ioChannelName);
            this.logger?.info(`[${commandId}] - getting context for user channel with id ${channelId} (underlying glue channel ${ioChannelName})`);
            const context = await this.glueController.getContext(glueChannelWithPrefix);
            return context.latest_fdc3_type ? this.parser.parseContextsDataToInitialFDC3Data(context) : null;
        }
        const parsedType = this.parser.mapFDC3TypeToChannelsDelimiter(contextType);
        const { data } = await this.glueController.getChannel(ioChannelName);
        return data?.[`fdc3_${parsedType}`]
            ? this.parser.parseContextsDataToInitialFDC3Data({ data, latest_fdc3_type: parsedType })
            : null;
    }
    async broadcast({ ioChannelName, context }) {
        const { path, value } = this.parser.parseFDC3ContextToGlueContexts(context);
        return this.glueController.channelsUpdate({ [path]: value }, ioChannelName);
    }
    async addContextListener({ commandId, channelId, handler, invokedOnChannelModel, contextType }) {
        if (!invokedOnChannelModel) {
            this.logger?.info(`[${commandId}] - subscribing for fdc3 user channel with id ${channelId}`);
            const unsubscribe = this.glueController.legacyChannelsSubscribe(handler, contextType);
            return { unsubscribe };
        }
        const ioChannelName = await this.glueController.getIoChannelNameByFDC3ChannelId(channelId);
        if (!ioChannelName) {
            this.logger?.error(`[${commandId}] - io channel with fdc3 channel id ${channelId} not found`);
            throw new Error(ChannelError.AccessDenied);
        }
        const contextToSubscribeTo = this.parser.mapChannelNameToContextName(ioChannelName);
        this.logger?.info(`[${commandId}] - subscribing for fdc3 user channel with id ${channelId}`);
        const unsubscribe = await this.glueController.contextsSubscribe(contextToSubscribeTo, handler);
        return { unsubscribe };
    }
    get logger() {
        if (!this._logger) {
            this._logger = this.glueController.initSubLogger("fdc3.legacy.channels.controller");
        }
        return this._logger;
    }
}

class NewDataWrappingChannelsController {
    parser;
    glueController;
    _logger;
    constructor(parser, glueController) {
        this.parser = parser;
        this.glueController = glueController;
    }
    async getContext({ commandId, channelId, contextType }) {
        this.logger?.info(`[${commandId}] - retrieving latest context of type ${contextType}  broadcasted on channel with id ${channelId}`);
        const ioChannelName = await this.glueController.getIoChannelNameByFDC3ChannelId(channelId);
        if (!ioChannelName) {
            this.logger?.error(`[${commandId}] - io channel with fdc3 channel id ${channelId} not found`);
            throw new Error(ChannelError.AccessDenied);
        }
        const ioChannel = await this.glueController.getChannel(ioChannelName);
        if (!contextType) {
            return ioChannel.data.fdc3 || null;
        }
        if (contextType && ioChannel.data.fdc3?.type === contextType) {
            return ioChannel.data.fdc3;
        }
        const ioChannelContextName = this.parser.mapChannelNameToContextName(ioChannelName);
        const { data } = await this.glueController.getContext(ioChannelContextName);
        const parsedType = this.parser.mapFDC3TypeToChannelsDelimiter(contextType);
        return data?.[`fdc3_${parsedType}`]
            ? this.parser.parseContextsDataToInitialFDC3Data({ data, latest_fdc3_type: parsedType })
            : null;
    }
    async broadcast({ ioChannelName, context }) {
        return this.glueController.channelsUpdate(context, { name: ioChannelName, fdc3: true });
    }
    async addContextListener({ commandId, channelId, invokedOnChannelModel, handler, contextType }) {
        if (!invokedOnChannelModel) {
            this.logger?.info(`[${commandId}] - subscribing for fdc3 user channel with id ${channelId}`);
            const unsubscribe = this.glueController.channelsSubscribe(handler, contextType);
            return { unsubscribe };
        }
        const ioChannelName = await this.glueController.getIoChannelNameByFDC3ChannelId(channelId);
        if (!ioChannelName) {
            this.logger?.error(`[${commandId}] - io channel with fdc3 channel id ${channelId} not found`);
            throw new Error(ChannelError.AccessDenied);
        }
        const contextToSubscribeTo = this.parser.mapChannelNameToContextName(ioChannelName);
        this.logger?.info(`[${commandId}] - subscribing for fdc3 user channel with id ${channelId}`);
        const unsubscribe = await this.glueController.contextsSubscribe(contextToSubscribeTo, handler);
        return { unsubscribe };
    }
    get logger() {
        if (!this._logger) {
            this._logger = this.glueController.initSubLogger("fdc3.ioSupport.channels.controller");
        }
        return this._logger;
    }
}

class IoC {
    _eventDispatcher;
    _eventReceiver;
    _desktopAgent;
    _glueController;
    _intentsController;
    _applicationController;
    _channelsBaseController;
    _legacyDataWrappingChannelsController;
    _newDataWrappingChannelsController;
    _channelsParser;
    _channelsStateStore;
    _channelsFactory;
    _fdc3;
    _eventsController;
    _applicationsStateStore;
    get ioc() {
        return this;
    }
    get eventReceiver() {
        if (!this._eventReceiver) {
            this._eventReceiver = new EventReceiver(this.glueController, this.eventDispatcher);
        }
        return this._eventReceiver;
    }
    get glueController() {
        if (!this._glueController) {
            this._glueController = new GlueController(this.channelsParser, this.channelsStateStore);
        }
        return this._glueController;
    }
    get fdc3() {
        if (!this._fdc3) {
            this._fdc3 = this.desktopAgent.toApi();
        }
        return this._fdc3;
    }
    get eventDispatcher() {
        if (!this._eventDispatcher) {
            this._eventDispatcher = new EventDispatcher();
        }
        return this._eventDispatcher;
    }
    get channelsFactory() {
        if (!this._channelsFactory) {
            this._channelsFactory = new ChannelsFactory(this.createUserChannel.bind(this), this.createAppChannel.bind(this), this.createPrivateChannel.bind(this));
        }
        return this._channelsFactory;
    }
    createUserChannel(glueChannel) {
        return new UserChannel(this.channelsBaseController, glueChannel).toApi();
    }
    createAppChannel(id) {
        return new AppChannel(this.channelsBaseController, id).toApi();
    }
    createPrivateChannel(logger, channelId, isCreator) {
        return new PrivateChannel(this.channelsBaseController, logger, channelId, isCreator);
    }
    get desktopAgent() {
        if (!this._desktopAgent) {
            this._desktopAgent = new DesktopAgent(this.intentsController, this.applicationController, this.channelsBaseController);
        }
        return this._desktopAgent;
    }
    get channelsParser() {
        if (!this._channelsParser) {
            this._channelsParser = new ChannelsParser();
        }
        return this._channelsParser;
    }
    get intentsController() {
        if (!this._intentsController) {
            this._intentsController = new IntentsController(this.glueController, this.channelsBaseController, this.channelsFactory, this.eventsController);
        }
        return this._intentsController;
    }
    get applicationController() {
        if (!this._applicationController) {
            this._applicationController = new ApplicationsController(this.glueController, this.applicationsStateStore, this.eventsController);
        }
        return this._applicationController;
    }
    get channelsBaseController() {
        if (!this._channelsBaseController) {
            this._channelsBaseController = new ChannelsBaseController(this.glueController, this.channelsStateStore, this.channelsParser, this.channelsFactory, this.eventsController, this.legacyDataWrappingChannelsController, this.ioFdc3SupportChannelsController);
        }
        return this._channelsBaseController;
    }
    get legacyDataWrappingChannelsController() {
        if (!this._legacyDataWrappingChannelsController) {
            this._legacyDataWrappingChannelsController = new LegacyDataWrappingChannelsController(this.channelsParser, this.glueController);
        }
        return this._legacyDataWrappingChannelsController;
    }
    get ioFdc3SupportChannelsController() {
        if (!this._newDataWrappingChannelsController) {
            this._newDataWrappingChannelsController = new NewDataWrappingChannelsController(this.channelsParser, this.glueController);
        }
        return this._newDataWrappingChannelsController;
    }
    get channelsStateStore() {
        if (!this._channelsStateStore) {
            this._channelsStateStore = new ChannelsStateStore();
        }
        return this._channelsStateStore;
    }
    get eventsController() {
        if (!this._eventsController) {
            this._eventsController = new GlueEventsController(this.glueController, this.channelsStateStore, this.applicationsStateStore);
        }
        return this._eventsController;
    }
    get applicationsStateStore() {
        if (!this._applicationsStateStore) {
            this._applicationsStateStore = new ApplicationsStateStore();
        }
        return this._applicationsStateStore;
    }
}

const fdc3Factory = () => {
    const ioc = new IoC();
    ioc.glueController.createGluePromise();
    ioc.eventReceiver.start();
    return ioc.fdc3;
};

var version = "2.5.0";

let globalFdc3 = window.fdc3;
window.fdc3Info = {
    provider: "io.Connect",
    providerVersion: version,
    standardVersion: "2.1"
};
if (typeof globalFdc3 === "undefined") {
    globalFdc3 = fdc3Factory();
    window.fdc3 = globalFdc3;
}
else {
    console.warn("Defaulting to using the auto-injected fdc3.");
}
var globalFdc3$1 = globalFdc3;

export { globalFdc3$1 as default };
//# sourceMappingURL=fdc3.es.js.map
